var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SearchData = /** @class */ (function () {
    function SearchData() {
    }
    return SearchData;
}());
//var PageSetup = PageSetup || {};
// Polyfill
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, length) {
        if (length === undefined || length > this.length) {
            length = this.length;
        }
        return this.substring(length - searchString.length, length) === searchString;
    };
}
;
var Page;
(function (Page) {
    var firstSearch = true;
    var searchResults = [];
    var pageUCLs = [];
    var isMobile = {
        iOS: function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i); },
    };
    var currentRequest = null;
    /*
     Access My Community functions
     */
    function InitAmcPage() {
        var mapName = arguments[0];
        var region = arguments[1];
        window.Search = {
            Location: null,
            LocationMarker: null,
            DefaultLatLng: null,
            Radius: 5,
            RegionID: region.RegionID,
            RegionType: region.RegionType,
            CentreLat: region.CentreLat,
            CentreLng: region.CentreLng,
            IsLoggedIn: arguments[2],
            ServicesShown: false,
            SettingsDone: false
        };
        window.AmcMarkers = {
            Locations: [],
            OpenData: []
        };
        if (region.CentreLat !== 0 && region.CentreLng !== 0) {
            window.Search.DefaultLatLng = new google.maps.LatLng(region.CentreLat, region.CentreLng);
        }
        initAmcMap(mapName);
        initAmcActions();
        //
        if (document.getElementById('autocomplete-location-new')) {
            McdMaps.setDefaultLocation(false, true);
            McdMaps.getResults('#autocomplete-location-new', false);
        }
        // 
        window.Search.RegionID = 0; // We use google maps
        if (window.Search.RegionID === 0) {
            var initAddress = $("#txtLocation").val();
            if (initAddress) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': initAddress
                }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        var place = results[0];
                        if (place.geometry.location) {
                            displayMyLocation(place.geometry.location, true);
                        }
                        else {
                            $('#cantFindYou').show();
                            if (place.geometry.viewport) {
                                window.MapView.fitBounds(place.geometry.viewport);
                            }
                        }
                    }
                });
            }
            else {
                if (mapName !== "#council-ucl-map") {
                    displayAndSetMyLocation(true);
                }
            }
        }
        else {
            getRegions(0, 0);
            $('#cantFindYou').hide();
            $(".txt-address-wrapper").hide();
            $(".txt-distance-wrapper").hide();
            $(".txt-buttons-wrapper").hide();
        }
        aria.Utils.AriaAlert("Unfortunately the map based search used in access my community is not properly supported by screen readers. We invite you to use the accessible features found in our standard search", 15);
    }
    Page.InitAmcPage = InitAmcPage;
    function initAmcMap(mapName) {
        var lat = $(mapName).data("lat");
        var lng = $(mapName).data("lng");
        var kml = $(mapName).data("kml") || '';
        window.MapView = createMapPanel(mapName, lat, lng, 12, false);
        if (window.Search.RegionID > 0 && kml) {
            window.KmlLayer = new google.maps.KmlLayer({
                url: kml,
                suppressInfoWindows: true,
                clickable: false,
                map: window.MapView
            });
        }
        window.InfoWindow = new google.maps.InfoWindow({});
        window.Geocoder = new google.maps.Geocoder();
        window.Search.Location = window.MapView.getCenter();
        window.Spiderfier = new OverlappingMarkerSpiderfier(window.MapView, {
            markersWontMove: true,
            markersWontHide: true
        });
        window.Clusterer = new MarkerClusterer(window.MapView, [], {
            gridSize: 50,
            maxZoom: 15,
            ignoreHidden: true
        });
        window.Spiderfier.addListener('click', function (marker) {
            showInfoWindow(marker.html, marker.getPosition(), true, marker.outlet);
        });
        var input = document.getElementById('txtLocation');
        if (input) {
            window.Autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: 'au'
                }
            });
            window.Autocomplete.bindTo("bounds", window.MapView);
            google.maps.event.addListener(window.Autocomplete, 'place_changed', function () {
                var place = window.Autocomplete.getPlace();
                if (!place.geometry) {
                    return;
                }
                if (place.geometry.location) {
                    displayMyLocation(place.geometry.location, true);
                }
                else {
                    $('#cantFindYou').show();
                    if (place.geometry.viewport) {
                        window.MapView.fitBounds(place.geometry.viewport);
                    }
                }
            });
        }
        var defAddress = document.getElementById('defAddress');
        if (defAddress) {
            var defComplete = new google.maps.places.Autocomplete(defAddress, {
                componentRestrictions: {
                    country: 'au'
                }
            });
            google.maps.event.addListener(defComplete, 'place_changed', function () {
                var place = defComplete.getPlace();
                //alert(place.formatted_address + ", " + place.geometry.location.lat() + ", " + place.geometry.location.lng());
                window.Search.DefaultLatLng = place.geometry.location;
            });
        }
        google.maps.event.addListener(window.MapView, 'click', function (event) {
            showInfo(event.latLng);
        });
        // Fired when the map stops moving, including the 'slide' effect after dragging.
        google.maps.event.addListener(window.MapView, 'idle', function () {
            checkIfAllMarkersVisible();
        });
        // Fired when the map is zoomed in or out
        google.maps.event.addListener(window.MapView, 'zoom_changed', function () {
            checkIfAllMarkersVisible();
        });
    }
    function initAmcActions() {
        resetAmcDisplay();
        setupSettings();
        if ($("#distanceSlider").length > 0) {
            $("#distanceSlider")
                .bootstrapSlider({
                value: 5,
                min: 1,
                max: 20,
                step: 1,
                tooltip: "hide"
            })
                .on('slide', function (e) {
                window.Search.Radius = e.value;
                $("#txtDistance").text(window.Search.Radius + 'km');
                showCircle(window.Search.Radius, window.Search.Location);
            })
                .on('click', function (e) {
                window.Search.Radius = e.value;
                $("#txtDistance").text(window.Search.Radius + 'km');
                showCircle(window.Search.Radius, window.Search.Location);
                refresh();
            })
                .on('slideStop', function (e) {
                refresh();
            });
        }
        $('.slider').on('click', function (e) {
            window.Search.Radius = $("#distanceSlider").val();
            $("#txtDistance").text(window.Search.Radius + 'km');
            showCircle(window.Search.Radius, window.Search.Location);
            refresh();
        });
        $('#btnRefine').on('click', function (e) {
            e.preventDefault();
            if (window.Search.IsLoggedIn) {
                if (!window.Search.ServicesShown) {
                    // Show sub categories
                    $('#categoryGroups').slideUp("slow");
                    $('#services').show("slow");
                    $(this).text('Hide Categories');
                    window.Search.ServicesShown = true;
                }
                else {
                    // Show main categories
                    $('#services').hide("slow");
                    $('#categoryGroups').slideDown("slow");
                    $(this).text('Refine Categories');
                    window.Search.ServicesShown = false;
                }
            }
        });
        $('form').bind("keypress", function (e) {
            if (e.keyCode === 13)
                return false;
            return true;
        });
        $('#allCategories').on('click', function (e) {
            var checked = $(this).prop("checked");
            toggleAllServicesOnMap(checked);
            $("input:checkbox[name='service']:visible").prop("checked", checked);
            aria.Utils.AriaAlert((checked ? "All" : "No") + " categories selected");
        });
        $("input:checkbox[name='service']").on('click', function (e) {
            toggleSingleServiceOnMap($(this).prop("checked"), $(this).val());
            setAllCategoriesChecked();
        });
        $('div.categoryButtons a').on('click', function (e) {
            e.preventDefault();
            var group = $(this).data('group');
            var src = $(this).children('img').attr('src');
            if (src.endsWith("_off.jpg")) {
                aria.Utils.AriaAlert("Loading categories...");
                src = src.replace("_off.jpg", ".jpg");
                // Ensure marker array is populated.
                loadCategoryGroup(group, true);
                setGroupDisplay(group, true);
            }
            else {
                src = src.replace(".jpg", "_off.jpg");
                hideCategoryGroupOnMap(group);
                setGroupDisplay(group, false);
            }
            $(this).children('img').attr('src', src);
        });
        $('#btnCurrentLocation').on('click', function (e) {
            e.preventDefault();
            displayAndSetMyLocation(false);
        });
        $("#geoDefault").on("click", function (e) {
            $("#defAddress").val('');
        });
        $("#defAddress").on("blur", function (e) {
            $("#geoDefault").prop("checked", false);
            $("#manDefault").prop("checked", true);
        });
        $("#btnSaveSettings").on("click", function (e) {
            e.preventDefault();
            if ($('#manDefault').is(':checked') && $("#defAddress").val() === '') {
                aria.Utils.AriaAlert("You must either use the geolocation service or enter an address to use! Press enter to close dialog.");
                setTimeout(function () { return alert('You must either use the geolocation service or enter an address to use!'); }, 500);
                return;
            }
            var address = $("#defAddress").val();
            setStoredValue(address);
            $("#settingsModal").modal('hide');
            displayAndSetMyLocation(false);
        });
        $("#btnCancelSettings").on("click", function (e) {
            e.preventDefault();
            setupSettings();
            $("#settingsModal").modal('hide');
        });
        $(document).on("click", "a.getDirections", function (e) {
            e.preventDefault();
            getDirections($(this).data("mode"), $(this).data("outletid"));
        });
        $(document).on("click", "a.setMyLocation", function (e) {
            e.preventDefault();
            setMyLocation();
        });
        $(".close-directions").on("click", function (e) {
            e.preventDefault();
            clearDirections();
            aria.Utils.AriaAlert("Map directions cleared");
        });
        $('div.openData a').click(function (e) {
            e.preventDefault();
            var type = $(this).data('type');
            var status = $(this).data('status');
            //var imgs = $('div.openData a img');
            if (!window.Search.IsLoggedIn) {
                // Only one open data item at a time for Public access.
                $('div.openData a').data('status', 'off');
                $(this).data('status', status === 'off' ? 'on' : 'off');
                // Hide the data on the map
                hideOpenDataOnMap('', this);
                // Set the image display
                $('div.openData a img').attr('src', function (index, e) {
                    return e.endsWith("_off.png") ? e : e.replace(".png", "_off.png");
                });
                if (status === 'off') {
                    $(this).children('img').attr('src', function (index, e) {
                        return e.replace("_off.png", ".png");
                    });
                    showOpenDataOnMap(type, this);
                }
            }
            else {
                // Set the Status property. 
                $(this).data('status', status === 'off' ? 'on' : 'off');
                var src = $(this).children('img').attr('src');
                if (status === 'off') {
                    src = src.replace("_off.png", ".png");
                    showOpenDataOnMap(type, this);
                }
                else {
                    src = src.replace(".png", "_off.png");
                    hideOpenDataOnMap(type, this);
                }
                $(this).children('img').attr('src', src);
            }
        });
    }
    function clearDirections() {
        $("#panelDirectionsFull").hide();
        $("#panelDirectionsEmpty").show();
        $(".opendata-loading").hide();
        if (window.DirectionsDisplay)
            window.DirectionsDisplay.setMap(null);
        if (window.InfoWindow)
            window.InfoWindow.close();
        if (!$("#panelServices").hasClass("in"))
            $("a[href='#panelServices']").click();
    }
    function resetAmcDisplay() {
        $("#panelDirectionsFull").hide();
        $("#panelDirectionsEmpty").show();
        showOpenDataSets([]);
        $('#services').hide();
        $('#btnRefine').hide();
        hideOpenDataOnMap('', null);
        window.AmcMarkers.Locations.length = 0;
        window.AmcMarkers.OpenData.length = 0;
        $('div.categoryButtons a').each(function () {
            var group = $(this).data('group');
            var src = $(this).children('img').attr('src');
            setGroupDisplay(group, false);
            if (!src.endsWith("_off.jpg")) {
                src = src.replace(".jpg", "_off.jpg");
                hideCategoryGroupOnMap(group);
                $(this).children('img').attr('src', src);
            }
        });
    }
    function setupSettings() {
        var def = getDefaultAddress();
        if (def === "geo") {
            $("#manDefault").prop("checked", false);
            $("#geoDefault").prop("checked", true);
            $("#defAddress").val("");
        }
        else if (def !== "") {
            $("#geoDefault").prop("checked", false);
            $("#manDefault").prop("checked", true);
            $("#defAddress").val(def);
        }
        else {
            $("#manDefault").prop("checked", false);
            $("#geoDefault").prop("checked", false);
            $("#defAddress").val("");
        }
        if (!navigator.geolocation) {
            $("#geoDefault").prop("checked", false);
            $("#geoDefault").prop('disabled', true);
        }
        window.Search.SettingsDone = true;
    }
    function showCircle(radius, posLatLng) {
        if (window.Circle)
            window.Circle.setMap(null);
        window.Circle = new google.maps.Circle({
            center: posLatLng,
            clickable: false,
            radius: radius * 1000,
            strokeColor: "#C0C0C0",
            strokeOpacity: 1,
            strokeWeight: 1,
            fillColor: "#C0C0C0",
            fillOpacity: 0.35,
            map: window.MapView
        });
        window.MapView.fitBounds(window.Circle.getBounds());
    }
    function showInfo(latLng) {
        var desc = '<div><strong>Your Destination</strong></div><div>';
        window.Geocoder.geocode({
            location: latLng
        }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                for (var i = 0; i < results.length; i++) {
                    if (results[i].types[0] === "street_address") {
                        showInfoWindow(desc + results[i].formatted_address + '</div>', latLng, true, 0);
                    }
                }
            }
        });
        showInfoWindow(desc + 'We were unable to correctly determine the address at the spot you chose.</div>', latLng, false, 0);
    }
    function showInfoWindow(description, latlng, allowedToRelocate, outletID) {
        if (window.InfoWindow)
            window.InfoWindow.close();
        window.InfoWindow = new google.maps.InfoWindow();
        description = '<div tabindex="0" role="region">' + description;
        if (allowedToRelocate)
            description += '<div style="margin-top: 15px;">' +
                '<a class="setMyLocation" tabindex="0">Set As My Location</a>  ' +
                '</div><div style="margin-top: 5px;">';
        else
            description += '<div style="margin-top: 15px;">';
        description += '<a class="getDirections btn btn-mini" data-mode="' + google.maps.TravelMode.DRIVING + '" data-outletid="' + outletID + '" title="Driving Directions" aria-label="Get driving directions from your location to this location" tabindex="0"><img src="https://mcdcdn.blob.core.windows.net/map-icons/dirDriving.png" alt="" /></a>  ' +
            '<a class="getDirections btn btn-mini" data-mode="' + google.maps.TravelMode.TRANSIT + '" data-outletid="' + outletID + '" title="Public Transport Directions" aria-label="Get public transport directions from your location to this location" tabindex="0"><img src="https://mcdcdn.blob.core.windows.net/map-icons/dirPublic.png" alt="" /></a>  ' +
            '<a class="getDirections btn btn-mini" data-mode="' + google.maps.TravelMode.WALKING + '" data-outletid="' + outletID + '" title="Walking Directions" aria-label="Get walking directions from your location to this location" tabindex="0"><img src="https://mcdcdn.blob.core.windows.net/map-icons/dirWalking.png" alt="" /></a>  ' +
            '<a class="getDirections btn btn-mini" data-mode="' + google.maps.TravelMode.BICYCLING + '" data-outletid="' + outletID + '" title="Bicycling Directions" aria-label="Get cycling directions from your location to this location" tabindex="0"><img src="https://mcdcdn.blob.core.windows.net/map-icons/dirCycling.png" alt="" /></a>  ' +
            '</div>';
        description += '</div>';
        window.InfoWindow.setContent(description);
        window.InfoWindow.setPosition(latlng);
        window.InfoWindow.open(window.MapView);
    }
    function getDirections(type, outletID) {
        if (!window.DirectionsDisplay) {
            window.DirectionsDisplay = new google.maps.DirectionsRenderer({
                draggable: true
            });
            window.DirectionsDisplay.setMap(window.MapView);
            window.DirectionsDisplay.setPanel(document.getElementById("directionsPanel"));
            window.DirectionsService = new google.maps.DirectionsService();
        }
        if (!window.Search.Location)
            window.Search.Location = window.MapView.getCenter();
        if (window.InfoWindow)
            window.InfoWindow.close();
        var request = {
            origin: window.Search.Location,
            destination: window.InfoWindow.getPosition(),
            travelMode: type
        };
        window.DirectionsDisplay.setMap(window.MapView);
        window.DirectionsService.route(request, function (result, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                $("a[href='#panelDirections']").click();
                $("#panelDirectionsFull").show();
                $("#panelDirectionsEmpty").hide();
                window.DirectionsDisplay.setDirections(result);
                function triggerAlert(e) {
                    e.preventDefault();
                    aria.Utils.AriaAlert("A new page will open for printing. For best result please ensure you enable Background images and colours if available. Once you have printed you may close the new page. Press enter to close the dialog");
                    setTimeout(function () {
                        alert('A new page will open for printing. For best result please ensure you enable Background images and colours if available. Once you have printed you may close the new page.');
                        window.open($(e.target).attr("href"));
                    }, 500);
                }
                $(".print-directions").off("click touchend").on("click touchend", function (e) {
                    triggerAlert(e);
                });
                $(".print-directions").off("keyup").on("keyup", function (e) {
                    if (e.which === 13) {
                        triggerAlert(e);
                    }
                });
                $(".print-directions").attr("href", "/Directory/PrintDirections.aspx?lat1=" + request.origin.lat() + "&lng1=" + request.origin.lng() + "&lat2=" + request.destination.lat() + "&lng2=" + request.destination.lng() + "&mode=" + type + "&outlet=" + outletID);
            }
        });
    }
    function setMyLocation() {
        displayMyLocation(window.InfoWindow.getPosition(), false);
        if (window.InfoWindow)
            window.InfoWindow.close();
    }
    function showOpenDataSets(regions) {
        //Hide all the openData datasets and then show only nationwide
        $('div.openData a').hide();
        $('div.openData h6').hide();
        // Nationwide datasets
        $('div.openData a.region0, div.openData h6.region0').show();
        //var ids = councilId.toString().split(',');
        for (var i = 0; i < regions.length; i++) {
            // Region datasets
            var region = regions[i];
            $('div.openData a.region' + region.GeographyID).show();
            $('div.openData h6.region' + region.GeographyID).show();
        }
    }
    function getDefaultAddress() {
        if (window.Search.RegionID > 0) {
            window.Search.DefaultLatLng = new google.maps.LatLng(window.Search.CentreLat, window.Search.CentreLng);
            return "region";
        }
        var value = getStoredValue();
        if (value === "geo") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    window.Search.DefaultLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                });
            }
            return value;
        }
        else {
            var vals = value.split("|");
            window.Search.DefaultLatLng = window.MapView.getCenter();
            if (vals.length === 3) {
                window.Search.DefaultLatLng = new google.maps.LatLng(parseFloat(vals[1]), parseFloat(vals[2]));
            }
            return vals[0];
        }
    }
    function displayAndSetMyLocation(refreshMarkers) {
        if (window.Search.DefaultLatLng) {
            displayMyLocation(window.Search.DefaultLatLng, refreshMarkers);
        }
        else {
            var addr = getDefaultAddress();
            if (addr === "geo") {
                navigator.geolocation.getCurrentPosition(function (position) {
                    displayMyLocation(new google.maps.LatLng(position.coords.latitude, position.coords.longitude), refreshMarkers);
                }, function () {
                    if (!window.Search.SettingsDone)
                        setupSettings();
                    $("#settingsModal").modal('show');
                });
            }
            else if (addr === "") {
                if (!window.Search.SettingsDone)
                    setupSettings();
                $("#settingsModal").modal('show');
            }
            else {
                displayMyLocation(window.Search.DefaultLatLng, refreshMarkers);
            }
        }
    }
    function displayMyLocation(latLng, refreshMarkers, infoWindowContent) {
        window.MapView.setCenter(latLng);
        window.Search.Location = latLng;
        $(".region-limitation-text").hide();
        window.Search.RegionID = 0;
        if (window.Search.LocationMarker) {
            window.Search.LocationMarker.setMap(null);
            window.Search.LocationMarker = null;
        }
        var myLocationMarker = new google.maps.Marker({
            position: latLng,
            map: window.MapView,
            clickable: false,
            //icon: "/_static/images/map_marker.png",
            visible: true,
        });
        if (infoWindowContent) {
            myLocationMarker.addListener('click', function () {
                window.InfoWindow.setContent(infoWindowContent);
                window.InfoWindow.open(window.MapView, myLocationMarker);
                // Remove "Close" button of the info window on hover
                // https://stackoverflow.com/questions/55432957/remove-the-close-title-attribute-from-google-maps-custom-markers-infowindow
                google.maps.event.addListener(window.InfoWindow, 'domready', function () {
                    jQuery(".gm-ui-hover-effect").attr('title', '');
                });
            });
        }
        window.Search.LocationMarker = myLocationMarker;
        if (refreshMarkers)
            refresh();
        //showCircle(window.Search.Radius, window.Search.Location);
        var locationLatLng = {
            location: latLng
        };
        window.Geocoder.geocode(locationLatLng, function (results, status) {
            $('#cantFindYou').hide();
            if (status === google.maps.GeocoderStatus.OK) {
                $('#txtLocation').val(results[0].formatted_address);
                getRegions(latLng.lat(), latLng.lng());
            }
            else {
                $('#cantFindYou').show();
                $('#txtLocation').focus();
            }
        });
    }
    function hideCategoryGroupOnMap(group) {
        var markers = [];
        var allVisible = true;
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (group === '' || value.Group === group) {
                markers.push(value.Marker);
                value.Marker.setVisible(false);
            }
            else {
                if (value.Marker.getVisible()) {
                    var currentBounds = window.MapView.getBounds();
                    if (!currentBounds.contains(value.Marker.getPosition())) {
                        allVisible = false;
                    }
                }
            }
        });
        if (!allVisible)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
        window.Clusterer.removeMarkers(markers);
    }
    function setGroupDisplay(group, turnOn) {
        var grpSel = "[data-group='" + group + "']";
        if (turnOn) {
            $("div" + grpSel).show();
            $("input" + grpSel).prop("checked", true);
            $("input" + grpSel).data("status", "on");
            $(".categoryButtons " + grpSel + " span.badge").show();
            if (window.Search.IsLoggedIn) {
                $('#btnRefine').show();
                aria.Utils.AriaAlert("You can further refine your selection by navigating to the end of this panel");
            }
        }
        else {
            $("input" + grpSel).prop("checked", false);
            $("input" + grpSel).data("status", "off");
            $("div" + grpSel).hide();
            $(".categoryButtons " + grpSel + " span.badge").hide();
            $(".categoryButtons " + grpSel + " span.status").html("0 shown.");
            if (window.Search.IsLoggedIn) {
                var n = $("input[name='service']:checkbox:checked").length;
                if (n === 0) {
                    $('#btnRefine').hide();
                }
                else {
                    $('#btnRefine').show();
                    aria.Utils.AriaAlert("You can further refine your selection by navigating to the end of this panel", null, null, "status");
                }
            }
        }
        setAllCategoriesChecked();
    }
    function loadCategoryGroup(group, showAll) {
        // Check to see if the group's categories are loaded in the array
        var found = false;
        var hideMarkers = [];
        var showMarkers = [];
        var allVisible = true;
        var currentBounds;
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (value.Group === group) {
                if (showAll) {
                    showMarkers.push(value.Marker);
                    value.Marker.setVisible(true);
                    currentBounds = window.MapView.getBounds();
                    if (!currentBounds.contains(value.Marker.getPosition())) {
                        allVisible = false;
                    }
                }
                else {
                    if ($("#services input[class~='category" + value.CategoryGroupID + "']:checked").length === 1) {
                        showMarkers.push(value.Marker);
                        value.Marker.setVisible(true);
                        currentBounds = window.MapView.getBounds();
                        if (!currentBounds.contains(value.Marker.getPosition())) {
                            allVisible = false;
                        }
                    }
                    else {
                        hideMarkers.push(value.Marker);
                        value.Marker.setVisible(false);
                    }
                }
                found = true;
            }
        });
        if (!allVisible && showMarkers.length > 0)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
        window.Clusterer.removeMarkers(hideMarkers);
        window.Clusterer.addMarkers(showMarkers);
        showGroupCount(group);
        if (found)
            return;
        // Not loaded so go and get them
        var selectedValues = loadCategoriesList(group);
        getOutlets(group, selectedValues, showAll);
    }
    function showGroupCount(group) {
        var numberShown = 0;
        $("input[data-group='" + group + "'] ~ span.label").text("0");
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (value.Group === group) {
                numberShown++;
                var catCountLabel = $("input[data-catgrp='" + value.CategoryGroupID + "'] ~ span.label");
                catCountLabel.text(parseInt(catCountLabel.text()) + 1);
                $(".categoryButtons [data-group='" + group + "'] span.badge").html(numberShown.toString());
                $(".categoryButtons [data-group='" + group + "'] span.status").html(numberShown + " found.");
            }
        });
        $(".categoryButtons [data-group='" + group + "'] span.badge").html(numberShown.toString());
        $(".categoryButtons [data-group='" + group + "'] span.status").html(numberShown + " found.");
    }
    function loadCategoriesList(group) {
        var $checkedCheckboxes = $("input[data-group='" + group + "']");
        var selectedValues = "";
        $checkedCheckboxes.each(function () {
            selectedValues += $(this).data("catgrp") + ",";
        });
        return selectedValues;
    }
    function addMarkers(group, list, showAll) {
        var marker, i, latlng;
        var bounds = new google.maps.LatLngBounds();
        $("#dvLoading").show();
        var allVisible = true;
        for (i = 0; i < list.length; i++) {
            latlng = new google.maps.LatLng(list[i].Lat, list[i].Lng);
            marker = new google.maps.Marker({
                position: latlng,
                map: ($("input[data-catgrp='" + list[i].CategoryGroupID + "']:checked").length === 1) ? window.MapView : null,
                title: list[i].Name,
                html: list[i].Html,
                animation: google.maps.Animation.DROP,
                outlet: list[i].OutletID,
                icon: 'https://mcdcdn.blob.core.windows.net/map-icons/service' + list[i].CategoryGroupID + '.png'
            });
            bounds.extend(latlng);
            window.AmcMarkers.Locations.push({
                Group: group,
                CategoryGroupID: list[i].CategoryGroupID,
                Marker: marker
            });
            if (window.Spiderfier)
                window.Spiderfier.addMarker(marker);
            if (window.Clusterer)
                window.Clusterer.addMarker(marker, false);
            var point = new google.maps.LatLng(parseFloat(list[i].Lat), parseFloat(list[i].Lng));
            var currentBounds = window.MapView.getBounds();
            if (!currentBounds.contains(point)) {
                allVisible = false;
            }
        }
        if (!allVisible)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
        showGroupCount(group);
        $("#dvLoading").fadeOut(300);
    }
    function refresh() {
        //window.Clusterer.clearMap();
        window.Clusterer.clearMarkers();
        // First we get the groups currently displayed
        var groups = [];
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if ($.inArray(value.Group, groups) === -1) {
                if (value.Marker.getVisible()) {
                    hideCategoryGroupOnMap(value.Group);
                    groups.push(value.Group);
                }
            }
        });
        // Remove outlets from the display and the array and reget them
        window.AmcMarkers.Locations.length = 0;
        $.each(groups, function (index, value) {
            loadCategoryGroup(value, false);
        });
        // Remove openData from the display and the array and reget them
        hideOpenDataOnMap('', null);
        window.AmcMarkers.OpenData.length = 0;
        $('div.openData a').each(function () {
            if ($(this).data("status") === "on")
                showOpenDataOnMap($(this).data('type'), this);
        });
        if (window.Spiderfier)
            window.Spiderfier.unspiderfy();
        clearDirections();
        getRegions(window.Search.Location.lat(), window.Search.Location.lng());
    }
    function refreshMarkers() {
        //window.Clusterer.clearMap();
        window.Clusterer.clearMarkers();
        // First we get the groups currently displayed
        var groups = [];
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if ($.inArray(value.Group, groups) === -1) {
                if (value.Marker.getVisible()) {
                    hideCategoryGroupOnMap(value.Group);
                    groups.push(value.Group);
                }
            }
        });
        // Remove outlets from the display and the array and reget them
        window.AmcMarkers.Locations.length = 0;
        $.each(groups, function (index, value) {
            loadCategoryGroup(value, false);
        });
        // Remove openData from the display and the array and reget them
        hideOpenDataOnMap('', null);
        window.AmcMarkers.OpenData.length = 0;
        $('div.openData a').each(function () {
            if ($(this).data("status") === "on")
                showOpenDataOnMap($(this).data('type'), this);
        });
        if (window.Spiderfier)
            window.Spiderfier.unspiderfy();
        clearDirections();
        getRegions(window.Search.Location.lat(), window.Search.Location.lng());
    }
    Page.refreshMarkers = refreshMarkers;
    function toggleSingleServiceOnMap(turnOn, categoryGroupId) {
        var hideMarkers = [];
        var showMarkers = [];
        var allVisible = true;
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (value.CategoryGroupID.toString() === categoryGroupId) {
                if (turnOn) {
                    value.Marker.setVisible(true);
                    showMarkers.push(value.Marker);
                    var currentBounds = window.MapView.getBounds();
                    if (!currentBounds.contains(value.Marker.getPosition())) {
                        allVisible = false;
                    }
                }
                else {
                    value.Marker.setVisible(false);
                    hideMarkers.push(value.Marker);
                }
            }
        });
        window.Clusterer.removeMarkers(hideMarkers);
        window.Clusterer.addMarkers(showMarkers);
        if (!allVisible && showMarkers.length > 0)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
        var valLabel = $("input[data-catgrp='" + categoryGroupId + "'] ~ span.label");
        var val = parseInt(valLabel.text());
        var totalLabel = $(".categoryButtons [data-group='" + $("input[data-catgrp='" + categoryGroupId + "']").data("group") + "'] span.badge");
        var total = parseInt(totalLabel.text());
        if (turnOn) {
            totalLabel.text(total + val);
        }
        else {
            totalLabel.text(total - val);
        }
    }
    function toggleAllServicesOnMap(turnOn) {
        $("#services input:checkbox:visible").each(function (i, obj) {
            $(".categoryButtons [data-group='" + $(obj).data("group") + "'] span.badge").text("0");
        });
        var hideMarkers = [];
        var showMarkers = [];
        var allVisible = true;
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (turnOn) {
                // if markers are already visible do not add again
                if (!value.Marker.setVisible) {
                    value.Marker.setVisible(true);
                    showMarkers.push(value.Marker);
                }
                var totalObj = $(".categoryButtons [data-group='" + value.Group + "'] span.badge");
                totalObj.text(parseInt(totalObj.text()) + 1);
                var currentBounds = window.MapView.getBounds();
                if (!currentBounds.contains(value.Marker.getPosition())) {
                    allVisible = false;
                }
            }
            else {
                value.Marker.setVisible(false);
                hideMarkers.push(value.Marker);
            }
        });
        window.Clusterer.removeMarkers(hideMarkers);
        window.Clusterer.addMarkers(showMarkers);
        if (!allVisible && showMarkers.length > 0)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
    }
    function checkIfAllMarkersVisible() {
        var allVisible = true;
        $.each(window.AmcMarkers.Locations, function (index, value) {
            if (value.Marker.getVisible()) {
                var currentBounds = window.MapView.getBounds();
                if (!currentBounds.contains(value.Marker.getPosition())) {
                    allVisible = false;
                }
            }
        });
        if (!allVisible)
            alertNotAllMarkersVisible();
        else
            hideAlertMarkersVisible();
    }
    function alertNotAllMarkersVisible() {
        // Show alert that there are markers outside the visible area on the map
        //$("#divAlertNotVisible").show();
    }
    function hideAlertMarkersVisible() {
        // Hide alert that there are markers outside the visible area on the map
        //$("#divAlertNotVisible").hide();
    }
    function setAllCategoriesChecked() {
        var vis = 0;
        $("input[data-status]").each(function () {
            if ($(this).data("status") === "on")
                vis++;
        });
        var checked = $("input[name='service']:checked").length;
        var set = (vis === checked);
        $("#allCategories").prop("checked", set);
    }
    function hideOpenDataOnMap(type, element) {
        if (element) {
            $(element).attr("aria-pressed", "false");
        }
        else {
            $("div.openData a").attr("aria-pressed", "false");
        }
        $.each(window.AmcMarkers.OpenData, function (index, value) {
            if (type === '' || value.Type === type)
                value.Marker.setMap(null);
        });
    }
    function showOpenDataOnMap(type, element) {
        $(element).attr("aria-pressed", "true");
        var found = false;
        $.each(window.AmcMarkers.OpenData, function (index, value) {
            if (value.Type === type) {
                value.Marker.setMap(window.MapView);
                found = true;
            }
        });
        if (!found)
            getOpenData(type);
    }
    function getRegions(lat, lng) {
        if (window.Search.RegionID === 0) {
            $.getJSON("/api/amc/getregionsbypoint/" + lat + "/" + lng + "/" + window.Search.Radius, function (data) {
                showOpenDataSets(data);
            });
        }
        else {
            $.getJSON("/api/amc/getregionsbyregion/" + window.Search.RegionID, function (data) {
                showOpenDataSets(data);
            });
        }
    }
    function getOutlets(group, selectedValues, showAll) {
        if (!window.Search.Location)
            window.Search.Location = window.MapView.getCenter();
        if (parseInt(window.Search.Radius) === 0)
            window.Search.Radius = 1;
        $(".categoryButtons [data-group='" + group + "'] span.badge").html('<img src="/_static/images/processing.gif" />');
        $.getJSON("/api/amc/getoutlets/" + window.Search.Location.lat() + "/" + window.Search.Location.lng() + "/" + window.Search.Radius + "/" + window.Search.RegionID + "/" + window.Search.RegionType + "/" + selectedValues, function (data) {
            addMarkers(group, data, showAll);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            $(".categoryButtons [data-group='" + group + "'] span.badge").html('');
        });
    }
    function getOpenData(type) {
        $(".opendata-loading").show();
        $.getJSON("/api/amc/getopendata/" + window.Search.Location.lat() +
            "/" + window.Search.Location.lng() +
            "/" + window.Search.Radius +
            "/" + type +
            "/" + window.Search.RegionType +
            "/" + window.Search.RegionID, function (data) {
            addOpenDataMarkersToArray(type, data);
        })
            .always(function () {
            $(".opendata-loading").hide();
        });
    }
    function addOpenDataMarkersToArray(type, list) {
        var marker, i, latlng;
        var bounds = new google.maps.LatLngBounds();
        $("#dvLoading").show();
        for (i = 0; i < list.length; i++) {
            latlng = new google.maps.LatLng(list[i].Lat, list[i].Lng);
            var iconUrl = list[i].MarkerIcon;
            if (!iconUrl || iconUrl === '')
                iconUrl = 'https://mcdcdn.blob.core.windows.net/map-icons/' + type + '.png';
            var html = list[i].Html;
            if (list[i].ItemURL && list[i].ItemURL !== '')
                html += "<div><a href='" + list[i].ItemURL + "' target='_blank' title='Find Out More About This Location'>More Info</a></div>";
            marker = new google.maps.Marker({
                position: latlng,
                map: window.MapView,
                title: list[i].Name,
                html: html,
                animation: google.maps.Animation.DROP,
                icon: iconUrl
            });
            bounds.extend(latlng);
            google.maps.event.addListener(marker, "click", function (event) {
                showInfoWindow(this.html, this.getPosition(), true, 0);
            });
            window.AmcMarkers.OpenData.push({
                Type: type,
                Marker: marker
            });
        }
        $("#dvLoading").fadeOut(500);
    }
    function getStoredValue() {
        var def = "geo";
        var key = 'AMCHomeAddress';
        if (typeof (Storage) !== "undefined") {
            def = localStorage.getItem(key);
        }
        else {
            def = $.cookie(key);
        }
        if (!def) {
            def = "geo";
        }
        if (def === "geo") {
            return navigator.geolocation ? def : "";
        }
        return def;
    }
    function setStoredValue(setting) {
        var key = 'AMCHomeAddress';
        var value = setting;
        if (value !== "geo" && value !== "" && window.Search.DefaultLatLng)
            value += "|" + window.Search.DefaultLatLng.lat() + "|" + window.Search.DefaultLatLng.lng();
        if (typeof (Storage) !== "undefined")
            localStorage.setItem(key, value);
        else
            $.cookie(key, value);
    }
    /**************************************/
    /* My Community Info Hub              */
    /**************************************/
    function debounce(func, wait) {
        var timeout;
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timeout);
            timeout = setTimeout(function () { return func.apply(_this, args); }, wait);
        };
    }
    function SetupLocateMeBtn($btnLocator, $btnClearInput, $addressInput, $btnGo) {
        if (isMobile.iOS()) {
            $btnLocator.css("content", "url(/_static/static-page-assets/images/icons/search-ios.svg)");
        }
        else {
            $btnLocator.css("content", "url(/_static/static-page-assets/images/icons/search.svg)");
        }
        $btnLocator.off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            navigator.geolocation.getCurrentPosition(function (position) {
                var latitude = position.coords.latitude;
                var longitude = position.coords.longitude;
                // Use Google Maps API to reverse geocode the coordinates
                var geocoder = new google.maps.Geocoder();
                var latLng = { lat: latitude, lng: longitude };
                geocoder.geocode({ 'location': latLng }, function (results, status) {
                    if (status === 'OK' && results[0]) {
                        var address = results[0].formatted_address;
                        $addressInput.val(address);
                        $btnGo.siblings('input[name="displayName"]').val(address);
                        $btnGo.siblings('input[name="lat"]').val(latitude);
                        $btnGo.siblings('input[name="lng"]').val(longitude);
                        $btnGo.siblings('input[name="locationType"]').val('point');
                        $btnLocator.hide();
                        $btnClearInput.show();
                    }
                    else {
                        console.error('Geocoder failed due to: ' + status);
                    }
                });
            }, function (error) {
                console.error('Error occurred: ' + error.message);
            });
        });
    }
    function InitSelectPicker() {
        $('#categorySelect').selectpicker();
        $('#categorySelect').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            // Get the value of the option that was clicked
            var clickedValue = $(this).find('option').eq(clickedIndex).val();
            // If the empty value option was selected, deselect all others
            if (clickedValue === '' && isSelected) {
                $(this).find('option').each(function () {
                    if ($(this).val() !== '') {
                        $(this).prop('selected', false);
                    }
                });
            }
            // If any other option was selected, deselect the empty value option
            else if (clickedValue !== '' && isSelected) {
                $(this).find('option[value=""]').prop('selected', false);
            }
            // Refresh the selectpicker to reflect changes
            $(this).selectpicker('refresh');
        });
    }
    function InitCommunityHub(displayAddress, geographyId, lat, lng, regionId, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            function handleAnchorChange() {
                var queryString = window.location.search;
                var urlParams = new URLSearchParams(queryString);
                var currentHash = "#" + urlParams.get('ucl');
                if ($(currentHash)[0] != null) {
                    var wrapper = $(currentHash).parent();
                    var destCoord = wrapper.find("input[name='DestinationCoordinate']").val().split(',');
                    var destObj = {
                        lat: parseFloat(destCoord[0]),
                        long: parseFloat(destCoord[1])
                    };
                    $(".list-item").removeClass('selected');
                    if ($(currentHash).hasClass('selected')) {
                        DisplayDirectoryServiceMarkers(results.services);
                        $(currentHash).removeClass('selected');
                        $(".info-council-wrapper>.ucl-info-card").toggleClass("display-none col-md-5");
                        $(".info-council-wrapper>#council-ucl-map").toggleClass("col-md-12 col-md-7");
                        if ($('#info-card-coord')) {
                            if (pageUCLs.length > 0) {
                                GetDefaultUCLsMarkers(pageUCLs);
                            }
                        }
                        if (window.matchMedia("(max-width: 768px)").matches) {
                            $('.mobile-ucl-info').hide();
                        }
                    }
                    else {
                        $(currentHash).addClass('selected');
                        $('.ucl-info-card-title').html(wrapper.find("input[name='DisplayTitle']").val());
                        $('#info-card-url').val(wrapper.find("input[name='URL']").val());
                        $('#info-card-coord').val(wrapper.find("input[name='DestinationCoordinate']").val());
                        $('#info-card-displayName').val(wrapper.find("input[name='DisplayTitle']").val());
                        if (window.matchMedia("(max-width: 768px)").matches) {
                            $('.mobile-ucl-info').show();
                        }
                        if ($('#info-card-coord')[0]) {
                            $(".ucl-info-card-description").text("");
                            window.MapView.panTo(new google.maps.LatLng(destObj.lat, destObj.long));
                            window.MapView.setZoom(13);
                            getUCLDescriptions(wrapper.find("input[name='GeographyMapId']").val(), wrapper.find("input[name='CouncilRegionID']").val());
                        }
                        if ($(".info-council-wrapper>.ucl-info-card").hasClass("display-none") || $(".info-council-wrapper>#council-ucl-map").hasClass("col-md-12")) {
                            $(".info-council-wrapper>.ucl-info-card").removeClass("display-none");
                            $(".info-council-wrapper>.ucl-info-card").addClass("col-md-5");
                            $(".info-council-wrapper>#council-ucl-map").removeClass("col-md-12");
                            $(".info-council-wrapper>#council-ucl-map").addClass("col-md-7");
                        }
                        /* $(".info-council-wrapper>.ucl-info-card").toggleClass("");*/
                        //$(".info-council-wrapper>#council-ucl-map").toggleClass("col-md-12 col-md-7");
                    }
                }
            }
            function RedirectToAnotherInfoHub($btnGoto) {
                $locationSelectorModal.modal('hide');
                $('#page-backdrop').fadeIn(150);
                $btnGoto.html('<div class="loader-small"></div>');
                $btnGoto.prop("disabled", true);
                var lat = $btnGoto.siblings('input[name="lat"]').val();
                var lng = $btnGoto.siblings('input[name="lng"]').val();
                // Need $btnGoto so we can get data about the location from its siblings
                // assuming we are dealing with the same structure
                var data = JSON.stringify({
                    "Url": $btnGoto.siblings('input[name="url"]').val(),
                    "DisplayName": $btnGoto.siblings('input[name="displayName"]').val(),
                    "LocationType": $btnGoto.siblings('input[name="locationType"]').val(),
                    "Lat": lat,
                    "Lng": lng,
                    "CouncilID": $btnGoto.siblings('input[name="councilId"]').val(),
                    "LocationID": $btnGoto.siblings('input[name="locationId"]').val()
                });
                $.ajax({
                    url: "/StoreSearchedModelInSession",
                    type: "POST",
                    contentType: "application/json",
                    dataType: "json",
                    data: data,
                    error: function (result) {
                        // Display a general error message to the user
                        alert("Sorry, there was a problem processing your request. Please try again later.");
                        console.error("AJAX error in request: " + result.responseText);
                    },
                    success: function (r) {
                    },
                    complete: function () {
                        $.ajax({
                            type: "POST",
                            url: "/Redirect/ToCommunityInfoHub",
                            contentType: "application/json",
                            dataType: "json",
                            data: JSON.stringify({ lat: lat, lng: lng }),
                            success: function (res) {
                                if (res && res.URL && res.URL.length > 0) {
                                    window.location.href = res.URL;
                                }
                            },
                            error: function () {
                                console.error("Error getting redirect url.");
                            },
                            complete: function () { }
                        });
                    }
                });
            }
            function hideAddressSuggestions_mobile() {
                $addressSuggestions_mobile.addClass('hidden');
                $navBackdrop_mobile.hide();
                $addressInput_mobile.val($btnGoToAddress_mobile.siblings('input[name="displayName"]').val());
            }
            /**
             * Fetch function used for mobile view.
             *
             * @param $addressInput
             * @param $btnGoToAddress
             * @param $btnLocateMe
             * @param $btnClearAddress
             * @param $addressSuggestions
             * @param $backdrop
             */
            function FetchLocation_mobile($addressInput, $btnGoToAddress, $btnLocateMe, $btnClearAddress, $addressSuggestions, $backdrop) {
                $addressInput.on('input', debounce(function () {
                    var value = $addressInput.val();
                    if (value.length == 0) {
                        $addressInput.val($btnGoToAddress.siblings('input[name="displayName"]').val());
                        return;
                    }
                    if (value.length > 0) {
                        $btnLocateMe.hide();
                        $btnClearAddress.show();
                    }
                    else {
                        $btnLocateMe.show();
                        $btnClearAddress.hide();
                        $addressSuggestions.empty();
                        if (!$addressSuggestions.hasClass('hidden')) {
                            $addressSuggestions.addClass('hidden');
                            $backdrop.hide(); // Disable backdrop
                        }
                        return;
                    }
                    if (value.length >= 3) {
                        // Send the AJAX request
                        $.ajax({
                            url: window.AppSettings.ApiUrl + "/api/v1/system/councils/searchall/" + value,
                            type: 'GET',
                            beforeSend: function () {
                                $addressSuggestions.empty();
                                if ($addressSuggestions.hasClass('hidden')) {
                                    $addressSuggestions.removeClass('hidden');
                                    $backdrop.show(); // Enable backdrop
                                }
                            },
                            success: function (response) {
                                if (response && response.length > 0) {
                                    var maxItems = Math.min(10, response.length); // Maximum of 10 suggestions will be displayed
                                    var _loop_1 = function (i) {
                                        var item = response[i];
                                        li = document.createElement("li");
                                        div = document.createElement("div");
                                        inputValue = $addressInput.val();
                                        escapedInput = inputValue.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                                        pattern = new RegExp(escapedInput, 'ig');
                                        name = item.DisplayName.replace(pattern, function (match) {
                                            return '<strong>' + match + '</strong>';
                                        });
                                        icon = document.createElement("div");
                                        li.classList.add("suggestions-item");
                                        li.appendChild(div);
                                        div.classList.add("suggestion-title");
                                        div.innerHTML = name;
                                        li.insertBefore(icon, div);
                                        icon.classList.add("suggestion-icon");
                                        icon.style.backgroundImage = item.LocationType.toUpperCase() == "LGA" ? "url('/_static/static-page-assets/images/icons/lga_icons.png')" : "url('/_static/static-page-assets/images/icons/pin_icons.png')";
                                        li.addEventListener('click', function () {
                                            $addressSuggestions.empty();
                                            $addressSuggestions.addClass('hidden');
                                            $backdrop.hide(); // Disable backdrop
                                            $addressInput.val(item.DisplayName);
                                            $btnGoToAddress.siblings('input[name="url"]').val(item.Url);
                                            $btnGoToAddress.siblings('input[name="displayName"]').val(item.DisplayName);
                                            $btnGoToAddress.siblings('input[name="lat"]').val(item.Lat);
                                            $btnGoToAddress.siblings('input[name="lng"]').val(item.Lng);
                                            $btnGoToAddress.siblings('input[name="locationType"]').val(item.LocationType);
                                            $btnGoToAddress.siblings('input[name="councilId"]').val(item.CouncilID);
                                            $btnGoToAddress.siblings('input[name="locationId"]').val(item.LocationID);
                                        });
                                        $addressSuggestions.append(li);
                                    };
                                    var li, div, inputValue, escapedInput, pattern, name, icon;
                                    for (var i = 0; i < maxItems; i++) {
                                        _loop_1(i);
                                    }
                                    ;
                                }
                            },
                            error: function (error) {
                                console.error(error);
                            }
                        });
                    }
                }, 250));
            }
            // Utility functions
            function ResetLocationToDefault($btnGoto) {
                $btnGoto.siblings('input[name="displayName"]').val(defaultLocation.DisplayName);
                $btnGoto.siblings('input[name="lat"]').val(defaultLocation.Lat);
                $btnGoto.siblings('input[name="lng"]').val(defaultLocation.Lng);
                $btnGoto.siblings('input[name="locationType"]').val(defaultLocation.LocationType);
                $btnGoto.siblings('input[name="url"]').val(defaultLocation.Url);
                $btnGoto.siblings('input[name="locationId"]').val(defaultLocation.LocationID);
                $btnGoto.siblings('input[name="councilId"]').val(defaultLocation.CouncilID);
            }
            var $mobileNav, $burgerMenu, $btnToggleBurgerMenu, $btnGoToAddress_mobile, $addressSuggestions, $btnLocateMe, $btnClearAddress, $btnGoToAddress, $addressInput, $locationSelectorModal, defaultLocation, addressLocationSelected, $addressInput_mobile, $addressSuggestions_mobile, $btnLocateMe_mobile, $btnClearAddress_mobile, $navBackdrop_mobile, $getHelp_1, $getInvolved_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.addEventListener("load", handleAnchorChange);
                        window.addEventListener("hashchange", handleAnchorChange);
                        $mobileNav = $('#mobile-nav');
                        $burgerMenu = $mobileNav.find('.burger-menu');
                        $btnToggleBurgerMenu = $mobileNav.find('#btn-burger-menu');
                        $btnGoToAddress_mobile = $mobileNav.find('#goto-mobile');
                        $addressSuggestions = $('#address-suggestion-list');
                        $btnLocateMe = $('#locator-button');
                        $btnClearAddress = $('#clear-address-button');
                        $btnGoToAddress = $('#go-button');
                        $addressInput = $('#address-input');
                        $locationSelectorModal = $('#councilModal');
                        defaultLocation = {
                            Url: $btnGoToAddress.siblings('input[name="url"]').val(),
                            DisplayName: $btnGoToAddress.siblings('input[name="displayName"]').val(),
                            Lat: $btnGoToAddress.siblings('input[name="lat"]').val(),
                            Lng: $btnGoToAddress.siblings('input[name="lng"]').val(),
                            LocationType: $btnGoToAddress.siblings('input[name="locationType"]').val(),
                            CouncilID: $btnGoToAddress.siblings('input[name="councilId"]').val(),
                            LocationID: $btnGoToAddress.siblings('input[name="locationId"]').val(),
                        };
                        if (defaultLocation.CouncilID > 0) {
                            window.Spiderfier = new OverlappingMarkerSpiderfier(window.MapView, {
                                markersWontMove: true,
                                markersWontHide: true,
                                keepSpiderfied: true
                            });
                            window.Spiderfier.removeListener('click');
                        }
                        $('.visit-btn').on('click', function () {
                            if ($("#nearby-communities li[id^='community-'] .nearby-community-item").hasClass("selected")) {
                                var destCoord = $("#info-card-coord").val().split(',');
                                var destObj = {
                                    lat: parseFloat(destCoord[0]),
                                    long: parseFloat(destCoord[1])
                                };
                                var title = $("#info-card-displayName").val();
                                var url = $("#info-card-url").val();
                                var data = JSON.stringify({
                                    "DisplayName": title,
                                    "Lat": destObj.lat,
                                    "Lng": destObj.long,
                                    "LocationType": 'point',
                                    "Url": url,
                                    "CouncilID": 0,
                                    "LocationID": 0
                                });
                                $.ajax({
                                    url: "/StoreSearchedModelInSession",
                                    type: "POST",
                                    contentType: "application/json",
                                    dataType: "json",
                                    data: data,
                                    error: function (result) {
                                        // Display a general error message to the user
                                        alert("Sorry, there was a problem processing your request. Please try again later.");
                                        console.error("AJAX error in request: " + result.responseText);
                                    },
                                    success: function (result) {
                                        window.location.href = result;
                                    },
                                });
                            }
                        });
                        $("#nearby-communities li[id^='community-'] .nearby-community-item").off('click').on('click', function (e) {
                            e.preventDefault();
                            var wrapper = $(this).parent();
                            // Extract coordinates from hidden inputs
                            var originCoord = wrapper.find("input[name='OriginCoordinate']").val().split(',');
                            var destCoord = wrapper.find("input[name='DestinationCoordinate']").val().split(',');
                            // Construct the objects
                            var originObj = {
                                lat: parseFloat(originCoord[0]),
                                long: parseFloat(originCoord[1])
                            };
                            var destObj = {
                                lat: parseFloat(destCoord[0]),
                                long: parseFloat(destCoord[1])
                            };
                            if (!$('#info-card-coord')[0]) {
                                getPointToPointDirection(originObj, destObj, google.maps.TravelMode.DRIVING, displayAddress);
                            }
                            $(this).siblings().removeClass('selected');
                            if ($(this).hasClass('selected')) {
                                if (!$('#info-card-coord')[0]) {
                                    getPointToPointDirection(originObj, originObj, google.maps.TravelMode.DRIVING, displayAddress);
                                }
                                else {
                                    history.replaceState(null, null, window.location.pathname);
                                }
                                DisplayDirectoryServiceMarkers(results.services);
                                $(this).removeClass('selected');
                                wrapper.find('#goto').css('display', 'none');
                                wrapper.find('.list-item.ucl-list-item').css('width', '100%');
                                $(".info-council-wrapper>.ucl-info-card").toggleClass("display-none col-md-5");
                                $(".info-council-wrapper>#council-ucl-map").toggleClass("col-md-12 col-md-7");
                                if ($('#info-card-coord')) {
                                    if (pageUCLs.length > 0) {
                                        GetDefaultUCLsMarkers(pageUCLs);
                                    }
                                }
                                if (window.matchMedia("(max-width: 768px)").matches) {
                                    $('.mobile-ucl-info').hide();
                                }
                            }
                            else {
                                if ($('#info-card-coord')[0]) {
                                    var id = $(this).attr("id");
                                    var queryParams = new URLSearchParams(window.location.search);
                                    queryParams.set("ucl", id);
                                    history.replaceState(null, null, "?" + queryParams.toString());
                                    window.scrollTo(0, 0);
                                }
                                $(this).addClass('selected');
                                wrapper.find('#goto').css('display', 'flex');
                                wrapper.find('#goto').css('width', '25%');
                                wrapper.find('.list-item.ucl-list-item').css('width', '75%');
                                $('.ucl-info-card-title').html(wrapper.find("input[name='DisplayTitle']").val());
                                $('#info-card-url').val(wrapper.find("input[name='URL']").val());
                                $('#info-card-coord').val(wrapper.find("input[name='DestinationCoordinate']").val());
                                $('#info-card-displayName').val(wrapper.find("input[name='DisplayTitle']").val());
                                if (window.matchMedia("(max-width: 768px)").matches) {
                                    $('.mobile-ucl-info').show();
                                }
                                if ($('#info-card-coord').length > 0) {
                                    $(".ucl-info-card-description").text("");
                                    window.MapView.panTo(new google.maps.LatLng(destObj.lat, destObj.long));
                                    window.MapView.setZoom(13);
                                    getUCLDescriptions(wrapper.find("input[name='GeographyMapId']").val(), wrapper.find("input[name='CouncilRegionID']").val());
                                }
                                $(".info-council-wrapper>.ucl-info-card").toggleClass("display-none col-md-5");
                                $(".info-council-wrapper>#council-ucl-map").toggleClass("col-md-12 col-md-7");
                            }
                            wrapper.find('#goto').off('click').on('click', function (e) {
                                $('#page-backdrop').fadeIn(150);
                                var url = wrapper.find("input[name='URL']").val();
                                var data = JSON.stringify({
                                    "DisplayName": null,
                                    "Lat": destObj.lat,
                                    "Lng": destObj.long,
                                    "LocationType": 'point',
                                    "Url": url,
                                    "CouncilID": 0,
                                    "LocationID": 0
                                });
                                $.ajax({
                                    url: "/StoreSearchedModelInSession",
                                    type: "POST",
                                    contentType: "application/json",
                                    dataType: "json",
                                    data: data,
                                    error: function (result) {
                                        // Display a general error message to the user
                                        alert("Sorry, there was a problem processing your request. Please try again later.");
                                        console.error("AJAX error in request: " + result.responseText);
                                    },
                                    success: function (result) {
                                        window.location.href = result;
                                    },
                                });
                            });
                            wrapper.siblings().each(function (i, e) {
                                if ($(e).find('.list-item.nearby-community-item').hasClass('selected')) {
                                    $(".info-council-wrapper>.ucl-info-card").toggleClass("display-none col-md-5");
                                    $(".info-council-wrapper>#council-ucl-map").toggleClass("col-md-12 col-md-7");
                                }
                                $(e).find('.list-item.nearby-community-item').removeClass('selected');
                                $(e).find('.list-item.nearby-community-item').css('width', '100%');
                                $(e).find('#goto').css('display', 'none');
                            });
                        });
                        $btnGoToAddress.on('click', function () {
                            RedirectToAnotherInfoHub($(this));
                        });
                        $btnGoToAddress_mobile.on('click', function () {
                            RedirectToAnotherInfoHub($(this));
                        });
                        $locationSelectorModal.on('click', function (event) {
                            // If the clicked element is the modal's direct child (the backdrop)
                            if ($(event.target).hasClass('modal')) {
                                $(this).modal('hide'); // Close the modal
                            }
                        });
                        $locationSelectorModal.on('show.bs.modal', function () {
                            $addressSuggestions.empty();
                            $addressSuggestions.hide();
                            $btnLocateMe.hide();
                            $btnClearAddress.show();
                            $addressInput.val(defaultLocation.DisplayName);
                            $btnGoToAddress.siblings('input[name="url"]').val(defaultLocation.Url);
                            $btnGoToAddress.siblings('input[name="displayName"]').val(defaultLocation.DisplayName);
                            $btnGoToAddress.siblings('input[name="lat"]').val(defaultLocation.Lat);
                            $btnGoToAddress.siblings('input[name="lng"]').val(defaultLocation.Lng);
                            $btnGoToAddress.siblings('input[name="locationType"]').val(defaultLocation.LocationType);
                            $btnGoToAddress.siblings('input[name="councilId"]').val(defaultLocation.CouncilID);
                            $btnGoToAddress.siblings('input[name="locationId"]').val(defaultLocation.LocationID);
                        });
                        SetupLocateMeBtn($btnLocateMe, $btnClearAddress, $addressInput, $btnGoToAddress); // desktop
                        $btnClearAddress.on('click', function (e) {
                            e.preventDefault();
                            $addressInput.val('');
                            $btnLocateMe.show();
                            $(this).hide();
                            $addressSuggestions.empty();
                            $addressSuggestions.hide();
                            ResetLocationToDefault($btnGoToAddress);
                            $addressInput.focus();
                        });
                        addressLocationSelected = false;
                        $addressInput.on('blur', function (e) {
                            if ($addressInput.is(e.target) || $addressSuggestions[0].contains(e.target)) {
                                return; // Do nothing if the click is on the input or suggestions list
                            }
                            if (addressLocationSelected) {
                                $addressInput.val($btnGoToAddress.siblings('input[name="displayName"]').val());
                                addressLocationSelected = false; // Reset the flag
                            }
                            else {
                                // Optional: handle other behavior if no location was selected
                                $addressSuggestions.empty();
                                $addressSuggestions.hide();
                            }
                        });
                        $addressInput.on('input', debounce(function () {
                            var value = $addressInput.val();
                            if (value.length > 0) {
                                $btnLocateMe.hide();
                                $btnClearAddress.show();
                            }
                            else {
                                $btnLocateMe.show();
                                $btnClearAddress.hide();
                                $addressSuggestions.empty();
                                $addressSuggestions.hide();
                                return;
                            }
                            if (value.length >= 3) {
                                // Send the AJAX request
                                $.ajax({
                                    url: window.AppSettings.ApiUrl + "/api/v1/system/councils/searchall/" + $(this).val(),
                                    type: 'GET',
                                    beforeSend: function () {
                                        $addressSuggestions.empty();
                                        $addressSuggestions.show();
                                    },
                                    success: function (response) {
                                        if ((response === null || response === void 0 ? void 0 : response.length) > 0) {
                                            var maxItems = Math.min(10, response.length); // Maximum of 10 suggestions will be displayed
                                            var _loop_2 = function (i) {
                                                var item = response[i];
                                                li = document.createElement("li");
                                                div = document.createElement("div");
                                                /* make the matching letters bold */
                                                inputValue = $addressInput.val();
                                                // Escape any special regex characters in inputValue
                                                escapedInput = inputValue.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                                                // Create a regex pattern for a case-insensitive search
                                                pattern = new RegExp(escapedInput, 'ig');
                                                // Replace matched substring with itself wrapped in <strong> tags
                                                name = item.DisplayName.replace(pattern, function (match) {
                                                    return '<strong>' + match + '</strong>';
                                                });
                                                icon = document.createElement("div");
                                                li.classList.add("suggestions-item");
                                                li.style.padding = "0 4px";
                                                li.appendChild(div);
                                                div.classList.add("suggestion-title");
                                                div.innerHTML = name;
                                                li.insertBefore(icon, div);
                                                icon.classList.add("suggestion-icon");
                                                if (item.LocationType.toUpperCase() == "LGA") {
                                                    icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/lga_icons.png')";
                                                }
                                                else {
                                                    icon.style.backgroundImage = "url('/_static/static-page-assets/images/icons/pin_icons.png')";
                                                }
                                                // add event
                                                li.addEventListener('click', function () {
                                                    addressLocationSelected = true;
                                                    $addressSuggestions.empty();
                                                    $addressSuggestions.hide();
                                                    $addressInput.val(item.DisplayName);
                                                    $btnGoToAddress.siblings('input[name="url"]').val(item.Url);
                                                    $btnGoToAddress.siblings('input[name="displayName"]').val(item.DisplayName);
                                                    $btnGoToAddress.siblings('input[name="lat"]').val(item.Lat);
                                                    $btnGoToAddress.siblings('input[name="lng"]').val(item.Lng);
                                                    $btnGoToAddress.siblings('input[name="locationType"]').val(item.LocationType);
                                                    $btnGoToAddress.siblings('input[name="councilId"]').val(item.CouncilID);
                                                    $btnGoToAddress.siblings('input[name="locationId"]').val(item.LocationID);
                                                });
                                                // Add suggestion item to the list
                                                $addressSuggestions.append(li);
                                            };
                                            var li, div, inputValue, escapedInput, pattern, name, icon;
                                            for (var i = 0; i < maxItems; i++) {
                                                _loop_2(i);
                                            }
                                        }
                                    },
                                    error: function (error) {
                                        console.error(error);
                                    }
                                });
                            }
                        }, 250));
                        $addressInput_mobile = $('#mobile-address-input');
                        $addressSuggestions_mobile = $('#mobile-address-suggestion-list');
                        $btnLocateMe_mobile = $('#mobile-locator-button');
                        $btnClearAddress_mobile = $('#mobile-clear-address-button');
                        $navBackdrop_mobile = $mobileNav.find("#backdrop");
                        $btnToggleBurgerMenu.on('click', function (e) {
                            e.preventDefault();
                            if ($burgerMenu.hasClass('hidden')) {
                                $burgerMenu.removeClass('hidden');
                            }
                            else {
                                $burgerMenu.addClass('hidden');
                            }
                        });
                        SetupLocateMeBtn($btnLocateMe_mobile, $btnClearAddress_mobile, $addressInput_mobile, $btnGoToAddress_mobile); // mobile
                        if ($addressInput_mobile.val()) {
                            $btnClearAddress_mobile.show();
                            $btnLocateMe_mobile.hide();
                        }
                        $btnClearAddress_mobile.on('click', function (e) {
                            e.preventDefault();
                            $addressInput_mobile.val('');
                            $btnLocateMe_mobile.show();
                            $(this).hide();
                            $addressSuggestions_mobile.empty();
                            if (!$addressSuggestions_mobile.hasClass('hidden')) {
                                hideAddressSuggestions_mobile();
                            }
                            // Reset to default
                            ResetLocationToDefault($btnGoToAddress_mobile);
                            $addressInput_mobile.focus();
                        });
                        $addressSuggestions_mobile.on("show", function () {
                            $navBackdrop_mobile.show();
                        });
                        $navBackdrop_mobile.click(hideAddressSuggestions_mobile);
                        FetchLocation_mobile($addressInput_mobile, $btnGoToAddress_mobile, $btnLocateMe_mobile, $btnClearAddress_mobile, $addressSuggestions_mobile, $navBackdrop_mobile);
                        if (!!$('#info-card-coord')[0]) return [3 /*break*/, 2];
                        // check if this is a communityinfohub page
                        if ($('#selectGetHelp').length == 0) {
                            return [2 /*return*/];
                        }
                        $getHelp_1 = $('#selectGetHelp');
                        $getInvolved_1 = $('#selectGetInvolved');
                        $getHelp_1.on('click', function () {
                            if ($(this).hasClass('selected')) {
                                DiaryRequest([5], { geographyId: geographyId });
                                $('#btn-community-diary, #btn-clubs-groups').removeClass('selected').addClass('unselected');
                                $('#btn-outreach-services').removeClass('unselected').addClass('selected');
                                if ($getInvolved_1.hasClass('selected')) {
                                    $getInvolved_1.removeClass('selected');
                                }
                                FetchDirectory(geographyId, displayAddress, lat, lng, getHelp);
                                $('button#show-services').parent().show();
                                $('#categorySelect').hide();
                                $('#directory-services').show();
                                $('#directory .service-name').text('Get Help');
                            }
                            else {
                                DiaryRequest([], { geographyId: geographyId });
                                $('#btn-outreach-services').removeClass('selected').addClass('unselected');
                                if (!$getInvolved_1.hasClass('selected')) {
                                }
                                else {
                                }
                                $('button#show-services').parent().hide();
                                $('#categorySelect').show();
                                $('#directory-services').hide();
                                $('#directory .service-name').text('Services');
                            }
                        });
                        $getInvolved_1.on('click', function () {
                            if ($(this).hasClass('selected')) {
                                DiaryRequest([1, 4], { geographyId: geographyId });
                                $('#btn-community-diary, #btn-clubs-groups').removeClass('unselected').addClass('selected');
                                $('#btn-outreach-services').removeClass('selected').addClass('unselected');
                                if ($getHelp_1.hasClass('selected')) {
                                    $getHelp_1.removeClass('selected');
                                }
                                FetchDirectory(geographyId, displayAddress, lat, lng, getInvolved);
                                $('button#show-services').parent().show();
                                $('#categorySelect').hide();
                                $('#directory-services').show();
                                $('#directory .service-name').text('Get Involved');
                            }
                            else {
                                DiaryRequest([], { geographyId: geographyId });
                                $('#btn-community-diary, #btn-clubs-groups').removeClass('selected').addClass('unselected');
                                if (!$getHelp_1.hasClass('selected')) {
                                }
                                else {
                                }
                                $('button#show-services').parent().hide();
                                $('#categorySelect').show();
                                $('#directory-services').hide();
                                $('#directory .service-name').text('Services');
                            }
                        });
                        InitSelectPicker();
                        return [4 /*yield*/, Promise.race([
                                FetchInfoHubAbout(geographyId, regionId),
                                FetchCategoryGroups(geographyId, displayAddress, lat, lng),
                                FetchWeatherData(lat, lng),
                                FetchDiary(geographyId, regionId, lat, lng),
                                FetchGiveLocal(geographyId, regionId),
                                FetchLocalServices(regionId, locationId)
                            ])
                                .then(function () {
                                $('#page-backdrop').fadeOut(200);
                            })
                                .catch(function (err) {
                                console.error(err);
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        $('#page-backdrop').fadeOut(200);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    Page.InitCommunityHub = InitCommunityHub;
    function FetchInfoHubAbout(geographId, councilId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!geographId || !councilId)
                            return resolve();
                        $.ajax({
                            type: "GET",
                            url: "/api/GetGeoMapDescription?GeoMapId=" + geographId + "&CouncilRegionId=" + councilId,
                            beforeSend: function () {
                                $("#infohub-desc").append('<li class="spinner"></li>');
                            },
                            success: function (data) {
                                if (data) {
                                    if (data.length > 250) {
                                        $('#infohub-desc').find('label').removeClass('hide');
                                    }
                                    $('#infohub-desc').find('.read-more__text').each(function (i, e) {
                                        $(e).text(data);
                                    });
                                }
                            },
                            complete: function () {
                                $("#infohub-desc").find('.spinner').remove();
                                resolve();
                            },
                        });
                    })];
            });
        });
    }
    Page.FetchInfoHubAbout = FetchInfoHubAbout;
    function FetchLocalServices(regionId, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!locationId)
                            return resolve();
                        $.ajax({
                            type: "POST",
                            url: '/api/GetLocalInfoCards',
                            data: JSON.stringify({ LocationID: locationId, CouncilRegionID: regionId, CategoryList: [141, 140, 153, 146] }),
                            contentType: "application/json",
                            dataType: "json",
                            beforeSend: function () {
                                $("#local-services").empty();
                                $("#local-services").append('<li class="spinner"></li>');
                                $("#local-services").find('.notfound').remove();
                            },
                            success: function (data) {
                                if (!data)
                                    return;
                                var renderedHtml = $.templates("#localServicesTemplate").render(data.filter(function (obj) { return obj.Services !== null; }));
                                $("#local-services").html(renderedHtml);
                            },
                            complete: function () {
                                $("#local-services").find('.spinner').hide();
                                //if (results.localservices.length <= 0) {
                                //    $("#local-services").append('<li class="notfound" style="display:flex;justify-content:center;"><i>Unfortunately, there are no matching services found at this time for this location!</i></li>');
                                //}
                                resolve();
                            },
                        });
                    })];
            });
        });
    }
    Page.FetchLocalServices = FetchLocalServices;
    function FetchWeatherData(lat, lng) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        /////////////////////////////////////////////////////////////////////
                        // Weather
                        function HandleErrors() {
                            $('span[id="localTime"]').text("-:-");
                            $('span[id="localTemperature"]').text('-°C');
                            $('span[id="localHumidity"]').text('-%');
                            $('span[id="localWindSpeed"]').text('- kmph');
                            $('span[id="localUV"]').text('UV - of 11');
                        }
                        if (!lat || !lng) {
                            HandleErrors();
                            return resolve();
                        }
                        $.ajax({
                            type: "GET",
                            url: "/api/GetWeatherInfo?lat=" + lat + "&lng=" + lng,
                            success: function (data) {
                                if (data.error) {
                                    HandleErrors();
                                    return;
                                }
                                var location = data.location;
                                var current = data.current;
                                if (location && current) {
                                    var date = new Date(location.localtime);
                                    var hour = date.getHours();
                                    var minutes = date.getMinutes();
                                    var ampm = hour >= 12 ? 'PM' : 'AM';
                                    // Convert hour to 12-hour format
                                    hour = hour % 12;
                                    // the hour '0' should be '12'
                                    hour = hour ? hour : 12;
                                    // Add a leading zero to minutes if less than 10
                                    var strMinutes = minutes < 10 ? '0' + minutes : minutes;
                                    $('span[id="localTime"]').text(hour + ":" + strMinutes + " " + ampm);
                                    $('span[id="localTemperature"]').text(current.temp_c + '°C');
                                    $('span[id="localHumidity"]').text(current.humidity + '%');
                                    $('span[id="localWindSpeed"]').text(current.wind_kph + ' kmph');
                                    $('span[id="localUV"]').text('UV ' + current.uv + ' of 11');
                                    //$('span[id="localVisibility"]').text(current.vis_km + 'km');
                                    $('#localWeatherIcon').html('<img src="' + current.condition.icon + '" alt="Weather Icon" />');
                                }
                                else {
                                    HandleErrors();
                                }
                            },
                            complete: function () {
                                resolve();
                            },
                            error: function () {
                                HandleErrors();
                            }
                        });
                    })];
            });
        });
    }
    Page.FetchWeatherData = FetchWeatherData;
    function DisplayDirectoryServiceMarkers(data) {
        results.services = data;
        results.directoryMarkers = [];
        RefreshMarkers();
        if (!data)
            return;
        for (var i = 0; i < results.services.length; i++) {
            // Check if Outlet and Outlet.Nickname exist before trying to access its value
            var nickname = results.services[i].Outlet && results.services[i].Outlet.Nickname ? results.services[i].Outlet.Nickname : null;
            var description = results.services[i].Description;
            if ((description === null || description === void 0 ? void 0 : description.length) > 150)
                description = description.slice(0, 150) + '...';
            var webUrl = window.AppSettings.DirectoryUrl + results.services[i].Url;
            var content = "<div>\n                    <span><a class=\"text-decoration-none\" href=\"" + webUrl + "\" target=\"_blank\" tabindex=\"-1\"><span style=\"font-size: 18px;font-weight: 500;\">" + nickname + "</span></a></span>\n                    <br />\n                    <span style=\"font-size: 12px;\"><i>" + results.services[i].Category.Name + "</i></span>\n                    <br />\n                    <span style=\"font-size: 12px;\">" + description + "</span>\n                    <br />\n                    <span style=\"display:flex;flex-direction:row;justify-content:space-between;\">\n                        <span class=\"text-decoration-none\"><a class=\"text-decoration-none\" href=\"" + webUrl + "\" target=\"_blank\" tabindex=\"-1\"><i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Link to Directory</a></span>\n                        " + (results.services[i].Outlet.Phone ? "<span><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> Phone: <a class=\"text-decoration-none\" href=\"tel:" + results.services[i].Outlet.Phone + "\" target=\"_blank\" tabindex=\"-1\">" + results.services[i].Outlet.Phone + "</a></span>" : '') + "\n                    </span>\n                </div>";
            // Check for the existence of Outlet.MapLocation before accessing Lat and Lng
            if (results.services[i].Outlet && results.services[i].Outlet.MapLocation.ShowMarker) {
                results.directoryMarkers.push(AddMarker(results.services[i].Outlet.MapLocation.Lat, results.services[i].Outlet.MapLocation.Lng, nickname, // title on hover,
                content, '/_static/images/MCD_logo.png'));
            }
        }
    }
    var results = {
        services: [],
        events: [],
        filteredEvents: [],
        localservices: [],
        directoryMarkers: [],
        diaryMarkers: [],
    };
    var getHelp = [1, 2, 3, 4, 5, 9, 10, 11, 12, 13, 15, 16, 17, 18, 21, 23, 25, 26];
    var getInvolved = [6, 7, 8, 14, 19, 20, 22, 24, 27, 28];
    function FetchDirectory(geographyId, displayAdddress, latitude, longitude, categoryGroups) {
        if (categoryGroups === void 0) { categoryGroups = [0]; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        /////////////////////////////////////////////////////////////////////
                        // NEARBY GEOGRAPHIES
                        var currentPageNo = 1; // default to first page if you don't know the current page yet
                        var PAGE_CHUNK_SIZE = 5;
                        var PAGE_CONTENT_SIZE = 20;
                        var MAX_PAGE_SIZE = 20;
                        var SORT_FIELD = 'OrganisationID';
                        var SORT_DIRECTION = 'ASC';
                        //const RADIUS = 100;
                        /////////////////////////////////////////////////////////////////////
                        // DIRECTORY
                        function DirectoryRequest(categoryGroupIds, geoId, pageNo) {
                            if (categoryGroupIds === void 0) { categoryGroupIds = []; }
                            if (geoId === void 0) { geoId = 0; }
                            if (pageNo === void 0) { pageNo = 1; }
                            $.ajax({
                                type: "GET",
                                url: '/api/Search/LocalGeoCategory',
                                data: {
                                    SearchType: 'Category',
                                    What: '',
                                    Where: displayAdddress,
                                    //Category: 0,
                                    //CategoryGroup: categoryGroupId,
                                    CategoryGroups: categoryGroupIds === null || categoryGroupIds === void 0 ? void 0 : categoryGroupIds.toString(),
                                    //Location: 0,
                                    //Council: 0,
                                    SortField: SORT_FIELD,
                                    SortDirection: SORT_DIRECTION,
                                    PageNo: pageNo,
                                    PageSize: MAX_PAGE_SIZE,
                                    SearchAroundCouncilRegion: false,
                                    IsAdvanced: false,
                                    ShowResourceList: 0,
                                    Ext: false,
                                    RegionID: geoId,
                                },
                                beforeSend: function () {
                                    $("#directory-services").append('<li class="spinner"></li>');
                                    $("#directory-services").find('.pagination').remove();
                                    $("#directory-services").find('.notfound').remove();
                                },
                                success: function (res) {
                                    var _a;
                                    if (((_a = res === null || res === void 0 ? void 0 : res.Results) === null || _a === void 0 ? void 0 : _a.length) <= 0) {
                                        console.log('No services');
                                    }
                                    else {
                                        var groupedByLocation = res.Results.reduce(function (accumulator, service) {
                                            var _a;
                                            // Find if there is already an entry for the locationId
                                            var existingEntry = accumulator.find(function (entry) { var _a; return entry.OrganisationID === ((_a = service.Outlet) === null || _a === void 0 ? void 0 : _a.OrganisationID); });
                                            if (existingEntry) {
                                                existingEntry.services.push(service);
                                            }
                                            else {
                                                accumulator.push({ OrganisationID: (_a = service.Outlet) === null || _a === void 0 ? void 0 : _a.OrganisationID, Outlet: service.Outlet, OrganisationName: service.OrganisationName, services: [service] });
                                            }
                                            return accumulator;
                                        }, []);
                                        groupedByLocation.forEach(function (location) {
                                            if (location.services && location.services.length > 0) {
                                                var servicesGroupedByLocation = location.services.reduce(function (accumulator, service) {
                                                    var _a;
                                                    // Find if there is already an entry for the OutletID
                                                    var existingEntry = accumulator.find(function (entry) { var _a; return entry.OutletID === ((_a = service.Outlet) === null || _a === void 0 ? void 0 : _a.OutletID); });
                                                    if (existingEntry) {
                                                        existingEntry.services.push(service);
                                                    }
                                                    else {
                                                        accumulator.push({ OutletID: (_a = service.Outlet) === null || _a === void 0 ? void 0 : _a.OutletID, Outlet: service.Outlet, services: [service] });
                                                    }
                                                    return accumulator;
                                                }, []);
                                                if (servicesGroupedByLocation && servicesGroupedByLocation.length > 0) {
                                                    location.services = servicesGroupedByLocation;
                                                }
                                            }
                                        });
                                        ProcessPagination(res.Results, res.Total, currentPageNo);
                                        var totalPages = Math.ceil(res.Total / PAGE_CONTENT_SIZE); // Assuming each page has 10 results
                                        var startPage = Math.floor((currentPageNo - 1) / PAGE_CHUNK_SIZE) * PAGE_CHUNK_SIZE + 1;
                                        var endPage = Math.min(startPage + (PAGE_CHUNK_SIZE - 1), totalPages); // ensure we don't go past totalPages
                                        var template = $.templates("#serviceTemplate");
                                        var htmlOutput = template.render(groupedByLocation.slice(0, PAGE_CONTENT_SIZE));
                                        $("#directory-services").html(htmlOutput);
                                        // Generate pagination HTML
                                        var paginationHtml = '<li><span class="pagination margin-0 margin-top-10" style="font-size: 18px; float: right;">Page ';
                                        // If on a page greater than 5, add a "previous" link
                                        if (currentPageNo > PAGE_CHUNK_SIZE) {
                                            paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + (startPage - 5) + "\" data-cg=\"" + categoryGroupIds + "\">Previous</a> ";
                                        }
                                        for (var i = startPage; i <= endPage; i++) {
                                            if (i == currentPageNo) {
                                                paginationHtml += "<span>" + i + "</span> "; // Highlight current page
                                            }
                                            else {
                                                paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + i + "\" data-cg=\"" + categoryGroupIds + "\">" + i + "</a> ";
                                            }
                                        }
                                        // If there are more pages ahead, add a "next" link
                                        if (totalPages > endPage) {
                                            paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + (endPage + 1) + "\" data-cg=\"" + categoryGroupIds + "\">Next</a> ";
                                        }
                                        paginationHtml += " - Showing " + res.Results.slice(0, PAGE_CONTENT_SIZE).length + " of " + res.Total;
                                        paginationHtml += '</span></li>';
                                        $("#directory-services").append(paginationHtml);
                                        // Attach click event to pagination links
                                        $("#directory-services").find('.pagination').off('click').on('click', 'a[data-page]', function (event) {
                                            event.preventDefault();
                                            var clickedPageNumber = $(this).data('page');
                                            currentPageNo = clickedPageNumber;
                                            DirectoryRequest($(this).data('cg'), geographyId, clickedPageNumber);
                                            document.getElementById('directory').scrollIntoView({ behavior: 'smooth' });
                                        });
                                        results.services = res.Results;
                                        DisplayDirectoryServiceMarkers(results.services);
                                    }
                                },
                                complete: function () {
                                    $("#directory-services").find('.spinner').hide();
                                    if (results.services.length <= 0) {
                                        $("#directory-services").append('<li class="notfound" style="display:flex;justify-content:center;"><i>Unfortunately, there are no matching services found at this time for this location!</i></li>');
                                    }
                                    resolve();
                                }
                            });
                        }
                        DirectoryRequest(categoryGroups, geographyId, currentPageNo);
                        $('#categorySelect').on('change', function () {
                            // Attaching this event after initializing with .selectpicker()
                            var selectedCategoryGroupId = $(this).val();
                            if (Array.isArray(selectedCategoryGroupId)) {
                                if (selectedCategoryGroupId.length === 0 || (selectedCategoryGroupId.length === 1 && (selectedCategoryGroupId[0] === '0' || selectedCategoryGroupId[0] === ''))) {
                                    selectedCategoryGroupId = 0;
                                }
                            }
                            $("#directory-services").empty();
                            $("#directory-services").find('.pagination').remove();
                            currentPageNo = 1;
                            DirectoryRequest(selectedCategoryGroupId, geographyId, currentPageNo);
                        });
                    })];
            });
        });
    }
    function ProcessPagination(items, totalItemsCount, currentPageNo, $pagination) {
        //@ts-ignore
        var ITEMS = items;
        //@ts-ignore
        var ITEMS_TOTAL = totalItemsCount;
        //@ts-ignore
        var PAGE_CHUNK_SIZE = 5;
        //@ts-ignore
        var PAGE_CONTENT_SIZE = 20;
        var totalPages = Math.ceil(ITEMS_TOTAL / PAGE_CONTENT_SIZE); // Assuming each page has 10 results
        var startPage = Math.floor((currentPageNo - 1) / PAGE_CHUNK_SIZE) * PAGE_CHUNK_SIZE + 1;
        //@ts-ignore
        var endPage = Math.min(startPage + (PAGE_CHUNK_SIZE - 1), totalPages); // ensure we don't go past totalPages
        //console.log(currentPageNo, totalPages, startPage, endPage);
        return;
    }
    function DisplayDiaryEventMarkers(data) {
        results.filteredEvents = data;
        results.diaryMarkers = [];
        RefreshMarkers();
        if (!data)
            return;
        for (var i = 0; i < data.length; i++) {
            var description = results.filteredEvents[i].TextOnlyDescription;
            if ((description === null || description === void 0 ? void 0 : description.length) > 150)
                description = description.slice(0, 150) + '...';
            var webUrl = window.AppSettings.DiaryUrl + results.filteredEvents[i].InstanceUrl;
            var content = "<div>\n                    <span><a class=\"text-decoration-none\" href=\"" + webUrl + "\" target=\"_blank\" tabindex=\"-1\"><span style=\"text-decoration: none; font-size: 18px;font-weight: 500;\">" + results.filteredEvents[i].EventName + "</span></a></span>\n                    <br />\n                    <span style=\"font-size: 12px;\">" + description + "</span>\n                    <br />\n                    <span style=\"font-size: 12px;\"><i>" + results.filteredEvents[i].LocationAddress + "</i></span>\n                    <br />\n                    <span style=\"display:flex;flex-direction:row;justify-content:space-between;\">\n                        <span><a class=\"text-decoration-none\" href=\"" + webUrl + "\" target=\"_blank\" tabindex=\"-1\"><i class=\"fa fa-globe\" aria-hidden=\"true\"></i> Link to Diary</a></span>\n                        " + (results.filteredEvents[i].Phone1 ? "<span><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> Phone: <a class=\"text-decoration-none\" href=\"tel:" + results.filteredEvents[i].Phone1 + "\" target=\"_blank\" tabindex=\"-1\">" + results.filteredEvents[i].Phone1 + "</a></span>" : '') + "\n                    </span>\n                </div>";
            results.diaryMarkers.push(AddMarker(results.filteredEvents[i].GeocodeLat, results.filteredEvents[i].GeocodeLong, results.filteredEvents[i].EventName + ' ' + results.filteredEvents[i].EventInstanceID, // title on hover
            content, '/_static/images/Diary_logo.png'));
        }
    }
    function FetchCategoryGroups(geographyId, displayAddress, lat, lng) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!geographyId)
                            return resolve();
                        $.ajax({
                            type: "GET",
                            url: "/api/GetLocalCategoryGroups/" + geographyId,
                            beforeSend: function () {
                                $("#categorySelect").append('<li class="spinner"></li>');
                                $('button#show-services').on('click', function () {
                                    $(this).parent().hide();
                                    $('#categorySelect').show();
                                    $('#directory-services').hide();
                                    $('#directory .service-name').text('Services');
                                });
                            },
                            success: function (data) {
                                if (data && data.length > 0) {
                                    var renderedOptions = $.templates("#categoryGroupsTemplate").render(data);
                                    $("#categorySelect").append(renderedOptions);
                                    $("#categorySelect").children().each(function (i, e) {
                                        $(this).on('click', function () {
                                            $('button#show-services').parent().show();
                                            $('#categorySelect').hide();
                                            $('#directory-services').show();
                                            $('#directory .service-name').text($(this).data('category-name'));
                                            FetchDirectory(geographyId, displayAddress, lat, lng, [$(this).data('category-group-id')]);
                                        });
                                    });
                                }
                            },
                            complete: function () {
                                $("#categorySelect").find('.spinner').remove();
                                $('#categorySelect').selectpicker('refresh'); // to be removed
                                $('button#show-services').parent().hide();
                                resolve();
                            }
                        });
                    })];
            });
        });
    }
    Page.FetchCategoryGroups = FetchCategoryGroups;
    //function GetDateNextMonthsAsString(numMonth = 3) {
    //    const date = new Date();
    //    date.setMonth(date.getMonth() + numMonth);
    //    const year = date.getFullYear();
    //    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    //    const nextDate = ('0' + date.getDate()).slice(-2);
    //    return `${year}-${month}-${nextDate}`;
    //}
    //var ignoreEventIds = [0];
    //var ignoreEventKeys = [''];
    function DiaryRequest(diaryTypeIDs, _a, callback) {
        if (diaryTypeIDs === void 0) { diaryTypeIDs = []; }
        var _b = _a === void 0 ? {} : _a, _c = _b.currentDate, currentDate = _c === void 0 ? null : _c, _d = _b.PAGE_NO, PAGE_NO = _d === void 0 ? 1 : _d, _e = _b.MAX_PAGE_SIZE, MAX_PAGE_SIZE = _e === void 0 ? 20 : _e, _f = _b.PAGE_CONTENT_SIZE, PAGE_CONTENT_SIZE = _f === void 0 ? 20 : _f, _g = _b.geographyId, geographyId = _g === void 0 ? null : _g;
        if (diaryTypeIDs.length <= 0) {
            diaryTypeIDs.push(1);
            diaryTypeIDs.push(4);
            diaryTypeIDs.push(5);
        }
        if (!currentDate) {
            var date = new Date();
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            currentDate = year + "-" + month + "-" + day;
        }
        //const nextThreeMonths = GetDateNextMonthsAsString(3);
        if (diaryTypeIDs.length > 0 && geographyId > 0) {
            $.ajax({
                type: "GET",
                url: window.AppSettings.ApiUrl + '/api/v1/search/diary/GetResponse',
                data: {
                    WhenIndex: 'All',
                    SearchFrom: currentDate,
                    //SearchTo: nextThreeMonths,
                    PageNo: PAGE_NO,
                    PageSize: MAX_PAGE_SIZE,
                    UniqueEvents: true,
                    IncludeDeletedAndUnpublished: false,
                    //CouncilID: councilId,
                    //IsCommunityOrganisation: false,
                    //IsATDW: false,
                    //IsEventFinda: false,
                    //IsCheckup: false,
                    //IsCATS: false,
                    //IsPrivate: false,
                    //Latitude: latitude,
                    //Longitude: longitude,
                    //RadiusKM: searchRadius,
                    GeographyID: geographyId,
                    //DiaryFormatID: ,
                    DiaryTypeIDs: diaryTypeIDs,
                },
                beforeSend: function () {
                    $("#diary-events").append('<li class="spinner"></li>');
                    $("#diary-events").find('.notfound').remove();
                    $("#diary-events").find('.findmore').remove();
                    $("#diary-events").find('.pagination').remove();
                    $("#diary-events").find('.list-item').remove();
                },
                success: function (res) {
                    var _a;
                    results.events = [];
                    var renderData;
                    if (((_a = res === null || res === void 0 ? void 0 : res.Data) === null || _a === void 0 ? void 0 : _a.length) <= 0) {
                        console.log('No events');
                        renderData = null;
                    }
                    else {
                        res.Data.forEach(function (event) {
                            results.events.push(event);
                        });
                        var template = $.templates("#eventTemplate");
                        renderData = results.events.slice(0, PAGE_CONTENT_SIZE);
                        var htmlOutput = template.render(renderData); // Display first n items (or fewer if fewer than n are present)
                        $("#diary-events").html(htmlOutput);
                        var totalPages = Math.ceil(res.TotalCount / PAGE_CONTENT_SIZE); // Assuming each page has n results
                        var pagesRange = 3;
                        var startPage = Math.max(1, PAGE_NO - pagesRange);
                        var endPage = Math.min(totalPages, PAGE_NO + pagesRange);
                        // Generate pagination HTML
                        var paginationHtml = '<li class="row margin-0 margin-top-10 pagination" style="float: right;"><span style="font-size: 18px;">';
                        if (PAGE_NO > 1) {
                            paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + (PAGE_NO - 1) + "\" >Prev</a> ";
                        }
                        else {
                            paginationHtml += 'Page '; // Show "Page" only if there is no "Prev" link
                        }
                        for (var i = startPage; i <= endPage; i++) {
                            if (i === PAGE_NO) {
                                paginationHtml += "<strong>" + i + "</strong> ";
                            }
                            else {
                                paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + i + "\" >" + i + "</a> ";
                            }
                        }
                        if (PAGE_NO < totalPages) {
                            paginationHtml += "<a href=\"javascript:void(0);\" data-page=\"" + (PAGE_NO + 1) + "\" >Next</a> ";
                        }
                        paginationHtml += " - Showing " + renderData.length + " of " + res.TotalCount;
                        paginationHtml += '</span></li>';
                        $("#diary-events").append(paginationHtml);
                        // Attach click event to pagination links
                        $("#diary-events").find('.pagination').off('click').on('click', 'a[data-page]', function (event) {
                            event.preventDefault();
                            DiaryRequest(diaryTypeIDs, { geographyId: geographyId, PAGE_NO: $(this).data('page') });
                            document.getElementById('diary').scrollIntoView({ behavior: 'smooth' });
                        });
                        //var paginationHtml = '<li class="row margin-0 margin-top-10 pagination" style="float: right;"><span style="font-size: 18px;">';
                        //if (res?.length >= MAX_PAGE_SIZE) {
                        //    paginationHtml += ` - <a id="next-events" href="javascript:void(0);">Next</a>`
                        //}
                        //$("#diary-events").find('#next-events').off('click').on('click', function (e) {
                        //    e.preventDefault();
                        //    results.events.forEach(function (e) {
                        //        if (e.DataProviderKey && e.DataProviderKey.length > 0) {
                        //            ignoreEventKeys.push(e.DataProviderKey.split('/')[0]);
                        //        } else {
                        //            ignoreEventIds.push(e.EventID);
                        //        }
                        //    });
                        //    document.getElementById('diary').scrollIntoView({ behavior: 'smooth' })
                        //    DiaryRequest(diaryTypeIDs, { geographyId: geographyId });
                        //});
                    }
                    DisplayDiaryEventMarkers(renderData);
                },
                complete: function () {
                    $("#diary-events").find('.spinner').remove();
                    if (results.events.length <= 0) {
                        $("#diary-events").append('<li class="row margin-0 margin-top-10 notfound" style="display:flex;justify-content:center;"><i>Unfortunately, there are no matching events found at this time for this location!</i></li>');
                    }
                    if (callback) {
                        callback();
                    }
                },
            });
        }
    }
    ;
    function FetchDiary(geographyId, councilId, latitude, longitude, diaryTypeIDs) {
        if (diaryTypeIDs === void 0) { diaryTypeIDs = []; }
        return __awaiter(this, void 0, void 0, function () {
            //const nextThreeMonths = GetDateNextMonthsAsString(3);
            // Helper function to handle click events on the buttons to change diary type
            function handleButtonClick(buttonId, typeIds) {
                if (typeIds === void 0) { typeIds = []; }
                $(buttonId).on('click', function (e) {
                    e.preventDefault();
                    //// Important!
                    //ignoreEventIds = [];
                    //ignoreEventKeys = [];
                    // Determine which buttons to select based on typeIds using indexOf for broader compatibility
                    if (typeIds.length == 2 && typeIds.indexOf(1) !== -1 && typeIds.indexOf(4) !== -1) {
                        // Select #btn-community-diary and #btn-clubs-groups, unselect #btn-outreach-services
                        $('#btn-community-diary, #btn-clubs-groups').removeClass('unselected').addClass('selected');
                        $('#btn-outreach-services').removeClass('selected').addClass('unselected');
                    }
                    else {
                        if ($(this).hasClass('selected')) {
                            $(this).removeClass('selected').addClass('unselected');
                            // check if others are selected
                            var ids = [];
                            if ($('#btn-community-diary').hasClass('selected')) {
                                ids.push(1);
                            }
                            if ($('#btn-clubs-groups').hasClass('selected')) {
                                ids.push(4);
                            }
                            if ($('#btn-outreach-services').hasClass('selected')) {
                                ids.push(5);
                            }
                            DiaryRequest(ids, { geographyId: geographyId });
                        }
                        else {
                            // Sends a request if individual btn is clicked
                            DiaryRequest(typeIds, { geographyId: geographyId });
                            // General case for toggling based on the clicked button
                            $(this).removeClass('unselected').addClass('selected');
                            $(this).siblings().removeClass('selected').addClass('unselected');
                        }
                    }
                });
            }
            var date, currentYear, currentMonth, currentDay, currentDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date = new Date();
                        currentYear = date.getFullYear();
                        currentMonth = ('0' + (date.getMonth() + 1)).slice(-2);
                        currentDay = ('0' + date.getDate()).slice(-2);
                        currentDate = currentYear + "-" + currentMonth + "-" + currentDay;
                        //// Important!
                        //ignoreEventIds = [];
                        //ignoreEventKeys = [];
                        // Attach event handlers to the buttons
                        handleButtonClick('#btn-community-diary', [1]);
                        handleButtonClick('#btn-clubs-groups', [4]);
                        handleButtonClick('#btn-outreach-services', [5]);
                        if (!(diaryTypeIDs.length == 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, $.ajax({
                                type: "GET",
                                url: window.AppSettings.ApiUrl + '/api/v1/search/diary/GetEventTypesWithCount',
                                data: {
                                    WhenIndex: 'All',
                                    SearchFrom: currentDate,
                                    //SearchTo: nextThreeMonths,
                                    UniqueEvents: true,
                                    IncludeDeletedAndUnpublished: false,
                                    GeographyID: geographyId,
                                    DiaryTypeIds: [1, 4, 5]
                                },
                                beforeSend: function () {
                                    $("#diary-events").append('<li class="spinner"></li>');
                                },
                                success: function (res) {
                                    if (res != null && res.length > 0) {
                                        diaryTypeIDs = res;
                                    }
                                    else {
                                        diaryTypeIDs = [];
                                        $("#diary-events").append('<li class="row margin-0 margin-top-10 notfound" style="display:flex;justify-content:center;"><i>Unfortunately, there are no events found at this time for this location!</i></li>');
                                    }
                                },
                                error: function (err) {
                                    console.log(err);
                                },
                                complete: function () {
                                    $("#diary-events").find('.spinner').remove();
                                },
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (diaryTypeIDs.indexOf(1) !== -1) {
                            if (!$('#btn-community-diary').hasClass('selected')) {
                                $('#btn-community-diary').removeClass('unselected').addClass('selected');
                            }
                        }
                        if (diaryTypeIDs.indexOf(4) !== -1) {
                            if (!$('#btn-clubs-groups').hasClass('selected')) {
                                $('#btn-clubs-groups').removeClass('unselected').addClass('selected');
                            }
                        }
                        if (diaryTypeIDs.indexOf(5) !== -1) {
                            if (!$('#btn-outreach-services').hasClass('selected')) {
                                $('#btn-outreach-services').removeClass('unselected').addClass('selected');
                            }
                        }
                        if (diaryTypeIDs.length == 0) {
                            console.log('No events');
                            return [2 /*return*/];
                        }
                        else {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    DiaryRequest(diaryTypeIDs, { currentDate: currentDate, geographyId: geographyId }, resolve);
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    Page.FetchDiary = FetchDiary;
    function FetchGiveLocal(geographyId, councilId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        /////////////////////////////////////////////////////////////////////
                        // GIVE LOCAL
                        var searchRequest = { "OrderByDate": true, "OrderByVolunteerTitle": false, "CouncilID": councilId, "Length": 10, "Start": 0, "IncludeCounts": true, "GeographyID": "" };
                        $.ajax({
                            type: "POST",
                            url: window.AppSettings.ApiUrl + "/api/v1/volunteer/search",
                            data: JSON.stringify(searchRequest),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            beforeSend: function () {
                                $("#givelocal-services").append('<li class="spinner"></li>');
                                $("#givelocal-services").find('.notfound').remove();
                            },
                            success: function (res) {
                                var data = res.Results;
                                if (data.length > 0) {
                                    var template = $.templates("#givelocalTemplate");
                                    var htmlOutput = template.render(data);
                                    $("#givelocal-services").html(htmlOutput);
                                    var totalPages = Math.ceil(data.length / data.length); // Assuming each page has 10 results
                                    // Generate pagination HTML
                                    var paginationHtml = '<span class="pagination margin-0 margin-top-10" style="font-size: 18px; float: right;">Page ';
                                    for (var i = 1; i <= totalPages; i++) {
                                        paginationHtml += "<a href=\"javascript:void(0);\">" + i + "</a> ";
                                    }
                                    paginationHtml += " - Showing " + data.length + " of " + data.length;
                                    paginationHtml += '</span>';
                                    $("#givelocal-services").append(paginationHtml);
                                    $("#givelocal-services").find('.givelocal-item').off('click').on('click', function (e) {
                                        e.preventDefault();
                                        window.open($(this).find('[name="LocationUrl"]').val());
                                    });
                                    results.localservices = data;
                                }
                                else {
                                    console.log('No vonlunteer ads');
                                }
                            },
                            complete: function () {
                                $("#givelocal-services").find('.spinner').hide();
                                if (results.localservices.length <= 0) {
                                    $("#givelocal-services").append('<li class="notfound" style="display:flex;justify-content:center;"><i>Unfortunately, there are no services found at this time for this location!</i></li>');
                                }
                                resolve();
                            }
                        });
                    })];
            });
        });
    }
    Page.FetchGiveLocal = FetchGiveLocal;
    function getUCLDescriptions(geoID, councilRegionID) {
        $(".info-loading-wraper").show();
        currentRequest = $.ajax({
            url: "/api/GetGeoMapDescription?GeoMapId=" + geoID + "&CouncilRegionId=" + councilRegionID,
            dataType: "json",
            type: "Get",
            beforeSend: function () {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function (data) {
                $(".info-loading-wraper").hide();
                data.replace("/n", "<br><br>");
                document.getElementById("ucl-description").innerHTML = data.replace("/n", "<br><br>");
                document.getElementById("ucl-description-mobile").innerHTML = data.replace("/n", "<br><br>");
            }
        });
    }
    function SetUpUclDescription(ucls) {
        ucls.forEach(function (u) {
            $.ajax({
                url: "/api/GetGeoMapDescription?GeoMapId=" + u.GeographyMap.GeographyID + "&CouncilRegionId=" + u.Locality.CouncilRegionID,
                dataType: "json",
                type: "Get",
                success: function (data) {
                    console.log(data);
                }
            });
        });
    }
    Page.SetUpUclDescription = SetUpUclDescription;
    ;
    function GetDefaultUCLsMarkers(ucls) {
        pageUCLs = ucls;
        var latlngList = [];
        ucls.forEach(function (marker) {
            var markerLatlng = new google.maps.LatLng(marker.GeographyMap.CentralLatitude, marker.GeographyMap.CentralLongitude);
            latlngList.push(markerLatlng);
            new google.maps.Marker({
                position: markerLatlng,
                map: window.MapView,
                title: marker.Title,
                icon: {
                    url: '/_static/images/CommunityInfo/CommunityInfoIcon.svg',
                    scaledSize: new google.maps.Size(24, 32),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 16),
                }
            });
        });
        if (latlngList.length === 0) {
            // No UCLs, fit bounds around default location
            var center = window.Search.DefaultLatLng;
            var distanceInKm = Math.sqrt(20000);
            var latChange = distanceInKm / 111;
            var northEast = new google.maps.LatLng(center.lat() + latChange, center.lng() + latChange);
            var southWest = new google.maps.LatLng(center.lat() - latChange, center.lng() - latChange);
            var bounds = new google.maps.LatLngBounds(southWest, northEast);
            window.MapView.fitBounds(bounds);
        }
        else {
            // Fit bounds to UCLs
            var latlngbounds = new google.maps.LatLngBounds();
            latlngList.forEach(function (latlng) {
                latlngbounds.extend(latlng);
            });
            window.MapView.fitBounds(latlngbounds);
        }
    }
    Page.GetDefaultUCLsMarkers = GetDefaultUCLsMarkers;
    function RefreshMarkers() {
        window.Clusterer.clearMarkers();
        for (var i = 0; i < results.directoryMarkers.length; i++) {
            window.Clusterer.addMarker(results.directoryMarkers[i]);
        }
        for (var i = 0; i < results.diaryMarkers.length; i++) {
            window.Clusterer.addMarker(results.diaryMarkers[i]);
        }
    }
    function AddMarker(lat, lng, title, infoWindowContent, url) {
        //@ts-ignore
        var mcdIcon = {
            url: url,
            // This marker is 20 pixels wide by 32 pixels high.
            scaledSize: new google.maps.Size(24, 32),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(12, 32),
        };
        var latlng = new google.maps.LatLng(lat, lng);
        var marker = new google.maps.Marker({
            position: latlng,
            map: window.MapView,
            title: title,
            icon: mcdIcon
        });
        marker.addListener('click', function () {
            window.InfoWindow.setContent(infoWindowContent);
            window.InfoWindow.setOptions({ pixelOffset: new google.maps.Size(0, 0) });
            window.InfoWindow.open(window.MapView, marker);
            // Remove "Close" button of the info window on hover
            // https://stackoverflow.com/questions/55432957/remove-the-close-title-attribute-from-google-maps-custom-markers-infowindow
            google.maps.event.addListener(window.InfoWindow, 'domready', function () {
                jQuery(".gm-ui-hover-effect").attr('title', '');
            });
        });
        if (window.Spiderfier)
            window.Spiderfier.addMarker(marker);
        if (window.Clusterer)
            window.Clusterer.addMarker(marker);
        return marker;
    }
    function getPointToPointDirection(origin, destination, type, currentLocationInfoWindowContent) {
        if (origin.lat === destination.lat && origin.long === destination.long) {
            displayMyLocation(new google.maps.LatLng(origin.lat, origin.long), true, currentLocationInfoWindowContent);
            return;
        }
        if (!window.DirectionsDisplay) {
            window.DirectionsDisplay = new google.maps.DirectionsRenderer({
                draggable: true
            });
            window.DirectionsDisplay.setMap(window.MapView);
            window.DirectionsDisplay.setPanel(document.getElementById("directionsPanel"));
            window.DirectionsService = new google.maps.DirectionsService();
        }
        if (window.InfoWindow)
            window.InfoWindow.close();
        var request = {
            origin: new google.maps.LatLng(origin.lat, origin.long),
            destination: new google.maps.LatLng(destination.lat, destination.long),
            travelMode: type
        };
        refresh(); // should remove existing markers in the cluster so we can display A and B
        window.DirectionsDisplay.setMap(window.MapView);
        window.DirectionsService.route(request, function (result, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                $("a[href='#panelDirections']").click();
                $("#panelDirectionsFull").show();
                $("#panelDirectionsEmpty").hide();
                window.DirectionsDisplay.setDirections(result);
                function triggerAlert(e) {
                    e.preventDefault();
                    aria.Utils.AriaAlert("A new page will open for printing. For best result please ensure you enable Background images and colours if available. Once you have printed you may close the new page. Press enter to close the dialog");
                    setTimeout(function () {
                        alert('A new page will open for printing. For best result please ensure you enable Background images and colours if available. Once you have printed you may close the new page.');
                        window.open($(e.target).attr("href"));
                    }, 500);
                }
                $(".print-directions").off("click touchend").on("click touchend", function (e) {
                    triggerAlert(e);
                });
                $(".print-directions").off("keyup").on("keyup", function (e) {
                    if (e.which === 13) {
                        triggerAlert(e);
                    }
                });
                $(".print-directions").attr("href", "/Directory/PrintDirections.aspx?lat1=" + request.origin.lat() + "&lng1=" + request.origin.lng() + "&lat2=" + request.destination.lat() + "&lng2=" + request.destination.lng() + "&mode=" + type);
            }
        });
    }
    /**************************************/
    /* Advanced Search functions          */
    /**************************************/
    function queryStringToJSON() {
        if (location.search === "")
            return null;
        var pairs = location.search.slice(1).split('&');
        if (pairs.length === 0)
            return null;
        var result = {};
        pairs.forEach(function (item) {
            var pair = item.split('=');
            if (pair.length > 0) {
                result[pair[0].toLowerCase()] = decodeURIComponent(pair[1] || '');
            }
        });
        if (Object.keys(result).length === 0 && JSON.stringify(result) === JSON.stringify({})) {
            return null;
        }
        return JSON.parse(JSON.stringify(result));
    }
    function jsonToQueryString(obj) {
        var keyVal;
        var parentKey;
        var items = Object.keys(obj).map(function (key) {
            switch (key) {
                case "CategoryGroupID":
                case "CategoryID":
                case "Council":
                case "LocationID":
                    keyVal = obj[key];
                    if (!isNaN(keyVal) && parseInt(keyVal) > 0) {
                        return key.replace(/ID$/i, "") + '=' + keyVal;
                    }
                    break;
                case "AccreditationsAny":
                case "AccreditationsRequired":
                case "TagsAny":
                case "TagsRequired":
                case "WhatAny":
                case "WhatRequired":
                case "CategoryGroupsRequired":
                    parentKey = key.replace(/(Required|Any)$/i, "");
                    keyVal = obj[parentKey] || "";
                    if (keyVal !== "") {
                        return key + '=' + obj[key];
                    }
                    break;
                case "WheelchairAccess":
                case "IsGov":
                case "DgrStatus":
                case "Gender":
                case "ReferralRequired":
                case "FeeToAccess":
                    keyVal = obj[key] || "";
                    if (keyVal !== "" && keyVal !== "Any") {
                        return key + '=' + keyVal;
                    }
                    break;
                default:
                    keyVal = obj[key] || "";
                    if (keyVal !== "") {
                        return key + '=' + encodeURIComponent(keyVal);
                    }
                    break;
            }
            return null;
        });
        items = items.filter(function (e) {
            return !!e;
        });
        return items.join('&');
    }
    function getGroupValue(parent, multiple) {
        if (!multiple) {
            return $(parent + " button.active").data("value") || "";
        }
        else {
            var values = [];
            $(parent + " button.active").each(function (i, v) {
                values.push($(this).data("value") || "");
            });
            return values.join(",");
        }
    }
    function setGroupValue(parent, value) {
        var values = value.split(',');
        for (var i = 0; i < values.length; i++) {
            $(parent + " button[data-value='" + values[i] + "']").addClass("btn-blue active");
        }
    }
    function saveAdvancedSearch() {
        var thisSearch = new SearchData();
        thisSearch.ABN = $("#abn").val() || "";
        thisSearch.Accreditations = $("#accreditations").val() || "";
        $("#accreditations").val("");
        thisSearch.AccreditationsAny = getGroupValue("#accreditationAll", false) === "Any" ? "true" : "false";
        thisSearch.AccreditationsRequired = getGroupValue("#accreditationRequired", false) === "Required" ? "true" : "false";
        thisSearch.CategoryGroupID = $("#hfCategoryGroupId").val() || 0;
        thisSearch.Council = $("#hfCouncilId").val() || 0;
        thisSearch.DgrStatus = getGroupValue("#dgr", false);
        thisSearch.Email = $("#email").val() || "";
        thisSearch.EntityType = $("#entityType").val() || "";
        thisSearch.FeeToAccess = getGroupValue("#fees", true);
        thisSearch.LocationID = $("#hfLocationId").val() || 0;
        thisSearch.State = $("#hfStateCode").val() || "";
        thisSearch.Phone = $("#phone").val() || "";
        thisSearch.Radius = $("#radius").val() || 50;
        thisSearch.ReferralRequired = getGroupValue("#referral", false);
        thisSearch.CategoryID = $("#hfCategoryId").val() || 0;
        thisSearch.Gender = getGroupValue("#gender", false);
        thisSearch.Age = ($("#age").val() || "").replace(/\s+/g, "");
        thisSearch.IsGov = getGroupValue("#gov", false);
        thisSearch.Tags = $("#tags").val() || "";
        $("#tags").val('');
        thisSearch.TagsAny = getGroupValue("#tagsAny", false) === "Any" ? "true" : "false";
        thisSearch.TagsRequired = getGroupValue("#tagsRequired", false) === "Required" ? "true" : "false";
        thisSearch.Website = $("#website").val() || "";
        thisSearch.Where = $('#autocomplete-location').val() || "";
        thisSearch.What = $('#autocomplete-category').val() || "";
        thisSearch.WhatAny = getGroupValue("#whatAny", false) === "Any" ? "true" : "false";
        thisSearch.WhatRequired = getGroupValue("#whatRequired", false) === "Required" ? "true" : "false";
        thisSearch.WheelchairAccess = getGroupValue("#wheelchair", false);
        thisSearch.UseElasticOptimisation = getGroupValue("#elasticOptimisation", false) === "Enable" ? "true" : "false";
        thisSearch.CategoryGroups = $("#advancedCategory").val() || "";
        $("#advancedCategory").val("");
        thisSearch.CategoryGroupsRequired = getGroupValue("#categoryRequired", false) === "Required" ? "true" : "false";
        var searchType = getGroupValue("#whereBtns", false);
        switch (searchType) {
            case "All":
                thisSearch.Council = 0;
                thisSearch.State = "";
                thisSearch.Where = "";
                thisSearch.LocationID = 0;
                break;
            case "Directory":
                thisSearch.Where = "";
                thisSearch.LocationID = 0;
                break;
            case "Specified":
                thisSearch.Council = 0;
                thisSearch.State = "";
                break;
        }
        sessionStorage.setItem("SavedSearch", JSON.stringify(thisSearch));
        sessionStorage.setItem("SearchQuery", location.search);
        return thisSearch;
    }
    function getSearchValues(councilId) {
        var lastQuery = sessionStorage.getItem("SearchQuery");
        var savedSearch = new SearchData();
        var query = queryStringToJSON();
        if ((query === null) || (lastQuery === location.search)) {
            savedSearch = JSON.parse(sessionStorage.getItem("SavedSearch")) || new SearchData();
            query = {};
        }
        else {
            sessionStorage.setItem("SavedSearch", JSON.stringify({}));
        }
        var search = new SearchData();
        search.ABN = query.abn || savedSearch.ABN || "";
        search.Accreditations = query.accreditations || savedSearch.Accreditations || "";
        search.AccreditationsAny = query.accreditationsany || savedSearch.AccreditationsAny || "true";
        search.AccreditationsRequired = query.accreditationsrequired || savedSearch.AccreditationsRequired || "true";
        search.CategoryGroupID = query.category || savedSearch.CategoryGroupID || 0;
        search.Council = councilId; // We don't get this from the saved search or query string because it is calculated in the controller
        search.DgrStatus = query.dgrstatus || savedSearch.DgrStatus || "Any";
        search.Email = query.email || savedSearch.Email || "";
        search.EntityType = query.entitytype || savedSearch.EntityType || "";
        search.FeeToAccess = query.feetoaccess || savedSearch.FeeToAccess || "Any";
        search.LocationID = query.location || savedSearch.LocationID || 0;
        search.State = query.state || savedSearch.State || "";
        search.Phone = query.phone || savedSearch.Phone || "";
        search.Radius = query.radius || savedSearch.Radius || 50;
        search.ReferralRequired = query.referralrequired || savedSearch.ReferralRequired || "Any";
        search.CategoryID = query.service || savedSearch.CategoryID || 0;
        search.CategoryGroups = query.servicecategories || savedSearch.CategoryGroups || '';
        search.CategoryGroupsRequired = query.servicecategoriesrequired || savedSearch.CategoryGroupsRequired || "true";
        search.Tags = query.tags || savedSearch.Tags || "";
        search.TagsAny = query.tagsany || savedSearch.TagsAny || "true";
        search.TagsRequired = query.tagsrequired || savedSearch.TagsRequired || "true";
        search.Website = query.website || savedSearch.Website || "";
        search.What = query.what || savedSearch.What || "";
        search.WhatAny = query.whatany || savedSearch.WhatAny || "true";
        search.WhatRequired = query.whatrequired || savedSearch.WhatRequired || "true";
        search.WheelchairAccess = query.wheelchairaccess || savedSearch.WheelchairAccess || "Any";
        search.Age = query.age || savedSearch.Age || "";
        search.Gender = query.gender || savedSearch.Gender || "Any";
        search.IsGov = query.isgov || savedSearch.IsGov || "Any";
        search.Where = query.where || savedSearch.Where || "";
        search.UseElasticOptimisation = savedSearch.UseElasticOptimisation || query.useelasticoptimisation || "";
        return search;
    }
    function restoreAdvancedSearch(search, useElasticOptimisationDefault) {
        $("#abn").val(search.ABN);
        $("#accreditations").data("selectize-value", search.Accreditations);
        setGroupValue("#accreditationAll", search.AccreditationsAny === "true" ? "Any" : "All");
        setGroupValue("#accreditationRequired", search.AccreditationsRequired === "true" ? "Required" : "Prefer");
        $("#hfCategoryGroupId").val(search.CategoryGroupID);
        $("#hfCouncilId").val(search.Council);
        $("#hfStateCode").val(search.State);
        setGroupValue("#dgr", search.DgrStatus); //, "Any");
        $("#email").val(search.Email);
        $("#entityType").val(search.EntityType);
        setGroupValue("#fees", search.FeeToAccess);
        $("#hfLocationId").val(search.LocationID);
        $("#phone").val(search.Phone);
        $("#radius").val(search.Radius);
        setGroupValue("#referral", search.ReferralRequired);
        $("#hfCategoryId").val(search.Service);
        $("#advancedCategory").data("selectize-value", search.CategoryGroups);
        setGroupValue("#categoryRequired", search.CategoryGroupsRequired === "true" ? "Required" : "Prefer");
        $("#tags").data("selectize-value", search.Tags);
        setGroupValue("#tagsAny", search.TagsAny === "true" ? "Any" : "All");
        setGroupValue("#tagsRequired", search.TagsRequired === "true" ? "Required" : "Prefer");
        $("#website").val(search.Website);
        $('#autocomplete-category').val(search.What);
        setGroupValue("#whatAny", search.WhatAny === "true" ? "Any" : "All");
        setGroupValue("#whatRequired", search.WhatRequired === "true" ? "Required" : "Prefer");
        setGroupValue("#wheelchair", search.WheelchairAccess);
        setGroupValue("#gender", search.Gender);
        setGroupValue("#gov", search.IsGov);
        if (search.UseElasticOptimisation === "true" || search.UseElasticOptimisation === "false") {
            setGroupValue("#elasticOptimisation", search.UseElasticOptimisation === "true" ? "Enable" : "Disable");
        }
        else {
            setGroupValue("#elasticOptimisation", useElasticOptimisationDefault === "True" ? "Enable" : "Disable");
        }
        $('#age').val(search.Age);
        $('#autocomplete-location').val(search.Where);
        if ($("#autocomplete-location").val() === "" && parseInt($("#hfCouncilId").val()) > 0) {
            $("#btnDirectory").click();
        }
        $("#hintSelfAssessments").hide();
        $("#hintTags").hide();
    }
    function selectLocation() {
        $(this).addClass("btn-blue active");
        $(this).parent().siblings().children().removeClass("btn-blue active");
        if ($(this).hasClass("btn-location")) {
            $(this).closest(".row").next().slideDown();
        }
        else {
            $(this).closest(".row").next().slideUp();
        }
    }
    function selectOption() {
        $(this).addClass('btn-blue active');
        $(this).siblings(".btn").removeClass("btn-blue active");
        $(this).siblings("input").val($(this).text());
    }
    function selectSetOption() {
        var value = "";
        if ($(this).hasClass('active')) {
            $(this).removeClass('btn-blue active');
            if ($(this).siblings(".active").length === 0) {
                $(this).siblings(".answer-btn").addClass("btn-blue active");
            }
        }
        else {
            $(this).addClass('btn-blue active');
            value = $(this).text() + ";";
            $(this).siblings(".answer-btn").removeClass("btn-blue active");
        }
        for (var i = 0; i < $(this).siblings(".active").length; i++) {
            value += $(this).siblings(".active")[i].innerText + ";";
        }
        value = value.slice(0, -1);
        $(this).siblings("input").val(value);
    }
    /**************************************/
    function clearMap() {
        $(".map-lat").val(0);
        $(".map-lng").val(0);
        $(".map-latlng").empty();
        if (window.InfoWindow)
            window.InfoWindow.close();
    }
    function showGeocodeResults(place, status, address, geolocationCallback) {
        var addr = address;
        if (place.address_components) {
            if ((place.formatted_address || "").length > 0) {
                addr = place.formatted_address;
            }
            else {
                addr = [(place.address_components[0] && place.address_components[0].short_name || ''),
                    (place.address_components[1] && place.address_components[1].short_name || ''),
                    (place.address_components[2] && place.address_components[2].short_name || '')
                ].join(', ');
            }
            loadMapPlace(place, geolocationCallback);
            $('.map-edit-address').show();
        }
        else {
            $('.map-edit-address').hide();
        }
        markMap(place.geometry.location, '<div><strong>Your Location</strong></div>' + addr);
    }
    function markMap(latlng, content) {
        if (window.InfoWindow)
            window.InfoWindow.close();
        window.Marker.setVisible(false);
        saveLatLng(latlng);
        window.MapView.setCenter(latlng);
        window.MapView.setZoom(12);
        window.Marker.setPosition(latlng);
        window.Marker.setVisible(true);
        if (window.InfoWindow) {
            window.InfoWindow.setContent(content);
            window.InfoWindow.setPosition(latlng);
            window.InfoWindow.open(window.MapView, window.Marker);
        }
    }
    function setMapAddressReadonly(readonly) {
        $(".map-address1").prop("readonly", readonly).toggleClass("disabled", readonly);
        $(".map-address2").prop("readonly", readonly).toggleClass("disabled", readonly);
        $(".map-suburb").prop("readonly", readonly).toggleClass("disabled", readonly);
        $(".map-state").prop("readonly", readonly).toggleClass("disabled", readonly);
        $(".map-postcode").prop("readonly", readonly).toggleClass("disabled", readonly);
        if (readonly) {
            // Disable fields - reset button to Edit
            $(".map-edit-address").addClass("btn-success").text("Edit");
        }
        else {
            // Enable fields - set button to Undo
            $(".map-edit-address").removeClass("btn-success").text("Undo");
        }
    }
    //function clearMapAddress() {
    //	$(".map-search").val("");
    //	$(".map-address1").val("");
    //	$(".map-address2").val("");
    //	$(".map-suburb").val("");
    //	$(".map-state").val("");
    //	$(".map-postcode").val("");
    //}
    function loadMapPlace(place, geolocationCallback) {
        var su = '';
        var a1a = '';
        var a1b = '';
        var a1 = '';
        var a2 = '';
        var st = '';
        var pc = '';
        var sp = '';
        var blg = '';
        for (var i = 0; i < place.address_components.length; i++) {
            switch (place.address_components[i].types[0]) {
                case "floor":
                    blg = place.address_components[i].long_name;
                    break;
                case "establishment":
                    blg = place.address_components[i].long_name;
                    break;
                case "premise":
                    blg = place.address_components[i].long_name;
                    break;
                case "subpremise":
                    sp = place.address_components[i].long_name;
                    break;
                case "street_address":
                    a1 = place.address_components[i].long_name;
                    break;
                case "street_number":
                    a1a = place.address_components[i].long_name;
                    break;
                case "route":
                    a1b = place.address_components[i].long_name;
                    break;
                case "locality":
                    su = place.address_components[i].long_name;
                    break;
                case "administrative_area_level_1":
                    st = place.address_components[i].short_name;
                    break;
                case "postal_code":
                    pc = place.address_components[i].short_name;
                    break;
                default:
                    break;
            }
        }
        saveLatLng(place.geometry.location);
        if (a1.length === 0)
            a1 = $.trim(a1a + ' ' + a1b);
        if (a1.length > 0 || su.length > 0) {
            if (sp.length > 0) {
                if (/^\d+[a-zA-Z]?$/.test(sp)) {
                    a1 = sp + "/" + a1;
                    sp = '';
                }
                else if (blg.length === 0) {
                    blg = sp;
                }
            }
            if (blg.length === 0 && place.name && place.types &&
                place.types[0] !== "street_address" && $.inArray("street_address", place.types) >= 0) {
                blg = place.name;
            }
            $(".map-search").val(place.formatted_address);
            $(".map-building").val($.trim(blg) || "");
            $(".map-address1").val($.trim(a1) || " ");
            $(".map-address2").val($.trim(a2) || " ");
            $(".map-suburb").val($.trim(su) || " ");
            $(".map-state").val($.trim(st) || " ");
            $(".map-postcode").val($.trim(pc) || " ");
            setMapAddressReadonly(true);
            if (geolocationCallback) {
                geolocationCallback();
            }
        }
    }
    function saveLatLng(latlng) {
        $(".map-lat").val(latlng.lat());
        $(".map-lng").val(latlng.lng());
        $(".map-latlng").html("Lat / Lng : " + latlng.lat() + " / " + latlng.lng());
    }
    function geocodeLatLng(latlng) {
        window.Geocoder.geocode({
            location: latlng
        }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                showGeocodeResults(results[0], status, '');
            }
            else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
    function drawMap(mapName, geolocationCallback) {
        if (!$(mapName).length) {
            return;
        }
        var lat = $(mapName).data("lat");
        var lng = $(mapName).data("lng");
        var showMap = $(mapName).data("showmap") || true;
        var showMarker = $(mapName).data("showmarker");
        var showAddress = $(mapName).data("showaddress");
        var html = $(mapName).data("html");
        var isStatic = $(mapName).data("static") || false;
        var zoom = $(mapName).data("zoom") || 14;
        var kml = $(mapName).data("kml") || '';
        if (!showMap)
            return;
        window.MapView = createMapPanel(mapName, lat, lng, zoom, isStatic);
        if (kml) {
            window.KmlLayer = new google.maps.KmlLayer({
                url: kml,
                suppressInfoWindows: true,
                clickable: false,
                map: window.MapView
            });
        }
        else {
            if (showMarker) {
                window.Marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: window.MapView,
                    icon: "/_static/images/map_marker.png",
                    html: html
                });
                window.InfoWindow = new google.maps.InfoWindow();
                if (html !== '') {
                    google.maps.event.addListener(window.Marker, 'click', function () {
                        window.InfoWindow.setContent(this.html);
                        window.InfoWindow.open(window.MapView, this);
                    });
                }
            }
            if (showAddress) {
                window.Geocoder = new google.maps.Geocoder();
                window.Marker = new google.maps.Marker({
                    map: window.MapView,
                    position: null
                });
                var input = $(".map-address").get(0);
                window.Autocomplete = new google.maps.places.Autocomplete(input, {
                    componentRestrictions: {
                        country: 'au'
                    }
                });
                window.Autocomplete.bindTo("bounds", window.MapView);
                google.maps.event.addListener(window.MapView, 'click', function (event) {
                    geocodeLatLng(event.latLng);
                });
                google.maps.event.addListener(window.Autocomplete, 'place_changed', function () {
                    clearMap();
                    var place = window.Autocomplete.getPlace();
                    if (!place || !place.geometry)
                        return;
                    if (place.geometry.viewport) {
                        window.MapView.fitBounds(place.geometry.viewport);
                    }
                    else {
                        window.MapView.setCenter(place.geometry.location);
                    }
                    showGeocodeResults(place, google.maps.GeocoderStatus.OK, '', geolocationCallback);
                });
            }
        }
    }
    function createMapPanel(mapName, centerLat, centerLng, zoom, isStatic) {
        if (!(centerLat || centerLng)) {
            centerLat = -27.4984;
            centerLng = 152.9712;
        }
        var mapContainer = $(mapName);
        var MY_MAPTYPE_ID = 'custom_style';
        var location = new google.maps.LatLng(centerLat, centerLng);
        var mapOptions;
        mapOptions = {
            zoom: zoom || 14,
            //center: location,
            mapTypeControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
            },
            mapTypeId: MY_MAPTYPE_ID
        };
        if (isStatic) {
            mapOptions = {
                zoom: zoom || 14,
                center: location,
                mapTypeControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                },
                mapTypeId: MY_MAPTYPE_ID,
                disableDefaultUI: true,
                disableDoubleClickZoom: true,
                scrollwheel: false,
                draggable: false
            };
        }
        var map = new google.maps.Map(mapContainer[0], mapOptions);
        var styledMapOptions = {
            name: 'Style'
        };
        if (mapName === "#council-ucl-map" || mapName === "#amc-map-ucl") {
            var customMapType = new google.maps.StyledMapType([
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#d3d3d3',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    stylers: [
                        {
                            color: '#808080',
                        },
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#b3b3b3',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#ffffff',
                        },
                        {
                            weight: 1.8,
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d7d7d7',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                        {
                            color: '#ebebeb',
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [
                        { visibility: "off" }
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#a7a7a7',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#efefef',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#696969',
                        },
                    ],
                },
                {
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#737373',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d6d6d6',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {},
                {
                    featureType: 'poi',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#dadada',
                        },
                    ],
                },
            ], styledMapOptions);
            map.mapTypes.set(MY_MAPTYPE_ID, customMapType);
            return map;
        }
        var customMapType = new google.maps.StyledMapType(Common.Map.GetStandardMapStyle(), styledMapOptions);
        map.mapTypes.set(MY_MAPTYPE_ID, customMapType);
        return map;
    }
    // Map for the Item Listing page
    function loadMap(mapName, results, showResourceList, searchCenter) {
        window.MapView = createMapPanel(mapName);
        window.Bounds = new google.maps.LatLngBounds();
        var i;
        // Clear out any existing map markers
        if (typeof window.Markers !== 'undefined') {
            for (i = 0; i < window.Markers.length; i++) {
                window.Markers[i].setMap(null);
            }
        }
        window.Markers = [];
        window.InfoWindow = new google.maps.InfoWindow({});
        // Clear out the council map if used.
        if (typeof window.CouncilLayer !== 'undefined') {
            window.CouncilLayer.setMap(window.MapView);
        }
        var markerHandler = function () {
            window.InfoWindow.setContent(this.html);
            window.InfoWindow.open(window.MapView, this);
        };
        for (i = 0; i < results.length; i++) {
            // An example marker
            var listing = results[i];
            var html = "<div class='google-result'><div class='contact-details'>";
            if (showResourceList) {
                var phone = listing.Outlet.Phone || "";
                var pstripped = phone.replace(/[^0-9]+/g, "");
                if (pstripped.length > 0) {
                    html += "<p class='icon icon-phone60'><a href='tel:" + pstripped + "'>" + phone + "</a></p>";
                }
                else if (phone.substr(0, 2) === "--") {
                    html += "<p class='icon icon-phone60'>" + value + "</p>";
                }
                var value = listing.Outlet.DisplayAddress || "";
                var inner = "--not supplied--";
                if (value.length > 0) {
                    if (value.substr(0, 2) === "--") {
                        inner = value;
                    }
                    else {
                        inner = "<a href='https://maps.google.com/?q=" + encodeURIComponent(value) + "' target='_blank'>" + value + "</a>";
                    }
                }
                html += "<p class='icon icon-map15'>" + inner + "</p>";
            }
            else {
                html += "<p class='icon icon-phone60'><a href='" + listing.Url + "' class='btn btn-small btn-blue'>Contact Us</a></p>";
                html += "<p class='icon icon-map15'>" + listing.Outlet.Suburb + "</p>";
            }
            if (searchCenter !== 'undefined' && searchCenter !== '') {
                html += "<p class='icon icon-podcast distance'>" + listing.Distance + " from the centre of " + searchCenter + "</p>";
            }
            html += "</div></div>";
            if (listing.Outlet.MapLocation.ShowMarker) {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(listing.Outlet.MapLocation.Lat, listing.Outlet.MapLocation.Lng),
                    map: window.MapView,
                    icon: "/_static/images/map_marker.png",
                    html: "<h3 class=\"h5 orange\"><a href=\"" + listing.Url + "\">" + listing.Outlet.Nickname + "</a></h3>" + html
                });
                window.Bounds.extend(marker.getPosition());
                google.maps.event.addListener(marker, 'click', markerHandler);
                window.Markers[window.Markers.length] = marker;
            }
        }
        if (window.Markers.length === 0) {
            if (window.CurrentCouncil) {
                window.CouncilLayer = new google.maps.KmlLayer({
                    url: window.CurrentCouncil.KmlLocation
                });
                window.CouncilLayer.setMap(window.MapView);
            }
        }
        else {
            Common.Map.FitMapBounds(window.MapView, window.Bounds);
        }
    }
    function displayResults(data, performKeyWordSearch, showResourceList) {
        aria.Utils.AriaAlert("Showing search results", 2);
        Common.SetupConverters();
        var resultsWithAds = data.Results;
        // Don't modify incoming array
        if (data.AdResults.length > 0 && data.Results.length >= 1) {
            // Merge ad into list of results
            resultsWithAds = data.Results.slice(0, data.Results.length);
            for (var i = 0; i < data.AdResults.length; i++) {
                resultsWithAds.splice(i + 1, 0, data.AdResults[i]);
            }
            $("#categoryAds").html($("#categoryAdTemplate").render(data.AdResults));
        }
        var combinedResults = performKeyWordSearch ? data.KeywordSearchResults.concat(resultsWithAds) : resultsWithAds;
        var results = $("#resultsTemplate").render(combinedResults, {
            criteria: data.Criteria || {}
        });
        var $results = $("<div/>").html(results);
        $(".nofollow", $results).removeAttr("rel");
        results = $results.html();
        $("#results").html(results);
        $("#results").attr("aria-rowcount", $("#results .search-result").length);
        if (data.Criteria.ForceExpandSearch && data.Results.length > 0) {
            $(".section-search-listing:not(.organisation) .expanded-listings").show();
        }
        else if (data.Results.length < 10) {
            $(".section-search-listing:not(.organisation) .low-listings").show();
        }
        Common.Map.LoadMapMarkers("#search-map", data.Results, showResourceList, data.Criteria.Where);
        if (data.Results.length === 0) {
            //$(".view-toggles").hide();
            if (data.KeywordSearchResults.length !== 0) {
                // Add a little space between keyword search results and expand your search area
                $(".extend-your-search").prepend("<div style='margin-top:30px;'/>");
            }
        }
    }
    function displayResultsPagination(crit, loggedIn, pageResults, totalPages, pageSize, favouriteModalUrl, showExpandSearch) {
        var pageLinks = '';
        var pageNo = crit.PageNo;
        var numberOfPages = Math.floor(totalPages / pageSize);
        if (totalPages % pageSize > 0)
            numberOfPages++;
        if (numberOfPages <= 1 || typeof pageNo === "undefined") {
            $(".mcd-pagination").hide();
            $(".search-expand").toggleClass("margin-top-30", pageResults > 0);
            return;
        }
        var startPage = 1;
        var endPage = numberOfPages;
        var maxDisplayPages = 11;
        if (numberOfPages > maxDisplayPages) {
            startPage = pageNo - Math.floor((maxDisplayPages - 1) / 2);
            if (startPage <= 0)
                startPage = 1;
            endPage = startPage + maxDisplayPages;
            if (endPage > numberOfPages) {
                endPage = numberOfPages;
                startPage = endPage - maxDisplayPages;
            }
        }
        if (pageNo > 1) {
            if (pageNo > numberOfPages) {
                pageLinks += '<a data-page="' + numberOfPages + '" class="pickPage previous" tabindex="0" aria-label="See previous page of results">Previous</a>';
            }
            else {
                pageLinks += '<a data-page="' + (pageNo - 1) + '" class="pickPage previous" tabindex="0" aria-label="See previous page of results">Previous</a>';
            }
        }
        if (startPage > 1) {
            pageLinks += '<a data-page="1" class="number pickPage" tabindex="0" aria-label="Show results (page 1 of ' + numberOfPages + '">1</a> ... ';
        }
        for (var i = startPage; i <= endPage; i++) {
            pageLinks += '<a data-page="' + i + '" class="number ' + (i === pageNo ? 'current' : 'pickPage') + '" tabindex="0" aria-label="' + (i === pageNo ? 'Page ' + i + ' of ' + numberOfPages : ' Show results (page ' + i + ' of ' + numberOfPages + ')') + '">' + i + '</a>';
        }
        if (endPage < numberOfPages) {
            pageLinks += ' ... <a data-page="' + numberOfPages + '" class="number pickPage" tabindex="0" aria-label="Show results (page ' + numberOfPages + ' of ' + numberOfPages + ')">' + numberOfPages + '</a>';
        }
        if (numberOfPages > pageNo) {
            pageLinks += '<a data-page="' + (pageNo + 1) + '" class="pickPage next" tabindex="0" aria-label="See next page of results">Next</a>';
        }
        var pages;
        if (pageNo > numberOfPages) {
            pages = '<p tabindex="0">Beyond the ' + numberOfPages + ' pages of results</p>';
        }
        else {
            pages = '<p tabindex="0">Page ' + pageNo + ' of ' + numberOfPages + '</p>';
        }
        pages += '<div class="pagination-links">' + pageLinks + '</div>';
        if (showExpandSearch) {
            if (/(bot|crawler|crawling|spider|robot|slurp)\b/i.test(navigator.userAgent)) {
                // Always disable for bots
                $(".btn-expand-search").hide();
            }
            else {
                $(".btn-expand-search").show();
            }
        }
        else {
            $(".btn-expand-search").hide();
        }
        $(".search-expand").removeClass("margin-top-30").show();
        $('.mcd-pagination').html(pages).show();
        $(".mcd-pagination .pickPage").on("click", function (e) {
            e.preventDefault();
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            crit.PageNo = $(this).data("page");
            //if (ga) {
            //ga('send', 'event', 'button', 'click', 'page', crit.PageNo);
            //}
            Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn);
        });
        if (window.history && window.history.pushState && crit.OrigUrl && crit.OrigParams) {
            var newParams = jQuery.extend({}, crit.OrigParams);
            newParams.PageNo = crit.PageNo;
            var str = [];
            for (var p in newParams) {
                if (newParams.hasOwnProperty(p)) {
                    str.push(p + "=" + newParams[p]);
                }
            }
            var newUrl = crit.OrigUrl + "?" + str.join("&");
            window.history.pushState(jQuery.extend({}, crit), (crit.OrigTitle || "") + " (page " + crit.PageNo + ")", newUrl);
        }
    }
    function displayOtherResultsSummary(data) {
        var summary = "<strong>No Result</strong>";
        if (data.Criteria.Council.CouncilRegionID > 0) {
            summary += " in the " + data.Criteria.Council.DisplayNameCouncil + " region";
        }
        else {
            if (data.Criteria.AffiliateSite.Loaded) {
                summary += " in the " + data.Criteria.AffiliateSite.Name + " region";
            }
        }
        summary += "</br>However, we found a few results which might be close to the region ";
        $(".search-summary").html(summary);
        $(".advanced-search-btn").on('click touchend', function (e) {
            e.preventDefault();
            var tempUrl = "/Search/Advanced" + location.search;
            window.location.href = tempUrl;
        });
    }
    function displayResultsSummary(data) {
        var summary = "<strong>" + Common.AddCommas(data.Total) + " Result" + (data.Total === 1 ? "" : "s") + "</strong> for ";
        if (data.Criteria.CategoryGroup.ID === 0 && data.Criteria.Category.ID === 0) {
            if (data.Criteria.What === '' || data.Criteria.Locality.LocalityID === 0) {
                summary += "everything ";
            }
            else {
                summary += "'" + data.Criteria.What + "' ";
            }
        }
        else {
            if (data.Criteria.Category.ID === 0) {
                summary += "All " + data.Criteria.CategoryGroup.Name + " ";
            }
            else {
                summary += data.Criteria.Category.Name + " ";
            }
        }
        if (data.Criteria.Locality.LocalityID === 0) {
            // If has council ID, not showing where text in summary
            if (data.Criteria.Where !== '' && data.Criteria.Council.CouncilRegionID === 0) {
                summary += data.Criteria.Radius + "km from " + data.Criteria.Where;
            }
        }
        else {
            summary += data.Criteria.Radius + "km from " + data.Criteria.Locality.Name;
        }
        if (data.Criteria.Council.CouncilRegionID > 0) {
            summary += " in the " + data.Criteria.Council.DisplayNameCouncil + " region";
        }
        else {
            if (data.Criteria.AffiliateSite.Loaded) {
                summary += " in the " + data.Criteria.AffiliateSite.Name + " region";
            }
        }
        if (data.Criteria.IsAdvanced) {
            summary += " <i>with <a href='#' class='advanced-search-btn'>advanced criteria</a><i>";
        }
        $(".search-summary").html(summary);
        $(".advanced-search-btn").on('click touchend', function (e) {
            e.preventDefault();
            var tempUrl = "/Search/Advanced" + location.search;
            window.location.href = tempUrl;
        });
    }
    function displayExtraInformation() {
        $(".next-appt").each(function (i, element) {
            var outletId = $(this).data("outlet-id");
            var listingId = $(this).data("listing-id");
            var healthEngineId = $(this).data("healthengine-id");
            var healthEngineStatus = $(this).data("healthengine-status") || "-";
            if (outletId && healthEngineId) {
                $.getJSON("/api/Outlets/GetNextBooking/" + outletId + "/" + listingId + "/" + healthEngineId + "/" + healthEngineStatus, function (data) {
                    if (data && data.OutletID) {
                        $(element).html($("#nextAppointmentTemplate").render(data));
                    }
                    else {
                        $(element).hide();
                    }
                });
            }
            //if (bookingType && appointmentUrl) {
            //    console.log(appointmentUrl)
            //    $(element).html($("#bookingTemplate").render(appointmentUrl));
            //}
        });
        $(".book-appt").each(function (i, element) {
            var bookingType = $(this).data("booking-type");
            var appointmentUrl = $(this).data("booking-url");
            var backgroundColor = (appointmentUrl.includes('healthengine')) ? "#0176be" : "#d14905";
            var display = (appointmentUrl.includes('healthengine')) ? "block" : "none";
            if (appointmentUrl) {
                $(element).html($("#bookingTemplate").render({
                    appointmentUrl: appointmentUrl,
                    bookingType: bookingType,
                    backgroundColor: backgroundColor,
                    display: display
                }));
            }
            else {
                $(element).hide();
            }
        });
        var ids = [];
        $(".badges-search").each(function () {
            var id = $(this).data("id");
            if (id) {
                ids.push(id);
            }
        });
        if (ids.length > 0) {
            $.ajax({
                url: "/api/Search/GetServiceBadges",
                data: {
                    ids: ids
                },
                dataType: "json",
                type: "POST",
                success: function (data) {
                    $(".badges-search").each(function () {
                        var id = $(this).data("id");
                        if (id && data[id]) {
                            var template = $("#badgesTemplate").render(data[id]);
                            var $template = $("<div/>").html(template);
                            $(".nofollow", $template).removeAttr("rel");
                            template = $template.html();
                            $(this).html(template);
                        }
                        else {
                            $(this).hide();
                        }
                    });
                }
            });
        }
    }
    function loadNearby(outletId, orgId, pageNumber) {
        $(".nearby-locations .loadMore").remove();
        $(".nearby-locations .processing").show();
        $.getJSON("/api/Outlets/Nearby/" + outletId + "/" + pageNumber, function (data) {
            $(".nearby-locations .processing").remove();
            if (data.Results.length !== 0) {
                $(".nearby-locations-content .placeholder").replaceWith("" + $("#nearbyTemplate").render(data));
            }
        });
    }
    function drawOrgChart(data) {
        var formatter = new google.visualization.NumberFormat({
            pattern: '###,###'
        });
        formatter.format(data, 1);
        var options = {
            height: 300,
            //width: '100%',
            chartArea: {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%"
            }
        };
        var chart = new google.visualization.PieChart(document.getElementById('orgtypes'));
        chart.draw(data, options);
    }
    function drawOrgMap(data) {
        var formatter = new google.visualization.NumberFormat({
            pattern: '###,###'
        });
        formatter.format(data, 2);
        var options = {
            region: "AU",
            dataMode: "markers"
        };
        var chart = new google.visualization.GeoMap(document.getElementById('orgmap'));
        chart.draw(data, options);
    }
    function drawServiceChart(data) {
        var formatter = new google.visualization.NumberFormat({
            pattern: '###,###'
        });
        formatter.format(data, 1);
        var options = {
            height: 300,
            //width: '100%',
            chartArea: {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%"
            }
        };
        var chart = new google.visualization.PieChart(document.getElementById('servicetypes'));
        chart.draw(data, options);
    }
    function showRemaining(control, maxlength, limitcontrol) {
        var setLimit = function () {
            var l = ($(control).val() || "").length;
            var left = (maxlength - l);
            if (left < 0)
                left = 0;
            $(limitcontrol).text(left + ' characters left');
        };
        $(control).on('keyup', setLimit);
        setLimit();
    }
    var _pendingAbn = false;
    function getAbnDetails(abn, onSuccess) {
        if ((abn || "").length === 0 || abn === "N/A")
            return;
        _pendingAbn = true;
        clearMatchedOrgs();
        $('.org-unregisteredname').hide();
        $('.org-registerednames').show().data("shown", true);
        $('.org-spinner').show();
        $.ajax({
            url: '/api/Outlets/AbnValidation',
            data: JSON.stringify({
                Abn: abn
            }),
            dataType: "json",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                var tradingNames = $('.org-validated-tradingnames');
                tradingNames.empty();
                if (data.ABNFound) {
                    $('.org-entered-abn').val(data.ABN);
                    $('.org-validated-abn').val(data.ABN);
                    $('.org-validated-legalname').val(data.LegalName);
                    if (data.AvailableTradingNames.length === 0) {
                        tradingNames.append($("<option />", {
                            value: '',
                            text: " -- none listed -- "
                        }));
                        tradingNames.val('');
                        tradingNames.attr("readonly", "readonly");
                    }
                    else {
                        //don't forget error handling!
                        for (var i = 0; i < data.AvailableTradingNames.length; i++) {
                            var name = data.AvailableTradingNames[i];
                            tradingNames.append($("<option />", {
                                value: name,
                                text: name
                            }));
                        }
                        tradingNames.val(data.TradingName);
                        tradingNames.removeAttr("readonly");
                    }
                    $('.org-validated-entitytype').val(data.EntityType);
                    $('.org-validated-gstreg').prop("checked", data.GSTRegistered);
                    $('.org-validated-dgrstatus').prop("checked", data.DGRStatus);
                    $('.org-validated-charity').prop("checked", data.RegisteredCharity);
                    $('.org-preferredname').val(data.TradingName === '' ? data.LegalName : data.TradingName);
                    $('.org-preferredname').removeAttr("readonly");
                    if (onSuccess)
                        onSuccess(data);
                }
                else {
                    $('.org-validated-abn').val("");
                    $('.org-validated-legalname').val('');
                    tradingNames.append($("<option />", {
                        value: '',
                        text: " -- none listed --"
                    }));
                    tradingNames.val('');
                    tradingNames.attr("readonly", "readonly");
                    $('.org-validated-entitytype').val('');
                    $('.org-validated-gstreg').prop("checked", false);
                    $('.org-validated-dgrstatus').prop("checked", false);
                    $('.org-validated-charity').prop("checked", false);
                    $('.org-preferredname').val('');
                    $('.org-preferredname').attr("readonly", "readonly");
                }
                getMatchedOrgs();
            },
            complete: function () {
                _pendingAbn = false;
                $('.org-spinner').hide();
                $('.org-entered-abn').valid();
            }
        });
    }
    function showFoundOrgs(orgs) {
        var found = false;
        if (orgs.length && orgs.length > 0) {
            var html = "";
            for (var orgNum = 0; orgNum < orgs.length; orgNum++) {
                var org = orgs[orgNum];
                var orgName = org.DisplayName;
                var orgId = org.OrganisationID;
                var numOutlets = org.Outlets.length;
                $(".org-matched-select").append($("<option />").val(orgId).text(orgName));
                html += "<div style=\"padding-left: 10px;\">";
                html += "<p class=\"small\" style=\"margin-bottom:0;\"><strong>" + orgName + "</strong></p>";
                if (numOutlets > 0) {
                    html += "<p class=\"small\" style=\"margin-bottom:0;\">With the following outlet" + (numOutlets > 1 ? "s" : "") + ":</p><ul>";
                    for (var a = 0; a < numOutlets; a++) {
                        html += "<li class=\"small\" >" + org.Outlets[a].Nickname + ", " + org.Outlets[a].Suburb + "</li>";
                    }
                    html += "</ul>";
                }
                html += "</div>";
                if (orgs.length === 1) {
                    $(".org-matched-select").val(orgId);
                }
            }
            $('.org-existing-selection').hide();
            $(".org-matched-info").html(html);
            $(".org-matched-is-listed").prop('checked', false);
            found = true;
        }
        $(".org-matched").toggle(found);
    }
    function clearMatchedOrgs() {
        $("org-matched-list").empty();
        $(".org-matched-select").html("<option value=''>Choose an organisation ...</option>").val("");
        $('.org-matched').hide();
    }
    function getMatchedOrgs() {
        var newAbn = $('.org-validated-abn').val();
        var newName = $('.org-tradingnames-unverified').val();
        $('.org-matched-select').val("");
        if ($('.org-noabn').is(':checked')) {
            newAbn = "";
            if (newName.length < 3) {
                $.msgGrowl({
                    type: 'error',
                    title: 'Name Invalid',
                    position: 'bottom-right',
                    text: 'You must enter in a name with 3 or more characters.'
                });
                return;
            }
        }
        else
            newName = "";
        $.ajax({
            type: "POST",
            url: "/api/Outlets/FindOrganisations",
            data: JSON.stringify({
                Abn: newAbn,
                TradingName: newName
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                showFoundOrgs(data);
            }
        });
    }
    function addAbnValidation() {
        $.validator.addMethod("abn", function (value, element) {
            if ($(".org-noabn").is("checked")) {
                return true;
            }
            if (_pendingAbn)
                return "pending";
            var validatedAbn = $(".org-validated-abn").val();
            return this.optional(element) || value === "N/A" || ((validatedAbn || "").length > 0 && value === validatedAbn);
        }, "Please enter a valid ABN.");
    }
    function initHtmlEditor(control) {
        CKEDITOR.replace(control, {
            removeButtons: "Source,About",
            removePlugins: "elementspath",
            height: "300px",
            enterMode: CKEDITOR.ENTER_P,
            htmlEncodeOutput: true
        });
    }
    function initPasswordStrength() {
        var popoverOptions = {
            html: true,
            content: "<div class='popover-verdict'>" +
                "   <div><strong>Password strength:</strong> <span id='password-verdict'>Invalid</span>" +
                "</div>" +
                "<div id='password-strength'>" +
                "   <div class='progress'></div>" +
                "</div>" +
                "<p>Use at least 6 characters without spaces. To protect your data we recommend choosing a strong password.</p>",
            template: "<div class='popover password-tip' role='tooltip'>" +
                "   <div class='arrow'></div>" +
                "   <div class='popover-content'></div>" +
                "</div>",
            placement: function () {
                return $(window).width() < 900 ? "top" : "right";
            },
            trigger: "click hover focus"
        };
        $("#Password").popover(popoverOptions);
        var options = {};
        options["common"] = {
            usernameField: "#password-ignore",
            zxcvbn: true // https://blogs.dropbox.com/tech/2012/04/zxcvbn-realistic-password-strength-estimation/
        };
        options["ui"] = {
            viewports: {
                progress: "#password-strength",
                verdict: "#password-verdict" // override where password verdict is shown
            }
        };
        var pwInitialised = false;
        $("#Password").off("shown.bs.popover").on("shown.bs.popover", function () {
            $("#Password").off("keyup click").on("keyup click", function () {
                if (pwInitialised && !$("#Password").valid()) {
                    pwInitialised = false;
                    $("#Password").pwstrength("destroy");
                    $("#password-strength").append($("<div>").addClass("progress"));
                    $("#password-verdict").html("Not valid");
                }
                else if (!pwInitialised) {
                    pwInitialised = true;
                    $("#password-strength .progress").remove();
                    $("#password-verdict").html("");
                    $("#Password").pwstrength(options);
                }
            });
        });
        $("#Password").off("hide.bs.popover").on("hide.bs.popover", function () {
            if (pwInitialised) {
                pwInitialised = false;
                $("#Password").pwstrength("destroy");
                $("#password-strength").append($("<div>").addClass("progress"));
                $("#password-verdict").html("Not valid");
            }
        });
    }
    function setupCommentNotificationsDefaults() {
        $.notifyDefaults({
            delay: 5000,
            timer: 500,
            allow_dismiss: true,
            newest_on_top: true,
            mouse_over: 'pause',
            template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                '<span data-notify="icon"></span>' +
                '<div class="content"><span data-notify="title">{1}</span>' +
                '<span data-notify="message">{2}</span></div>' +
                '<div class="progress" data-notify="progressbar">' +
                '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div>' +
                '</div>'
        });
    }
    function showLoadingComments() {
        $("#comments-processing").show();
        $("#comments-error").hide();
        $("#more-comments").attr("disabled", "disabled");
        $("#comments").addClass("opaque");
        var i = 0;
        var text = "loading comments";
        setInterval(function () {
            $("#loading").html(text + Array((++i % 4) + 1).join("."));
        }, 500);
        // hide all existing tooltips
        var tooltips = $(".qtip");
        if (tooltips.length > 0) {
            tooltips.each(function () {
                $(this).qtip("api").toggle(false);
            });
        }
    }
    function finishLoadingComments() {
        $("#comments-processing").hide();
        $("#comments").removeClass("opaque");
    }
    function showEditComment(commentId) {
        $("#comment-" + commentId + " .comment-text").hide();
        $("#comment-" + commentId + " .comment-flags").hide();
        $("#comment-" + commentId + " .edit-comment").show();
        $("#comment-" + commentId + " textarea").focus();
        $("#comment-" + commentId + " .edit-comment-flags input").bootstrapToggle();
    }
    function hideEditComment(commentId) {
        $("#comment-" + commentId + " .edit-comment").hide();
        $("#comment-" + commentId + " .comment-flags").show();
        $("#comment-" + commentId + " .comment-text").show();
    }
    function updateComment(target, orgCommentsUrl) {
        var commentId = target.data("comment");
        target.attr("disabled", "disabled");
        showLoadingComments();
        hideEditComment(commentId);
        setupCommentNotificationsDefaults();
        var selectedFlags = $.makeArray($("input:checked", target.closest(".panel")).map(function () {
            return $(this).data("value");
        }));
        var model = {
            Id: commentId,
            UpdatedComment: $("#comment-" + commentId + " textarea").val(),
            CommentFlags: selectedFlags.join(",")
        };
        // only send back if data changed
        var original = $("#comment-" + commentId + " textarea").data("original");
        var flags = $("#comment-" + commentId + " textarea").data("flags");
        if (model.UpdatedComment !== original || model.CommentFlags !== flags) {
            $.ajax({
                type: "POST",
                url: window.AppSettings.ApiUrl + "/api/v1/organisationcomments/save",
                data: JSON.stringify(model),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    var hasError = false;
                    for (var i = 0; i < data.length; i++) {
                        var result = data[i];
                        if (!result.Success) {
                            $.notify({
                                title: "Ooops",
                                message: result.Message,
                                icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "warning"
                            });
                            hasError = true;
                        }
                        else {
                            $.notify({
                                title: "Success",
                                message: "Successfully saved comment ",
                                icon: "glyphicon glyphicon-info-sign"
                            });
                        }
                    }
                    if (!hasError) {
                        reloadComments(1, orgCommentsUrl, "#comment-text");
                        target.data("original", model.UpdatedComment);
                        target.data("flags", model.CommentFlags);
                    }
                },
                error: function () {
                    $.notify({
                        title: "Dang It",
                        message: "There was an error trying to update this comment.",
                        icon: "glyphicon glyphicon-remove-circle"
                    }, {
                        type: "danger"
                    });
                },
                complete: function () {
                    target.removeAttr("disabled");
                    finishLoadingComments();
                }
            });
        }
        else {
            target.removeAttr("disabled");
            finishLoadingComments();
        }
    }
    function reloadComments(pageNumber, orgCommentsUrl, focusedSelector) {
        showLoadingComments();
        $.ajax({
            type: "GET",
            cache: false,
            url: orgCommentsUrl.replace("{pageNumber}", pageNumber.toString()),
            success: function (data) {
                var template = $("#organisationCommentsTemplate").render(data);
                var $template = $("<div/>").html(template);
                $(".nofollow", $template).removeAttr("rel");
                template = $template.html();
                $("#comments").html(pageNumber > 1 ? $("#comments").html() + template : template);
                // reset existing tooltips
                $("#comments [data-hasqtip]").each(function () {
                    $(this).attr("title", $(this).attr("oldtitle"));
                });
                Common.SetupTooltipsStyling();
                $("#more-comments").removeAttr("disabled");
                $("#more-comments").data("page-number", pageNumber);
                $("#more-comments").toggle(data.CanShowMoreResults);
                $("#comments").attr("aria-rowcount", $("#comments .panel").length);
                if (data.OrganisationComments.length > 0) {
                    setupSearchResultsAria(document.getElementById("comments"), focusedSelector);
                }
                var isDragging = false;
                // detect clicks outside of edit comment box -- resize needs to be detected here
                $(document).on("mouseup", function (e) {
                    var wasDragging = isDragging;
                    isDragging = false;
                    var editVisible = $(".edit-comment:visible");
                    if (editVisible.length === 0 || wasDragging) {
                        return;
                    }
                    var commentId = editVisible.data("comment");
                    var container = $("#comment-" + commentId);
                    if (!container.is(e.target) && container.has(e.target).length === 0) {
                        hideEditComment(commentId);
                        $("#comment-" + commentId + " textarea").val($("#comment-" + commentId + " textarea").data("original"));
                    }
                });
                // specifically handle click and drag behaviour to avoid triggering clicking outside of edit box in this case
                $(".edit-comment textarea").on("mousedown", function () {
                    isDragging = true;
                });
                $(".edit-comment-controls .no").on("click", function () {
                    var commentId = $(this).data("comment");
                    hideEditComment(commentId);
                    $("#comment-" + commentId + " textarea").val($("#comment-" + commentId + " textarea").data("original"));
                });
                $(".edit-comment-controls .yes").on("click", function () {
                    updateComment($(this), orgCommentsUrl);
                });
                $(".edit-comment textarea").on("keyup", function (e) {
                    var target = $(e.target);
                    if (e.which === 13 && target.val().length) { // user hit ENTER
                        updateComment(target, orgCommentsUrl);
                    }
                    else if (e.which === 27) { // user hit escape
                        $(".edit-comment-controls .no").trigger("click");
                    }
                });
            },
            error: function () {
                $("#comments-error").show();
            },
            complete: function () {
                finishLoadingComments();
            }
        });
    }
    function showComments(orgCommentsUrl, organisationId, outletId, outletServiceId) {
        reloadComments(1, orgCommentsUrl, null);
        var selector = "div[data-toggle^=toggle]";
        $(document).on("keydown", ".accessible-toggle", function (e) {
            if (e.which === 13) {
                $(selector, e.target).trigger("click.bs.toggle");
            }
        });
        $(document).on("click", ".accessible-toggle", function (e) {
            $(selector, e.target).trigger("click.bs.toggle");
        });
        $(document).on("click.bs.toggle", selector, function (e) {
            var $parent = $(e.target).closest(".accessible-toggle");
            $parent.closest(".accessible-toggle").attr("aria-checked", $("input[type=checkbox]", $parent).is(":checked") ? "true" : "false");
        });
        function deleteComment($element) {
            if (confirm("Are you sure you want to delete this comment?")) {
                showLoadingComments();
                setupCommentNotificationsDefaults();
                $.ajax({
                    type: "POST",
                    url: window.AppSettings.ApiUrl + "/api/v1/organisationcomments/remove/" + $element.data("comment"),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (d) {
                        var hasError = false;
                        for (var i = 0; i < d.length; i++) {
                            var result = d[i];
                            if (!result.Success) {
                                $.notify({
                                    title: "Ooops",
                                    message: result.Message,
                                    icon: "glyphicon glyphicon-remove-circle"
                                }, {
                                    type: "warning"
                                });
                                hasError = true;
                            }
                            else {
                                $.notify({
                                    title: "Success",
                                    message: result.Message,
                                    icon: "glyphicon glyphicon-info-sign"
                                });
                            }
                        }
                        if (!hasError) {
                            reloadComments(1, orgCommentsUrl, "#comments");
                        }
                    },
                    error: function () {
                        $.notify({
                            title: "Dang It",
                            message: "There was an error trying to delete this comment.",
                            icon: "glyphicon glyphicon-remove-circle"
                        }, {
                            type: "danger"
                        });
                    },
                    complete: function () {
                        finishLoadingComments();
                    }
                });
            }
        }
        // setup per-comment behaviours
        $(document).on("click", ".btn-delete-comment", function (ev) {
            ev.preventDefault();
            aria.Utils.AriaAlert("Are you sure you want to delete this comment? Showing alert dialog. Enter to accept, escape to cancel.", 3);
            var $element = $(this);
            setTimeout(function () {
                deleteComment($element);
            }, 500);
        });
        $(document).on("keyup", ".btn-delete-comment", function (ev) {
            ev.preventDefault();
            if (ev.which === 13) {
                aria.Utils.AriaAlert("Are you sure you want to delete this comment? Showing alert dialog. Enter to accept, escape to cancel.", 3);
                var $element_1 = $(this);
                setTimeout(function () {
                    deleteComment($element_1);
                }, 500);
            }
        });
        function editComment(elem) {
            var commentId = $(elem).data("comment");
            // only retrigger if not already visible
            if ($("#comment-" + commentId + " .edit-comment:visible").length === 0) {
                showEditComment($(elem).data("comment"));
            }
        }
        $(document).on("click", ".btn-edit-comment", function (ev) {
            ev.preventDefault();
            editComment(this);
        });
        $(document).on("keyup", ".btn-edit-comment", function (ev) {
            if (ev.which === 13) {
                ev.preventDefault();
                editComment(this);
            }
        });
        // setup other comment-related behaviours
        $("#more-comments").on("click", function (ev) {
            ev.preventDefault();
            $("#more-comments").attr("disabled", "disabled");
            $(this).data("page-number", $(this).data("page-number") + 1);
            reloadComments($(this).data("page-number"), orgCommentsUrl, "#comments");
        });
        if (!outletServiceId || !$("#comment-text").length) {
            return;
        }
        // add new comment behaviour
        $("#comment-text").data("organisation", organisationId);
        $("#comment-text").data("outlet", outletId);
        $("#comment-text").data("outletservice", outletServiceId);
        $("#comment-text").on("keyup", function (e) {
            var target = $(e.target);
            if (e.which === 13 && target.val().length) { // user hit ENTER
                showLoadingComments();
                target.attr("disabled", "disabled");
                var selectedFlags = $.makeArray($("input:checked", target.parent()).map(function () {
                    return $(this).data("value");
                }));
                var addNewComment = {
                    Comment: target.val(),
                    OrganisationId: target.data("organisation"),
                    OutletId: target.data("outlet"),
                    OutletServiceId: target.data("outletservice"),
                    CommentFlags: selectedFlags.join(",")
                };
                target.val("");
                setupCommentNotificationsDefaults();
                $.ajax({
                    type: "POST",
                    url: window.AppSettings.ApiUrl + "/api/v1/organisationcomments/add",
                    data: JSON.stringify(addNewComment),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        var hasError = false;
                        for (var i = 0; i < data.length; i++) {
                            var result = data[i];
                            if (!result.Success) {
                                $.notify({
                                    title: "Ooops",
                                    message: result.Message,
                                    icon: "glyphicon glyphicon-remove-circle"
                                }, {
                                    type: "warning"
                                });
                                hasError = true;
                            }
                            else {
                                $.notify({
                                    title: "Success",
                                    message: result.Message,
                                    icon: "glyphicon glyphicon-info-sign"
                                });
                            }
                        }
                        if (!hasError) {
                            reloadComments(1, orgCommentsUrl, null);
                        }
                    },
                    error: function () {
                        $.notify({
                            title: "Dang It",
                            message: "There was an error trying to post a new comment.",
                            icon: "glyphicon glyphicon-remove-circle"
                        }, {
                            type: "danger"
                        });
                    },
                    complete: function () {
                        finishLoadingComments();
                        $("#comment-text").removeAttr("disabled");
                        $("#comment-text").focus();
                    }
                });
            }
        });
    }
    function setupResultsButtonActions(crit, favouriteModalUrl, loggedIn, onSuccess) {
        if (window.opera || window.sidebar) {
            $(".btn-add-to-favourites").each(function () {
                $(this).attr("href", window.location.href);
                $(this).attr("title", document.title);
                $(this).attr("rel", "sidebar");
            });
        }
        $(".btn-add-to-favourites").off("click touchend").on("click touchend", function (e) {
            e.preventDefault();
            Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouriteModalUrl, loggedIn);
        });
        $(".btn-add-to-favourites").off("keyup").on("keyup", function (e) {
            e.preventDefault();
            if (e.which === 13) {
                Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouriteModalUrl, loggedIn);
            }
        });
        $(".btn-save-search").off("click touchend").on("click touchend", function (e) {
            e.preventDefault();
            Common.Favourites.ShowAddFavouriteList(loggedIn);
        });
        $(".btn-save-search").off("keyup").on("keyup", function (e) {
            e.preventDefault();
            if (e.which === 13) {
                Common.Favourites.ShowAddFavouriteList(loggedIn);
            }
        });
        $(".btn-share-nonlisted").off("click touchend").on("click touchend", function (e) {
            e.preventDefault();
            $('#ShareModal-ShareNonlisted').modal('show');
        });
        Common.Favourites.SetupSaveSearchClick(crit);
        var buttonWrapper = $("#view-toggles");
        var rankButton = buttonWrapper.find(".btn-rank");
        var alphaButton = buttonWrapper.find(".btn-alpha");
        var distanceButton = buttonWrapper.find(".btn-distance");
        var allResultsButton = buttonWrapper.find(".btn-all-results");
        var localResultsButton = buttonWrapper.find(".btn-local-results");
        var mapButton = buttonWrapper.find(".btn-map");
        if (crit.LocalOnly) {
            allResultsButton.removeClass("active");
            localResultsButton.addClass("active");
        }
        else {
            allResultsButton.addClass("active");
            localResultsButton.removeClass("active");
        }
        if (crit.SortField === 'Relevance') {
            // Reset the other buttons
            alphaButton.removeClass("active").removeClass("icon-sort-alpha-desc").addClass("icon-sort-alpha-asc").data("sort-direction", "ASC");
            distanceButton.removeClass("active").removeClass("icon-sort-distance-desc").addClass("icon-sort-distance-asc").data("sort-direction", "ASC");
            rankButton.addClass("active");
        }
        else if (crit.SortField === 'Distance') {
            // Reset the other buttons
            rankButton.removeClass("active");
            alphaButton.removeClass("active").removeClass("icon-sort-alpha-desc").addClass("icon-sort-alpha-asc").data("sort-direction", "ASC");
            // Set distance button display
            Common.Favourites.SetSortButtonDirection(distanceButton, crit.SortDirection, "distance");
        }
        else {
            // Reset the other buttons
            rankButton.removeClass("active");
            distanceButton.removeClass("active").removeClass("icon-sort-distance-desc").addClass("icon-sort-distance-asc").data("sort-direction", "ASC");
            // Set alpha button display
            Common.Favourites.SetSortButtonDirection(alphaButton, crit.SortDirection, "alpha");
        }
        function triggerRank(e) {
            e.preventDefault();
            crit.SortField = "Relevance";
            crit.SortDirection = "DESC";
            crit.PageNo = 1;
            crit.State = $("#State_Code").val();
            Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn, onSuccess);
        }
        rankButton.off("click touchend").on("click touchend", function (e) {
            triggerRank(e);
        });
        rankButton.off("keyup").on("keyup", function (e) {
            if (e.which === 13) {
                triggerRank(e);
            }
        });
        function triggerAlpha(e) {
            e.preventDefault();
            Common.DisableFilter();
            crit.SortField = "Nickname";
            crit.SortDirection = "ASC";
            crit.PageNo = 1;
            crit.State = $("#State_Code").val();
            if ($(e.target).hasClass("active")) {
                var direction = $(e.target).data("sort-direction");
                crit.SortDirection = direction === "DESC" ? "ASC" : "DESC";
                aria.Utils.AriaAlert("Sorting alphabetically: " + (direction === "DESC" ? "A to Z" : "Z to A"), 3);
            }
            Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn, onSuccess, Common.ReenableFilter);
        }
        alphaButton.off("click touchend").on("click touchend", function (e) {
            triggerAlpha(e);
        });
        alphaButton.off("keyup").on("keyup", function (e) {
            if (e.which === 13) {
                triggerAlpha(e);
            }
        });
        function triggerDistance(e) {
            e.preventDefault();
            Common.DisableFilter();
            var value = $(e.target).closest(".organisation").length ? $(".organisation .location-filter.tt-input").val() : $("#autocomplete-location").val();
            if (value === "") {
                $("#searchTextModal").on("shown.bs.modal", function () {
                    $("#searchTextModal [role=document]:first").focus();
                });
                $(".modal-title").text("Location needed");
                $("#searchTextModal [role=document]:first").attr("aria-label", "Location needed");
                $(".search-text").text("Before you can sort the results by distance you need to tell us where you are located. " + $(e.target).data("warning"));
                $("#searchTextModal").modal("show");
                Common.ReenableFilter();
                return;
            }
            crit.SortField = "Distance";
            crit.SortDirection = "ASC";
            crit.PageNo = 1;
            crit.State = $("#State_Code").val();
            if ($(e.target).hasClass("active")) {
                var direction = $(e.target).data("sort-direction");
                crit.SortDirection = direction === "DESC" ? "ASC" : "DESC";
                aria.Utils.AriaAlert("Sorting by distance: " + (direction === "DESC" ? "ascending" : "descending"), 3);
            }
            Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn, onSuccess, Common.ReenableFilter);
            if (mapButton.hasClass("active")) {
                if (window.Markers.length > 0) {
                    Common.Map.FitMapBounds(window.MapView, window.Bounds);
                }
                else {
                    if (typeof window.CouncilLayer !== 'undefined') {
                        window.CouncilLayer.setMap(window.MapView);
                    }
                }
            }
        }
        distanceButton.off("click touchend").on("click touchend", function (e) {
            triggerDistance(e);
        });
        distanceButton.off("keyup").on("keyup", function (e) {
            if (e.which === 13) {
                triggerDistance(e);
            }
        });
        function triggerResults(e, localOnly) {
            e.preventDefault();
            if (!$(e.target).hasClass("active")) {
                Common.DisableFilter();
                crit.LocalOnly = localOnly;
                Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn, onSuccess, Common.ReenableFilter);
            }
        }
        localResultsButton.off("click touchend").on("click touchend", function (e) {
            triggerResults(e, true);
        });
        localResultsButton.off("keyup").on("keyup", function (e) {
            if (e.which === 13) {
                triggerResults(e, true);
            }
        });
        allResultsButton.off("click touchend").on("click touchend", function (e) {
            triggerResults(e, false);
        });
        allResultsButton.off("keyup").on("keyup", function (e) {
            if (e.which === 13) {
                triggerResults(e, false);
            }
        });
    }
    function setupSearchResultsAria(elem, focusedSelector) {
        new aria.Grid(elem);
        if (focusedSelector) {
            $(focusedSelector).focus();
        }
    }
    function ShowThinking(regionToShow) {
        $(regionToShow).html('<div class="processing"><img src="/_static/images/processing.gif" alt="Loading Results..."/></div>');
        $(".search-expand").hide();
    }
    Page.ShowThinking = ShowThinking;
    function InitLoginPage() {
        var alreadyLoggedIn = arguments[0] || false;
        // Behaviour to toggle the showing & hiding of the login panels
        $(".login-wrapper").find("[data-toggle-button]").on("click touchend", function (e) {
            var buttonClicked = $(this);
            e.preventDefault();
            $(buttonClicked.data("toggle-parent")).fadeOut(300, function () {
                $(buttonClicked.data("toggle-target")).fadeIn();
                //$('html, body').animate({
                //    scrollTop: $(buttonClicked.data("toggle-target")).offset().top - 50
                //}, 200);
            });
        });
        $(".register-wrapper button").on("click", function (e) {
            e.preventDefault();
            var link = $(this).data("link");
            window.location.href = link;
        });
        if (alreadyLoggedIn) {
            $('.login-wrapper').hide(300, function () { return $('#loggedin-wrapper').fadeIn(); });
        }
    }
    Page.InitLoginPage = InitLoginPage;
    function InitVerifyEmailPage() {
        var initial = arguments[0] || "token-wrapper";
        $('.login-wrapper').hide();
        $(initial).show();
        var tokenForm = $('#tokenForm');
        tokenForm.validate({
            rules: {
                Token: {
                    required: true
                }
            },
            messages: {
                Token: {
                    required: "Please enter a token to validate"
                }
            }
        });
    }
    Page.InitVerifyEmailPage = InitVerifyEmailPage;
    function InitEventRegisterPage() {
        var alreadyLoggedIn = arguments[0] || false;
        var registerForm = $('#registerForm');
        registerForm.validate({
            rules: {
                FirstName: {
                    required: true
                },
                LastName: {
                    required: true
                },
                Email: {
                    required: false,
                    email: true
                },
                Mobile: {
                    mobileAvailable: true,
                    ausMobile: true
                },
            },
            messages: {
                FirstName: {
                    required: "We need your first name"
                },
                LastName: {
                    required: "We need your last name"
                },
                Mobile: {
                    mobileAvailable: "That mobile number is already used",
                    ausMobile: "This is not a valid Australian mobile number"
                },
                Email: {
                    required: "We need your email address",
                    email: "This is not a valid email address",
                    emailAvailable: "That email has already been used"
                },
            }
        });
        $.validator.addMethod("ausMobile", function (value, element) {
            var trimmedValue = value.replace(/[^\d\+]/gi, '');
            var re = new RegExp(/^\({0,1}((0|\+61)(4)){1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/);
            return this.optional(element) || trimmedValue.match(re);
        }, "Please enter a valid Australian mobile number.");
        var typingTimer; //timer identifier
        var doneTypingInterval = 1000; //time in ms (5 seconds)
        //on keyup, start the countdown
        $('#Email').keyup(function () {
            clearTimeout(typingTimer);
            if ($('#Email').val()) {
                typingTimer = setTimeout(checkIfExist, doneTypingInterval);
            }
        });
        //user is "finished typing," do something
        function checkIfExist() {
            jQuery.ajax({
                async: true,
                url: '/api/Users/IsEmailExist?email=' + $('#Email').val(),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                //contentType: "application/json; charset=utf-8",
                success: function (resp) {
                    if (resp) {
                        $('.register-extra-info').hide();
                        $('.found_you_text').show();
                        $('.extra_info_text').hide();
                        $('#IsCurrentUser').val(resp.toString());
                    }
                    else {
                        $('.register-extra-info').show();
                        $('.found_you_text').hide();
                        $('.extra_info_text').show();
                    }
                },
                error: function (err) {
                    alert(err.responseText);
                }
            });
        }
        // Behaviour to toggle the showing & hiding of the login panels
        $(".login-wrapper").find("[data-toggle-button]").on("click touchend", function (e) {
            var buttonClicked = $(this);
            e.preventDefault();
            var validate = buttonClicked.data("toggle-validate") || false;
            if (!validate || registerForm.valid()) {
                $(buttonClicked.data("toggle-parent")).fadeOut(300, function () {
                    $(buttonClicked.data("toggle-target")).fadeIn(null, function () { return $("select, [type=text]", ".login-wrapper").filter(":visible").first().focus(); });
                });
            }
            else if ($("label.has-error:visible").length) {
                $("input", $("label.has-error:visible:first").parent()).focus();
            }
        });
        $("#Email").on("blur", function () {
            if ($("#Username").val() === '')
                $("#Username").val($(this).val());
        });
        if (alreadyLoggedIn) {
            $('.login-wrapper').hide(300);
            $('#loggedin-wrapper').fadeIn();
        }
        initPasswordStrength();
        registerForm.on("submit", function () {
            if (!registerForm.valid()) {
                $("input", $("label.has-error:visible:first").parent()).focus();
            }
        });
    }
    Page.InitEventRegisterPage = InitEventRegisterPage;
    function InitRegisterPage() {
        var alreadyLoggedIn = arguments[0] || false;
        var registerForm = $('#registerForm');
        registerForm.validate({
            rules: {
                Username: {
                    required: true,
                    mcdUsername: true,
                    usernameAvailable: true
                },
                FirstName: {
                    required: true
                },
                LastName: {
                    required: true
                },
                Email: {
                    required: true,
                    email: true,
                    emailAvailable: true
                },
                Mobile: {
                    mobileAvailable: true,
                    ausMobile: true
                },
                Password: {
                    required: true,
                    minlength: 6,
                    regex: /^\S*$/
                },
                ConfirmPassword: {
                    required: true,
                    equalTo: '#Password'
                }
            },
            messages: {
                Username: {
                    required: "Please enter a user name",
                    mcdUsername: "That is not a valid username",
                    usernameAvailable: "That username already exists"
                },
                FirstName: {
                    required: "We need your first name"
                },
                LastName: {
                    required: "We need your last name"
                },
                Mobile: {
                    mobileAvailable: "That mobile number is already used",
                    ausMobile: "This is not a valid Australian mobile number"
                },
                Email: {
                    required: "We need your email address",
                    email: "This is not a valid email address",
                    emailAvailable: "That email has already been used"
                },
                Password: {
                    required: "Please enter your password",
                    minlength: "Your password must be at least six characters long",
                    regex: "Your password cannot contain any spaces"
                },
                ConfirmPassword: {
                    required: "Please confirm your password",
                    equalTo: "Your passwords must match"
                }
            }
        });
        // Behaviour to toggle the showing & hiding of the login panels
        $(".login-wrapper").find("[data-toggle-button]").on("click touchend", function (e) {
            var buttonClicked = $(this);
            e.preventDefault();
            var validate = buttonClicked.data("toggle-validate") || false;
            if (!validate || registerForm.valid()) {
                $(buttonClicked.data("toggle-parent")).fadeOut(300, function () {
                    $(buttonClicked.data("toggle-target")).fadeIn(null, function () { return $("select, [type=text]", ".login-wrapper").filter(":visible").first().focus(); });
                });
            }
            else if ($("label.has-error:visible").length) {
                $("input", $("label.has-error:visible:first").parent()).focus();
            }
        });
        $("#Email").on("blur", function () {
            if ($("#Username").val() === '')
                $("#Username").val($(this).val());
        });
        if (alreadyLoggedIn) {
            $('.login-wrapper').hide(300);
            $('#loggedin-wrapper').fadeIn();
        }
        initPasswordStrength();
        registerForm.on("submit", function () {
            if (!registerForm.valid()) {
                $("input", $("label.has-error:visible:first").parent()).focus();
            }
        });
    }
    Page.InitRegisterPage = InitRegisterPage;
    function InitAboutUsPage() {
        $.getJSON("/api/Statistics/LoadAll", function (data) {
            $(".litUsers").text(data.Users.toLocaleString()); //.ToString("N0");
            $(".litOrganisations").text(data.Organisations.toLocaleString()); //.ToString("N0");
            $(".litOutlets").text(data.Outlets.toLocaleString()); //.ToString("N0");
            $(".litServices").text(data.Services.toLocaleString()); //.ToString("N0");
            $(".litServiceRegions").text(data.ServiceRegions.toLocaleString()); //.ToString("N0");
            $(".litOutletsPerOrg").text("Average " + (parseFloat(data.Outlets) / parseFloat(data.Organisations)).toFixed(1) + " per Organisation");
            $(".litServicesPerOutlet").text("Average " + (parseFloat(data.Services) / parseFloat(data.Outlets)).toFixed(1) + " per Location");
            $(".litRegionsPerService").text("Average " + (parseFloat(data.ServiceRegions) / parseFloat(data.Services)).toFixed(1) + " per Service");
            window.orgData = new google.visualization.DataTable();
            window.orgData.addColumn('string', 'Organisation Type');
            window.orgData.addColumn('number', 'Count');
            $.each(data.OrganisationTypes, function (i, v) {
                window.orgData.addRow([v.label, v.data]);
            });
            drawOrgChart(window.orgData);
            window.orgMap = new google.visualization.DataTable();
            window.orgMap.addColumn('number', 'Latitude');
            window.orgMap.addColumn('number', 'Longitude');
            window.orgMap.addColumn('number', 'Locations');
            window.orgMap.addColumn('string', 'Region');
            $.each(data.ServiceCouncilMap, function (i, v) {
                window.orgMap.addRow([v.Latitude, v.Longitude, v.Count, v.Name]);
            });
            drawOrgMap(window.orgMap);
            window.serviceData = new google.visualization.DataTable();
            window.serviceData.addColumn('string', 'Service Type');
            window.serviceData.addColumn('number', 'Count');
            $.each(data.ServiceTypes, function (i, v) {
                window.serviceData.addRow([v.label, v.data]);
            });
            drawServiceChart(window.serviceData);
            window.resizeTimer = null;
            $(window).resize(function () {
                clearTimeout(window.resizeTimer);
                window.resizeTimer = window.setTimeout(function () {
                    drawOrgChart(window.orgData);
                    drawOrgMap(window.orgMap);
                    drawServiceChart(window.serviceData);
                }, 500);
            });
        });
    }
    Page.InitAboutUsPage = InitAboutUsPage;
    function InitRegionListingPage(council, isLocality) {
        Common.InitCategoryLinks();
        if (isLocality) {
            Common.SetCurrentLocality(council);
        }
        else {
            Common.SetCurrentCouncil(council);
        }
    }
    Page.InitRegionListingPage = InitRegionListingPage;
    function InitListingPage(councilId, orgId, outletId, outletServiceId, categoryId, localityId, localityName, shouldShowComments, favouriteModalUrl, loggedIn, showContactForm) {
        var pageNumber = 1;
        displayExtraInformation();
        loadNearby(outletId, orgId, pageNumber);
        pageNumber++;
        $("body").on("click touchend", ".loadMore", function () {
            loadNearby(outletId, orgId, pageNumber);
            pageNumber++;
        });
        $("#hfLocationId").val(localityId || "0");
        $("#autocomplete-location").val(localityName || "");
        if (localityId > 0) {
            $.getJSON("/api/Locations/id/" + localityId, function (data) {
                Common.SetCurrentLocality(data);
            });
        }
        else {
            $.getJSON("/api/Councils/" + councilId, function (data) {
                Common.SetCurrentCouncil(data);
            });
        }
        $.getJSON("/api/Outlets/OtherServices/" + outletId + "/" + outletServiceId + "/" + councilId, function (data) {
            if (data.length !== 0) {
                var template = $("#otherServicesTemplate").render(data);
                var $template = $("<div/>").html(template);
                $(".nofollow", $template).removeAttr("rel");
                template = $template.html();
                $("#otherServices").show();
                $("#otherServices").append("<ul>" + template + "</ul>");
            }
        });
        $.getJSON("/api/Outlets/OtherServiceRegions/" + outletId + "/" + outletServiceId + "/" + councilId + "/" + categoryId, function (data) {
            if (data.length !== 0) {
                var template = $("#otherServiceRegionsTemplate").render(data);
                var $template = $("<div/>").html(template);
                $(".nofollow", $template).removeAttr("rel");
                template = $template.html();
                $("#otherServiceRegions").show();
                $("#otherServiceRegions").append("<ul>" + template + "</ul>");
            }
        });
        Common.InitEmail(function (d) {
            return {
                OutletID: d.data("outlet"),
                OutletServiceID: d.data("service"),
                CategoryID: d.data("category"),
                CouncilRegionID: d.data("region"),
                FromName: $("#txt-name").val(),
                FromEmail: $("#txt-email").val(),
                Phone: $("#txt-phone").val(),
                Message: $("#txt-enquiry").val()
            };
        });
        if (window.opera || window.sidebar) {
            $(".btn-add-to-favourites").each(function () {
                $(this).attr("href", window.location.href);
                $(this).attr("title", document.title);
                $(this).attr("rel", "sidebar");
            });
        }
        $(".btn-add-to-favourites").on("click", function (e) {
            e.preventDefault();
            Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouriteModalUrl, loggedIn);
        });
        $(".btn-add-to-favourites").off("keyup").on("keyup", function (e) {
            e.preventDefault();
            if (e.which === 13) {
                Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouriteModalUrl, loggedIn);
            }
        });
        $(".description.trusted a").attr("target", "_blank");
        $(".description.trusted a").on("click", function (e) {
            var href = $(this).attr("href");
            var url = "/api/link/click?action=inlinelink&outletId=" + outletId + "&categoryId=" + categoryId + "&redirecturl=" + encodeURIComponent(href);
            $.ajax(url);
        });
        $(".icon-website a.trusted").on("click", function (e) {
            var url = "/api/link/click?action=recordclick&outletId=" + outletId + "&categoryId=" + categoryId;
            $.ajax(url);
        });
        Common.SetupShareModal($('#ShareModal-ShareAListing'));
        $("a.btn-email").attr("href", "mailto:?subject=About%20" + encodeURIComponent($(".company-header h3").text().trim()) + "&body=I%20have%20found%20this%20listing%20on%20My%20Community%20Directory:%0A%0A" + encodeURIComponent(window.location.href));
        if (shouldShowComments) {
            showComments(window.AppSettings.ApiUrl + "/api/v1/organisationComments?parentId=" + outletServiceId + "&type=0&pageNumber={pageNumber}", orgId, outletId, outletServiceId);
        }
        if ($("#custom-tags").length) {
            var selectize = null;
            $("#set-tags-modal").on("show.bs.modal", function () {
                if (selectize == null) {
                    selectize = $("#custom-tags-modal").selectize({
                        plugins: {
                            "remove_button_accessible": {},
                            "accessibility": {
                                Label: "Search for tags that are applied to services in the directory"
                            }
                        },
                        valueField: 'Text',
                        labelField: 'Text',
                        searchField: 'Text',
                        preload: true,
                        selectOnTab: true,
                        closeAfterSelect: true,
                        hideSelected: true,
                        load: function (query, callback) {
                            $.ajax({
                                url: "/manage/tags/selectcustomtags",
                                type: "get",
                                dataType: "json",
                                error: function () {
                                    callback();
                                },
                                success: function (data) {
                                    callback(data.map(function (d) {
                                        return {
                                            Text: d.TagName
                                        };
                                    }));
                                }
                            });
                        },
                        render: {
                            option: function (item, escape) {
                                return "<div><span>" + escape(item.Text) + "</span></div>";
                            }
                        }
                    })[0].selectize;
                }
            });
            $("#set-tags-modal").on("hidden.bs.modal", function () {
                selectize.clear(true);
                selectize.addItems($("#custom-tags-current").val().split(","));
            });
            $("body").on("click touchend", "#update-tags-button", function (ev) {
                $("#custom-tags-container").hide();
                $("#custom-tags-busy").show();
                var $form = $(ev.target).closest("form");
                var data = {
                    outletServiceId: $("#OutletServiceID", $form).val(),
                    tags: $("#custom-tags-modal").val().split(",")
                };
                $("input, button", $form).attr("disabled", "disabled");
                $.ajax({
                    url: "/manage/tags/updateforservice",
                    data: JSON.stringify(data),
                    contentType: "application/json",
                    method: "post",
                    success: function (result) {
                        if (result.Success) {
                            if (result.Data == null || result.Data === "") {
                                $("#custom-tags-formatted").html("There are no custom tags assigned to this listing. Why don't you add some?");
                            }
                            else {
                                $("#custom-tags-formatted").html(result.Data);
                            }
                            $("#custom-tags-current").val($("#custom-tags-modal").val());
                            $.notify({
                                title: "Success",
                                message: "Successfully updated tags",
                                icon: "glyphicon glyphicon-info-sign"
                            });
                        }
                        else {
                            $.notify({
                                title: "Error",
                                message: result.Messages[0].Message,
                                icon: "glyphicon glyphicon-remove-circle"
                            }, {
                                type: "danger"
                            });
                        }
                    },
                    error: function () {
                        $.notify({
                            title: "Error",
                            message: "Something went wrong. Please try again.",
                            icon: "glyphicon glyphicon-remove-circle"
                        }, {
                            type: "danger"
                        });
                    },
                    complete: function () {
                        $("input, button", $form).removeAttr("disabled");
                        $("#custom-tags-container").show();
                        $("#custom-tags-busy").hide();
                        $("#set-tags-modal").modal("hide");
                    }
                });
            });
        }
        if (showContactForm) {
            $("#contact-form").show();
            $('html, body').animate({
                scrollTop: $("#contact-form").offset().top
            }, 2000);
            $("#txt-name").focus();
        }
    }
    Page.InitListingPage = InitListingPage;
    function InitOutletPage(orgId, outletId, shouldShowComments) {
        var pageNumber = 1;
        displayExtraInformation();
        loadNearby(outletId, orgId, pageNumber);
        pageNumber++;
        $("body").on("click touchend", ".loadMore", function () {
            loadNearby(outletId, orgId, pageNumber);
            pageNumber++;
        });
        Common.InitEmail(function (d) {
            return {
                OutletID: d.data("outlet"),
                OutletServiceID: 0,
                CategoryID: 0,
                CouncilRegionID: 0,
                FromName: $("#txt-name").val(),
                FromEmail: $("#txt-email").val(),
                Phone: $("#txt-phone").val(),
                Message: $("#txt-enquiry").val()
            };
        });
        Common.SetupShareModal($('#ShareModal-ShareAListing'));
        //$(".btn-facebook").on("click", function (e) {
        //	e.preventDefault();
        //	var w = 626;
        //	var h = 436;
        //	var winTop = ($(window).height() / 2) - (h / 2);
        //	var winLeft = ($(window).width() / 2) - (w / 2);
        //	//window.open("https://www.facebook.com/sharer/sharer.php?s=100&p[url]=" + location.href + "&p[title]=" + document.title + "&p[summary]=" + $(this).data("description") + "&p[images][0]=" + $(this).data("image"), "", "toolbar=0,status=0,top=" + winTop + ",left=" + winLeft + ",width=" + w + ",height=" + h);
        //});
        $(".icon-website a.trusted").on("click", function (e) {
            var url = "/api/link/click?action=recordclick&outletId=" + outletId + "&categoryId=0";
            $.ajax(url);
        });
        $("a.btn-email").attr("href", "mailto:?subject=About%20" + encodeURIComponent($(".company-header h3").text().trim()) + "&body=I%20have%20found%20this%20listing%20on%20My%20Community%20Directory:%0A%0A" + encodeURIComponent(window.location.href));
        $("#linksModal").on("show.bs.modal", function (e) {
            var link = $(e.relatedTarget);
            var contentName = link.data("content-id");
            var serviceName = link.data("service-name");
            var content = $(contentName).html();
            $(".service-name").text(serviceName);
            $(".region-options").html(content);
        });
        if (shouldShowComments) {
            showComments(window.AppSettings.ApiUrl + "/api/v1/organisationComments?parentId=" + outletId + "&type=1&pageNumber={pageNumber}");
        }
    }
    Page.InitOutletPage = InitOutletPage;
    function InitMobileSearch() {
        if ($(window).width() < 768) {
            $("#sectionMobileSearch").show();
            $("#sectionDesktopSearch").hide();
        }
        $("#btnShowSearchHeader").on('click', function () {
            $("#sectionDesktopSearch").show();
            $("#sectionMobileSearch").hide();
        });
    }
    Page.InitMobileSearch = InitMobileSearch;
    function InitOrganisationPage(localityId, councilRegionId, state, orgId, showResourceList, favouritesUrl, loggedIn) {
        $("#locality-id").val(localityId);
        $("#btn-apply").on("click touchend", function (ev) {
            ev.preventDefault();
            doSearch();
        });
        var lastLocation = 0;
        function doSearch() {
            var currentLocation = $(".organisation #view-toggles .locality-id").val();
            if (currentLocation > 0 || lastLocation > 0) {
                performSearch();
            }
            else {
                Common.DisableFilter();
                filterResults(Common.ReenableFilter);
            }
            lastLocation = currentLocation;
        }
        // Respond to user hitting enter within the text fields
        $(".btn-filter input[type='text']").on("keyup", function (e) {
            if ($(".btn-filter.disabled").length) {
                return;
            }
            if (e.which === 13) {
                doSearch();
            }
        });
        $(".btn-filter").hide();
        function filterResults(finishedCallback) {
            var container = $("#results");
            container.hide();
            var filterText = $("#name-filter").val();
            var filteredResults = $.grep(searchResults, function (e) {
                return e.Outlet.Nickname.toLowerCase().indexOf(filterText) >= 0;
            });
            var results = $("#resultTemplate").render(filteredResults, {});
            var $results = $("<div/>").html(results);
            $(".nofollow", $results).removeAttr("rel");
            results = $results.html();
            $("#results").html(results);
            $(".btn-add-to-favourites").off("click touchend").on("click touchend", function (e) {
                e.preventDefault();
                Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouritesUrl, loggedIn);
            });
            $(".btn-add-to-favourites").off("keyup").on("keyup", function (e) {
                e.preventDefault();
                if (e.which === 13) {
                    Common.Favourites.ShowAddFavourite(e, parseInt($(this).data("outlet")), parseInt($(this).data("service")), parseInt($(this).data("category")), parseInt($(this).data("region")), $(this).data("url"), favouritesUrl, loggedIn);
                }
            });
            Common.Map.LoadMapMarkers("#search-map", filteredResults, showResourceList, $("#view-toggles .location-filter.tt-input").val() || "");
            setTimeout(function () {
                $(".processing", container.parent()).remove();
                container.show();
                if (!filteredResults.length) {
                    $("#view-toggles .low-listings").show();
                }
                else {
                    $("#view-toggles .low-listings").hide();
                    $(".search-result:not(:visible)", container).removeClass("no-margin");
                    $(".search-result:visible:first", container).addClass("no-margin");
                }
                if (typeof finishedCallback !== "undefined") {
                    finishedCallback();
                }
            }, 500);
        }
        function resultsLoadedCallback() {
            $(".btn-filter").show();
            if ($("#name-filter").val().length) {
                filterResults(Common.ReenableFilter);
            }
            else {
                if (!searchResults.length) {
                    $("#view-toggles .low-listings").show();
                }
                else {
                    $("#view-toggles .low-listings").hide();
                }
                Common.ReenableFilter();
            }
        }
        function performSearch() {
            Common.DisableFilter();
            var location = $("#view-toggles .locality-id").val() || 0;
            Page.LoadSearchResults({
                SearchType: "Search",
                Location: location,
                Council: councilRegionId,
                State: state,
                ConstrainedToOrgId: orgId,
                Radius: -1,
                ShowResourceList: showResourceList,
                SortField: location > 0 ? "Distance" : "Nickname",
                SortDirection: "ASC",
            }, favouritesUrl, loggedIn, resultsLoadedCallback, Common.ReenableFilter);
        }
        performSearch();
    }
    Page.InitOrganisationPage = InitOrganisationPage;
    function InitRegisterOrganisationPage() {
        var form = $("form");
        addAbnValidation();
        form.validate({
            rules: {
                UseExistingOrganisation: {
                    required: true
                },
                OrganisationType: {
                    required: true
                },
                Nickname: {
                    required: true
                },
                Suburb: {
                    required: true
                },
                Phone: {
                    ausPhone: true,
                    require_from_group: [1, ".required-contact"]
                },
                Email: {
                    email: true,
                    require_from_group: [1, ".required-contact"]
                },
                ManagerPhone: {
                    ausPhone: true
                },
                ManagerEmail: {
                    email: true
                },
                ManagerMobile: {
                    ausMobile: true
                },
                Website: {
                    simpleUrl: true
                },
                OrganisationNoAbnTradingName: {
                    required: true,
                    minlength: 3
                },
                OrganisationEnteredAbn: {
                    required: true,
                    abn: true
                },
                AlreadyListed: {
                    required: true
                },
                SelectedOrganisationId: {
                    required: "input[type='radio'][name='AlreadyListed'][value='True']:checked"
                },
                PrimaryService: {
                    required: true
                },
                BriefDescription: {
                    required: true,
                    minlength: 20,
                    maxlength: 200
                },
                AgreeConditions: {
                    required: true
                }
            },
            messages: {
                UseExistingOrganisation: {
                    required: "You must specify if you are adding a location to your existing organisation."
                },
                OrganisationType: {
                    required: "You must specify the type of organisation."
                },
                Nickname: {
                    required: "You must specify the location's name."
                },
                Suburb: {
                    required: "You must supply a partial address for the location. Begin by entering an address above."
                },
                Phone: {
                    require_from_group: "A telephone number or email address is required.",
                    ausPhone: "Please enter a valid phone number"
                },
                Email: {
                    require_from_group: "A telephone number or email address is required.",
                    email: "Please enter a valid email address"
                },
                Website: {
                    simpleUrl: "Please enter a valid website"
                },
                ManagerPhone: {
                    ausPhone: "Please enter a valid phone number"
                },
                ManagerEmail: {
                    email: "Please enter a valid email address"
                },
                ManagerMobile: {
                    ausMobile: "Please enter a valid mobile phone number"
                },
                OrganisationNoAbnTradingName: {
                    required: "You must specify the trading name for your organisation.",
                    minlength: "You must enter a name with 3 or more characters."
                },
                OrganisationEnteredAbn: {
                    required: "You must specify the ABN for your organisation."
                },
                AlreadyListed: {
                    required: "You must indicate if this organisation already exists."
                },
                SelectedOrganisationId: {
                    required: "You must select an existing organisation."
                },
                PrimaryService: {
                    required: "You must specify the primary service offered at this location."
                },
                BriefDescription: {
                    required: "You must provide a brief description for this service.",
                    minlength: "You must enter a description of 20 or more characters."
                },
                AgreeConditions: {
                    required: "You must agree to our terms and conditions."
                }
            },
            errorPlacement: function (error, element) {
                if (element.is(":checkbox") || element.is(":radio")) {
                    error.appendTo(element.parents('.controls'));
                }
                else {
                    error.insertAfter(element);
                }
            }
        });
        var orgTypeDropDown = $("#OrganisationType");
        var orgSelect = function () {
            var orgType = orgTypeDropDown.val();
            var orgDisplay = ".orgNone";
            if (orgType !== "") {
                orgDisplay = ".org" + orgType;
            }
            $(".orgType").hide();
            $(orgDisplay).show();
        };
        orgTypeDropDown.selectize({
            onChange: orgSelect
        });
        orgSelect();
        $(".org-registerednames").data("shown", false);
        var showHideOrgDetails = function () {
            var existingOrg = $("#ExistingOrganisationType").val();
            var isOrg = $("input[type='radio'][name='UseExistingOrganisation']:checked").val();
            var noAbn = $("#OrganisationNoAbn").is(':checked');
            $(".org-details").toggle((existingOrg !== "FoundById" && isOrg === "False") || $(".org-existing").length === 0);
            $(".org-registerednames").toggle(!noAbn && $(".org-registerednames").data("shown"));
            $(".org-unregisteredname").toggle(noAbn);
            $(".org-entered-abn").prop("readonly", noAbn).toggleClass("disabled", noAbn);
        };
        showHideOrgDetails();
        $("input[type='radio'][name='UseExistingOrganisation']").change(showHideOrgDetails);
        var showHideOrgType = function () {
            var isListed = $("input[type='radio'][name='AlreadyListed']:checked").val();
            var noabn = $("#OrganisationNoAbn").is(":checked");
            var orgListVisible = $('.org-existing-selection').is(":visible");
            $(".org-type").toggle(noabn || !orgListVisible || isListed !== "True");
        };
        $("#OrganisationNoAbn").change(function () {
            showHideOrgDetails();
            if ($("#OrganisationEnteredAbn").prop("readonly")) {
                $("#OrganisationEnteredAbn-error").remove();
            }
            showHideOrgType();
        });
        var alreadyListed = function () {
            var isListed = $("input[type='radio'][name='AlreadyListed']:checked").val();
            $(".org-existing-selection").toggle(isListed === "True");
            showHideOrgType();
        };
        alreadyListed();
        $("input[type='radio'][name='AlreadyListed']").change(alreadyListed);
        $("#OrganisationValidatedTradingName").change(function () {
            var tradingName = $("#OrganisationValidatedTradingName").val();
            if (tradingName) {
                $('.org-preferredname').val(tradingName);
            }
        });
        //$("div[id^='sectionnext-']").click(function () {
        //    var id = $(this).prop('id').substr('sectionnext-'.length);
        //    if (form.valid()) {
        //        $("#section-" + id).hide();
        //        id++;
        //        $("#section-" + id).show();
        //        $("#section-" + id).trigger("sectionShow");
        //    }
        //});
        //$("div[id^='sectionback-']").click(function () {
        //    var id = $(this).prop('id').substr('sectionback-'.length);
        //    $("#section-" + id).hide();
        //    id--;
        //    $("#section-" + id).show();
        //    $("#section-" + id).trigger("sectionShow");
        //});
        //var firstMap = true;
        //$("#section-2").on("sectionShow", function () {
        //    if (firstMap) {
        //        firstMap = false;
        //        drawMap("#map-location");
        //    }
        //    else {
        //        google.maps.event.trigger(window.Map, 'resize');
        //    }
        //});
        var geolocationCallback = function () {
            var lat = $(".map-lat").val();
            var lng = $(".map-lng").val();
            $("#UnsupportedAddress").hide();
            $.ajax({
                type: "GET",
                url: "/api/councils/" + lat + "/" + lng,
                cache: false,
                success: function (data) {
                    if (!data || !data.Loaded) {
                        $("#UnsupportedAddress").show();
                    }
                }
            });
        };
        drawMap("#map-location", geolocationCallback);
        setMapAddressReadonly(true);
        $('.map-edit-address').click(function (e) {
            e.preventDefault();
            var readonly = !$('.map-edit-address').hasClass("btn-success");
            setMapAddressReadonly(readonly);
            if (readonly) {
                google.maps.event.trigger(window.Autocomplete, 'place_changed');
            }
        });
        $("#useOrgNameForOutlet").click(function (e) {
            e.preventDefault();
            var name = "";
            var existingOrg = $("#ExistingOrganisationType").val();
            var isOrg = $("input[type='radio'][name='UseExistingOrganisation']:checked").val();
            if (existingOrg === "FoundById" || isOrg === "True") {
                name = $("#ExistingOrganisationName").val();
            }
            else if ($('#OrganisationNoAbn').is(":checked")) {
                name = $("#OrganisationNoAbnTradingName").val();
            }
            else {
                name = $.trim($("#OrganisationValidatedTradingNameSelect").val());
                if (name === '') {
                    var tradingName = $.trim($("#OrganisationValidatedTradingName").val());
                    if ((tradingName || "").length > 0 && tradingName !== "-- none listed --") {
                        name = tradingName;
                    }
                    else {
                        name = $("#OrganisationValidatedLegalName").val();
                    }
                }
            }
            var suburb = $.trim($("#Suburb").val());
            if ((suburb || "").length > 0) {
                name = name + " - " + suburb;
            }
            $('#Nickname').val(name);
        });
        var referralRequired = function () {
            var refRequired = $("input[type='radio'][name='ReferralRequired']:checked").val();
            $("#pnlReferralDetails").toggle(refRequired === "True");
        };
        var populateAbnCharity = function (data) {
            var hadData = false;
            var fld;
            if ($.isNumeric(data.OrganisationTypeGuess)) {
                hadData = true;
                fld = $('#OrganisationType').selectize();
                if (fld.length > 0) {
                    fld[0].selectize.setValue(data.OrganisationTypeGuess);
                }
            }
            if (data.CharityAddress) {
                hadData = true;
                $("#AddressSearch").val(data.CharityAddress);
                window.Geocoder.geocode({
                    'address': data.CharityAddress
                }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        clearMap();
                        var place = results[0];
                        if (!place || !place.geometry)
                            return;
                        if (place.geometry.viewport) {
                            window.MapView.fitBounds(place.geometry.viewport);
                        }
                        else {
                            window.MapView.setCenter(place.geometry.location);
                        }
                        showGeocodeResults(place, google.maps.GeocoderStatus.OK, '', geolocationCallback);
                    }
                    else {
                        clearMap();
                    }
                    if ($.trim($(".map-address1").val()).length === 0) {
                        // The address couldn't be fully validated so clear it out.
                        // Otherwise the person has to clear the field to enter in a valid address.
                        $("#AddressSearch").val("");
                    }
                });
            }
            if (data.CharityWebsite) {
                hadData = true;
                $("#Website").val(data.CharityWebsite);
            }
            if (data.CharityEmail) {
                hadData = true;
                $("#Email").val(data.CharityEmail);
                $("#ManagerEmail").val(data.CharityEmail);
            }
            if (data.PrimaryServiceGuess) {
                hadData = true;
                fld = $('#PrimaryService').selectize();
                if (fld.length > 0) {
                    fld[0].selectize.setValue(data.PrimaryServiceGuess);
                }
            }
            if (data.CharityDescription) {
                $("#CharityDescription").html("<div class=\"form-group\"><label class=\"control-label\">About This Charity</label><div class=\"controls\">" + data.CharityDescription + "</div></div>");
            }
            else {
                $("#CharityDescription").empty();
            }
            if (hadData) {
                $.notify({
                    title: "Pre-filling",
                    message: "We managed to discover some things about your organisation.<br/>Please check and confirm these details are correct.",
                    icon: "glyphicon glyphicon-info-sign"
                });
            }
        };
        $("#OrganisationEnteredAbn").change(function () {
            $("#CharityDescription").empty();
            getAbnDetails($("#OrganisationEnteredAbn").val(), populateAbnCharity);
        });
        $("#AddressFormat").selectize({
            plugins: {
                "accessibility": {}
            }
        });
        $("#ManagerTitle").selectize({
            plugins: {
                "accessibility": {}
            }
        });
        $("#PrimaryService").selectize({
            plugins: {
                "accessibility": {}
            }
        });
        referralRequired();
        $("input[type='radio'][name='ReferralRequired']").change(referralRequired);
        showRemaining("#BriefDescription", 200, "#spanRemaining");
        initHtmlEditor("FullDescription");
        var description = CKEDITOR.instances["FullDescription"].getData();
        description = jQuery('<div />').html(description).text();
        CKEDITOR.instances["FullDescription"].setData(description);
        var agreeConditions = function () {
            $(".terms-and-conditions-actions").toggle($("#AgreeConditions").is(":checked"));
        };
        agreeConditions();
        $("#AgreeConditions").change(agreeConditions);
        var suppliedABN = $("#ExistingOrganisationAbn").val();
        var existingOrg = $("#ExistingOrganisationType").val();
        var enteredABN = $("#OrganisationEnteredAbn").val();
        if (suppliedABN && existingOrg === "None" && !(enteredABN)) {
            $("#OrganisationEnteredAbn").val(suppliedABN);
            getAbnDetails(suppliedABN, populateAbnCharity);
        }
    }
    Page.InitRegisterOrganisationPage = InitRegisterOrganisationPage;
    function InitHelpLinks() {
        $(document).on("keydown", ".help-title", function (e) {
            if (e.which === 13) {
                $(this).trigger("click.bs.collapse");
            }
        });
        // Whenever a link expands, the 'Expand all' should now show 'collapse all'
        $(".help-topic .help-content").on("show.bs.collapse", function () {
            var $elem = $(".help-title", $(this).parent());
            $elem.addClass("help-title-expanded");
            $elem.attr("aria-expanded", "true");
        });
        // Whenever a link set finishes closing, check whether all other groups are closed as well
        $(".help-topic .help-content").on("hidden.bs.collapse", function () {
            var $elem = $(".help-title", $(this).parent());
            $elem.removeClass("help-title-expanded");
            $elem.attr("aria-expanded", "false");
        });
    }
    Page.InitHelpLinks = InitHelpLinks;
    function InitSearchToggleButtons(mapElem, calendarSelector, firstDate, organisationId) {
        var buttonWrapper = $("#view-toggles");
        var mapButton = $(".btn-map.tab-btn, .btn-map .tab-btn", buttonWrapper);
        var listButton = $(".btn-list.tab-btn, .btn-list .tab-btn", buttonWrapper);
        var eventsButton = $(".btn-events.tab-btn, .btn-events .tab-btn", buttonWrapper);
        var sectionDiv = $(".section-search-listing");
        var haveEventsStartedLoading = false;
        var haveEventsFinishedLoading = false;
        var triggerEventsRerender = false;
        function triggerMap(e) {
            e.preventDefault();
            $(".btn-list", buttonWrapper).removeClass("active");
            $(".btn-events", buttonWrapper).removeClass("active");
            $(".btn-map", buttonWrapper).addClass("active");
            sectionDiv.addClass("search-map-view").removeClass("search-list-view").removeClass("search-event-view");
            if (window.MapView) {
                $(".search-map").show();
                google.maps.event.trigger(window.MapView, 'resize');
                if (window.Markers.length > 0) {
                    Common.Map.FitMapBounds(window.MapView, window.Bounds);
                }
                else {
                    if (typeof window.CouncilLayer !== 'undefined') {
                        window.CouncilLayer.setMap(window.MapView);
                    }
                }
            }
            $(".search-support").hide();
            $(".region-information").show();
            $(".event-information").hide();
            triggerEventsRerender = haveEventsStartedLoading && !haveEventsFinishedLoading;
        }
        mapButton.on("click touchend", function (e) {
            triggerMap(e);
        });
        mapButton.on("keyup", function (e) {
            if (e.which === 13) {
                triggerMap(e);
            }
        });
        function triggerList(e) {
            e.preventDefault();
            $(".btn-map", buttonWrapper).removeClass("active");
            $(".btn-events", buttonWrapper).removeClass("active");
            $(".btn-list", buttonWrapper).addClass("active");
            sectionDiv.addClass("search-list-view").removeClass("search-map-view").removeClass("search-event-view");
            $(".search-support").show();
            $(".region-information").hide();
            $(".event-information").hide();
            triggerEventsRerender = haveEventsStartedLoading && !haveEventsFinishedLoading;
        }
        listButton.on("click touchend", function (e) {
            triggerList(e);
        });
        listButton.on("keyup", function (e) {
            if (e.which === 13) {
                triggerList(e);
            }
        });
        function triggerEvents(e) {
            e.preventDefault();
            $(".btn-map", buttonWrapper).removeClass("active");
            $(".btn-list", buttonWrapper).removeClass("active");
            $(".btn-events", buttonWrapper).addClass("active");
            sectionDiv.addClass("search-event-view").removeClass("search-map-view").removeClass("search-list-view");
            $(".search-support").hide();
            $(".search-map").hide();
            $(".region-information").hide();
            $(".event-information").show();
            function loadingCallback() {
                haveEventsStartedLoading = true;
            }
            function loadedCallback() {
                haveEventsFinishedLoading = true;
            }
            if (!haveEventsStartedLoading) {
                Calendars.InitListingCalendar(calendarSelector, firstDate, organisationId, undefined, undefined, loadingCallback, loadedCallback);
            }
            if (triggerEventsRerender) {
                triggerEventsRerender = false;
                $(calendarSelector).fullCalendar("rerenderEvents");
            }
        }
        eventsButton.on("click touchend", function (e) {
            triggerEvents(e);
        });
        eventsButton.on("keyup", function (e) {
            if (e.which === 13) {
                triggerEvents(e);
            }
        });
    }
    Page.InitSearchToggleButtons = InitSearchToggleButtons;
    function InitAmcToggleButtons() {
        var buttonWrapper = $("#amc-toggles");
        var mapButton = buttonWrapper.find(".btn-map");
        var listButton = buttonWrapper.find(".btn-list");
        var sectionDiv = $(".section-search-listing");
        mapButton.on("click touchend", function (e) {
            e.preventDefault();
            listButton.removeClass("active");
            $(this).addClass("active");
            sectionDiv.addClass("search-map-view").removeClass("search-list-view");
            google.maps.event.trigger(window.MapView, 'resize');
            $(".search-support").hide();
        });
        listButton.on("click touchend", function (e) {
            e.preventDefault();
            mapButton.removeClass("active");
            $(this).addClass("active");
            sectionDiv.addClass("search-list-view").removeClass("search-map-view");
            $(".search-support").show();
        });
        $("#settingsModal").on("shown.bs.modal", function () {
            $("#settingsModal [role=document]:first").focus();
        });
    }
    Page.InitAmcToggleButtons = InitAmcToggleButtons;
    function LoadPartners() {
    }
    Page.LoadPartners = LoadPartners;
    function LoadRemoteResults(councilId, categoryGroupId, categoryId, searchTerm, page, focus) {
        var resultsTargetName = ".search-support .results";
        var resultsTemplateName = "#remoteTemplate";
        if (page === 1) {
            Page.ShowThinking(resultsTargetName);
        }
        var s = (searchTerm || "-").replace(/[^a-zA-Z0-9]/g, ' ');
        $.getJSON("/api/Search/Remote/" + councilId + "/" + categoryGroupId + "/" + categoryId + "/" + encodeURIComponent(s) + "/" + page, function (data) {
            if (page === 1) {
                var template = $(resultsTemplateName).render(data.Results);
                var $template = $("<div/>").html(template);
                $(".nofollow", $template).removeAttr("rel");
                template = $template.html();
                $(resultsTargetName).html(template);
            }
            else {
                var template2 = $(resultsTemplateName).render(data.Results);
                var $template2 = $("<div/>").html(template2);
                $(".nofollow", $template2).removeAttr("rel");
                template2 = $template2.html();
                $(resultsTargetName).append(template2);
            }
            $(resultsTargetName).attr("aria-rowcount", $("#remote-results .search-support-item").length);
            if (data.Total > 0) {
                setupSearchResultsAria(document.getElementById("remote-results"), focus ? "#remote-results" : null);
            }
            if (data.Results.length > 0) {
                $(resultsTargetName).append('<a tabindex="0" class="btn-load-more" data-next-page="' + (page + 1) + '" aria-label="Show more listings servicing this area">Load more</a>');
                $(".btn-load-more").off("click").on("click", function (e) {
                    e.preventDefault();
                    $(this).hide();
                    Page.LoadRemoteResults(councilId, categoryGroupId, categoryId, searchTerm, $(this).data("next-page"), true);
                });
                $(".btn-load-more").off("keyup").on("keyup", function (e) {
                    e.preventDefault();
                    if (e.which === 13) {
                        $(this).hide();
                        Page.LoadRemoteResults(councilId, categoryGroupId, categoryId, searchTerm, $(this).data("next-page"), true);
                    }
                });
            }
            else {
                $(".servicing-this-region").hide();
            }
        });
    }
    Page.LoadRemoteResults = LoadRemoteResults;
    function LoadCategorySuggestions(searchTerm) {
        //var resultsTargetName = ".category-results";
        var resultsTemplateName = "#categoryTemplate";
        var s = (searchTerm || "-").replace(/[^a-zA-Z0-9]/g, ' ');
        $.getJSON("/api/Search/categories/" + s, function (data) {
            if (data == null || data.length == 0) {
                $(".category-search-support").hide();
                return;
            }
            var template = $(resultsTemplateName).render(data);
            console.log(template);
            var $template = $("<div/>").html(template);
            $(".nofollow", $template).removeAttr("rel");
            template = $template.html();
            $(".category-results-contents").append($template);
            $(".category-suggestions-loading").hide();
            $(".category-search-support-item").show();
        });
    }
    Page.LoadCategorySuggestions = LoadCategorySuggestions;
    function InitAdvancedSearch() {
        var councilId = parseInt(arguments[0]);
        var stateCode = arguments[1];
        var useElasticOptimisationDefault = arguments[2];
        $("#btnClearFields").on('click touchend', function (e) {
            e.preventDefault();
            $("input").val('');
            $("select").val('');
            $(".answer-btn:first-child").click();
            $("#tags").selectize()[0].selectize.clear();
            $("#accreditations").selectize()[0].selectize.clear();
            $("#advancedCategory").selectize()[0].selectize.clear();
            $("#radius").val('50');
        });
        $("#btnSearchAdvanced").on('click touchend', function (e) {
            e.preventDefault();
            console.log($("#hfStateCode").val());
            var search = saveAdvancedSearch();
            window.location.href = "/Search/Directory?" + jsonToQueryString(search);
        });
        $("#btnNearMe").on('click', function (e) {
            navigator.geolocation.getCurrentPosition(showPosition, function (posError) {
                $.notify({
                    title: "Error",
                    message: "We were unable to get your location from your browser for the following reason: <i>" + posError.message + "</i>",
                    icon: "glyphicon glyphicon-info-sign"
                });
            });
            function showPosition(position) {
                $.getJSON("/api/Councils/" + position.coords.latitude + "/" + position.coords.longitude, function (councilData) {
                    if (councilData.Loaded) {
                        $.getJSON("/api/Locations/" + position.coords.latitude + "/" + position.coords.longitude, function (locData) {
                            if ((locData.Name || '') !== '') {
                                $("#autocomplete-location").val($.trim(locData.Name + " " + (locData.Postcode || "")));
                            }
                            else {
                                $("#autocomplete-location").val(councilData.DisplayName);
                            }
                        });
                    }
                    else {
                        $.notify({
                            title: "Error",
                            message: "We were unable to find your location in one of our member councils.",
                            icon: "glyphicon glyphicon-info-sign"
                        });
                    }
                });
            }
        });
        $("#abn").mask('99 999 999 999');
        $(".answer-btn").on('click', selectOption);
        $(".answer-set-btn").on('click', selectSetOption);
        $(".btn-where").on("click", selectLocation);
        restoreAdvancedSearch(getSearchValues(councilId), useElasticOptimisationDefault);
        $("#hfStateCode").val(stateCode);
        var localityId = $("#hfLocationId").val();
        if (localityId > 0) {
            $.getJSON("/api/Locations/id/" + localityId, function (data) {
                Common.SetCurrentLocality(data);
            });
        }
        else if (councilId > 0) {
            $.getJSON("/api/Councils/" + councilId, function (data) {
                Common.SetCurrentCouncil(data);
            });
        }
        else if (stateCode) {
            $.getJSON("/api/States/" + stateCode, function (data) {
                Common.SetCurrentCouncil(data);
            });
        }
        $('#tags').selectize({
            delimiter: ',',
            valueField: 'ID',
            labelField: 'TagName',
            sortField: 'TagName',
            searchField: ['Keywords', 'TagName'],
            closeAfterSelect: true,
            hideSelected: true,
            create: false,
            preload: true,
            placeholder: "Tags",
            plugins: {
                "accessibility": {
                    Label: "Search for tags that are applied to services in the directory. Select then press enter. Backspace deletes last entry"
                }
            },
            onChange: function () {
                if (this.items.length > 0) {
                    $("#hintTags").show();
                }
                else {
                    $("#hintTags").hide();
                }
            },
            onInitialize: function () {
                var previousSelections = $(this.$input).data('selectize-value') || "";
                if (previousSelections === "")
                    return;
                var self = this;
                $.ajax({
                    url: "/api/tags/specified/" + previousSelections,
                    type: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        var items = data.Results;
                        self.clear();
                        self.clearOptions();
                        self.addOption(items);
                        items.forEach(function (option) {
                            self.addItem(option[self.settings.valueField]);
                        });
                    }
                });
            },
            load: function (query, callback) {
                var orderByLength = "true";
                // check if query is empty
                if (!query.length) {
                    query = "_"; //return callback();
                    orderByLength = "false";
                }
                $.ajax({
                    url: "/api/tags/page/1/" + query + "/true/" + orderByLength,
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        s: query,
                        per: 10
                    },
                    error: function (data) {
                        callback(data);
                    },
                    success: function (data) {
                        callback(data.Results);
                    }
                });
            }
        });
        $('#accreditations').selectize({
            delimiter: ',',
            valueField: 'AccreditationID',
            labelField: 'Title',
            searchField: 'Title',
            sortField: 'Title',
            closeAfterSelect: true,
            hideSelected: true,
            create: false,
            preload: true,
            placeholder: "Self Assessments",
            plugins: {
                "accessibility": {
                    Label: "Search for self assessment type. Select then press enter. Backspace deletes last entry"
                }
            },
            onChange: function () {
                if (this.items.length > 0) {
                    $("#hintSelfAssessments").show();
                }
                else {
                    $("#hintSelfAssessments").hide();
                }
            },
            onInitialize: function () {
                var previousSelections = $(this.$input).data('selectize-value') || "";
                if (previousSelections === "")
                    return;
                var self = this;
                $.ajax({
                    url: "/api/accreditation/specified/" + previousSelections,
                    type: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        var items = data.Results;
                        self.clear();
                        self.clearOptions();
                        self.addOption(items);
                        items.forEach(function (option) {
                            self.addItem(option[self.settings.valueField]);
                        });
                    }
                });
            },
            load: function (query, callback) {
                // check if query is empty
                if (!query.length)
                    query = "_"; // return callback();
                $.ajax({
                    url: "/api/accreditation/page/1/" + query,
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        s: query,
                        per: 10
                    },
                    error: function (data) {
                        callback(data);
                    },
                    success: function (data) {
                        callback(data.Results);
                    }
                });
            }
        });
        $("#advancedCategory").selectize({
            delimiter: ',',
            valueField: 'CategoryID',
            labelField: 'CategoryName',
            searchField: 'CategoryName',
            sortField: 'special',
            optgroupField: 'class',
            placeholder: 'Category',
            plugins: {
                "accessibility": {
                    Label: "Search within service categories. Select then press enter. Backspace deletes last entry"
                }
            },
            preload: true,
            onChange: function () {
                if (this.items.length > 0) {
                    $("#hintCategory").show();
                }
                else {
                    $("#hintCategory").hide();
                }
            },
            onInitialize: function () {
                var previousSelections = $(this.$input).data('selectize-value') || "";
                if (previousSelections === "")
                    return;
                var self = this;
                $.ajax({
                    url: "/api/categorygroups/specified/" + previousSelections,
                    type: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        var items = data.Results;
                        self.clear();
                        self.clearOptions();
                        self.addOption(items);
                        items.forEach(function (item) {
                            if (item.Categories.length === 0) {
                                var option = {
                                    special: "a" + item.Name,
                                    CategoryID: "0." + item.ID,
                                    CategoryName: item.Name + " -- All",
                                    class: item.CategoryKeywords
                                };
                                self.addOption(option);
                                self.addItem(option[self.settings.valueField]);
                            }
                            else {
                                item.Categories.forEach(function (category) {
                                    var option = {
                                        special: "z" + item.Name,
                                        CategoryID: category.ID + "." + item.ID,
                                        CategoryName: category.Name,
                                        class: item.CategoryKeywords
                                    };
                                    self.addOption(option);
                                    self.addItem(option[self.settings.valueField]);
                                });
                            }
                        });
                    }
                });
            },
            load: function (query, callback) {
                var self = this;
                if (!query.length) {
                    query = "_";
                }
                $.ajax({
                    url: "/api/categorygroups/page/1/" + query + "/true/false",
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        s: query,
                        per: 10
                    },
                    error: function () {
                        console.log('Error loading categories.');
                    },
                    success: function (data) {
                        var groupID = 0;
                        for (var i = 0; i < data.Results.length; i++) {
                            if (data.Results[i].ID !== groupID) {
                                self.addOptionGroup(data.Results[i].CategoryKeywords, {
                                    label: data.Results[i].Name,
                                    special: data.Results[i].Name
                                });
                                self.addOption({
                                    special: "a" + data.Results[i].Name,
                                    CategoryID: "0." + data.Results[i].ID,
                                    CategoryName: data.Results[i].Name + " -- All",
                                    class: data.Results[i].CategoryKeywords
                                });
                                groupID = data.Results[i].ID;
                            }
                            self.addOption({
                                special: "z" + data.Results[i].Name,
                                CategoryID: data.Results[i].Categories[0].ID + "." + data.Results[i].ID,
                                CategoryName: data.Results[i].Categories[0].Name,
                                class: data.Results[i].CategoryKeywords
                            });
                        }
                    }
                });
            }
        });
    }
    Page.InitAdvancedSearch = InitAdvancedSearch;
    function LoadSearchResults(crit, favouriteModalUrl, loggedIn, onSuccess, onFailed) {
        Common.SetupShareModal($('#ShareModal-ShareNonlisted'));
        function loadResults(data, crit) {
            displayResults(data, true, crit.ShowResourceList);
            if (data.IsExpandedSearch) {
                displayOtherResultsSummary(data);
            }
            else {
                displayResultsSummary(data);
            }
            displayExtraInformation();
            if (data.Total > 0) {
                setupSearchResultsAria(document.getElementById("results"), null);
            }
            $(".search-force-expanded").toggle(data.Criteria.ForceExpandSearch);
            if (data.Criteria.ForceExpandSearch) {
                crit.Ext = true;
                if (crit.OrigParams)
                    crit.OrigParams.Ext = true;
            }
            displayResultsPagination(crit, loggedIn, data.Results.length, data.Total, data.Criteria.PageSize, favouriteModalUrl, data.Criteria.AllowExpandSearch);
            setupResultsButtonActions(crit, favouriteModalUrl, loggedIn, onSuccess);
        }
        function searchLocalServices() {
            $.getJSON("/api/Search/Local", crit, function (data) {
                loadResults(data, crit);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 404) {
                    loadResults(jqXHR.responseJSON, crit);
                    $(".search-expand").show();
                }
                else if (jqXHR.responseText === "Timeout") {
                    $("#results").html("<div class='alert alert-danger'>Your request took too long, please try again later.</div>");
                }
                else {
                    $("#results").html("<div class='alert alert-danger'>An unexpected error occurred: " + (errorThrown || textStatus || "unknown error") + ".</div>");
                }
                if (typeof onFailed !== "undefined") {
                    onFailed();
                }
            })
                .done(function () {
                PageSetup.InitSearchResultsBehavior();
                $(".search-expand").show();
                if (typeof onSuccess !== "undefined") {
                    onSuccess();
                }
            });
        }
        // TODO: Why is draw = 0?
        function searchCouncilServices() {
            $.getJSON("/api/search/council/" + crit.Council + "/0", crit, function (data) {
                loadResults(data, crit);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 404) {
                    loadResults(jqXHR.responseJSON, crit);
                    $(".search-expand").show();
                }
                else if (jqXHR.responseText === "Timeout") {
                    $("#results").html("<div class='alert alert-danger'>Your request took too long, please try again later.</div>");
                }
                else {
                    $("#results").html("<div class='alert alert-danger'>An unexpected error occurred: " + (errorThrown || textStatus || "unknown error") + ".</div>");
                }
                if (typeof onFailed !== "undefined") {
                    onFailed();
                }
            })
                .done(function () {
                PageSetup.InitSearchResultsBehavior();
                $(".search-expand").show();
                if (typeof onSuccess !== "undefined") {
                    onSuccess();
                }
            });
        }
        aria.Utils.AriaAlert("Performing search", 2);
        if (firstSearch) {
            firstSearch = false;
            $(".btn-expand-search").on("click", function (e) {
                e.preventDefault();
                crit.Ext = true;
                crit.OrigParams.Ext = true;
                $(".btn-expand-search").hide();
                Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn);
            });
            crit.OrigTitle = document.title;
            crit.OrigUrl = document.location.href.split(/[?#]/)[0];
            crit.OrigParams = document.location.search.replace(/(^\?)/, '').split("&").map(function (n) {
                var parts;
                parts = n.split("=");
                this[parts[0]] = parts[1];
                return this;
            }.bind({}))[0];
            $(window).on('popstate', function (e) {
                crit = e.originalEvent.state;
                Page.LoadSearchResults(crit, favouriteModalUrl, loggedIn);
            });
        }
        if (crit.SearchType && crit.SearchType === 'Search') {
            $('#autocomplete-category').val(crit.IsAdvanced ? "" : crit.What);
            crit.Where = $("#autocomplete-location-new").val();
            $('#autocomplete-location').val(crit.Where);
            $('.ddl-radius').val(crit.Radius);
        }
        $("#hfCategoryGroupId").val(crit.CategoryGroup);
        $("#hfCategoryId").val(crit.Category);
        $("#hfLocationId").val(crit.Location);
        $("#hfCouncilId").val(crit.Council);
        $("#hfSortField").val(crit.SortField);
        $("#hfSortDirection").val(crit.SortDirection);
        Page.ShowThinking("#results");
        if (crit.Location !== null) {
            searchLocalServices();
        }
        else {
            // If location is null, search by council region
            searchCouncilServices();
        }
        $("body").on("click touchend", ".keywordSearch .close", function (ev) {
            ev.preventDefault();
            var $anchor = $(ev.target);
            $anchor.closest(".keywordSearch").hide();
        });
    }
    Page.LoadSearchResults = LoadSearchResults;
    function LoadNHSDResults(what, where) {
        var url = "/api/search/nhsd?what=" + what + "&where=" + where;
        $("#nhsdResults").show();
        var htmlResult = "";
        $.getJSON(url, function (d) {
            if (d) {
                var result = JSON.parse(d);
                if (result && result.SiteSearchResponse && result.SiteSearchResponse.SiteSearchResult &&
                    result.SiteSearchResponse.SiteSearchResult.ResultList && result.SiteSearchResponse.SiteSearchResult.ResultList.SiteData &&
                    result.SiteSearchResponse.SiteSearchResult.ResultList.SiteData.length > 0) {
                    if (!result.NHSDUrl) {
                        // fallback url
                        result.NHSDUrl = 'https://www.healthdirect.gov.au/australian-health-services';
                    }
                    console.log(result.SiteSearchResponse.SiteSearchResult.ResultList.SiteData);
                    var results_1 = $("#nhsdTemplate").render(result.SiteSearchResponse.SiteSearchResult.ResultList.SiteData, {
                        nhsdUrl: result.NHSDUrl,
                        nhsdId: result.NHSDID
                    });
                    var $results = $("<div/>").html(results_1);
                    $(".nofollow", $results).removeAttr("rel");
                    results_1 = $results.html();
                    var preHtml = "<p>Search <b>" + what + "</b> in or near <b>" + where + "</b> on the <b><em>National Health Services Directory</em></b></p>";
                    var endHtml = "<p class='nhsd-results-logo'>Search results powered by <img src='https://mcdcdn.blob.core.windows.net/images/nhsdLogo.png'></p>";
                    htmlResult = preHtml + results_1 + endHtml;
                }
            }
        }).done(function () {
            if (htmlResult === "") {
                $("#nhsdResults").hide();
            }
            else {
                $("#nhsdResults").html(htmlResult);
            }
        });
        $.views.converters("dec", function (val) {
            return (+val / 1000).toFixed(2) + "km";
        });
    }
    Page.LoadNHSDResults = LoadNHSDResults;
    function InitSliders() {
        // Create the slick sliders on the homepage
        $(".section-supporters .list-partners").not('.slick-initialized').slick({
            slide: "li",
            slidesToShow: 4,
            responsive: [{
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 840,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 560,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    Page.InitSliders = InitSliders;
    function InitConnectPage() {
        var passwordForm = $("#passwordForm");
        if (passwordForm.length) {
            passwordForm.validate({
                rules: {
                    Password: {
                        required: true,
                        minlength: 6,
                        regex: /^\S*$/
                    },
                    PasswordConfirmation: {
                        required: true,
                        equalTo: "#Password"
                    }
                },
                messages: {
                    Password: {
                        required: "Please enter your password",
                        minlength: "Your password must be at least six characters long",
                        regex: "Your password cannot contain any spaces"
                    },
                    PasswordConfirmation: {
                        required: "Please confirm your password",
                        equalTo: "Your passwords must match"
                    }
                }
            });
            initPasswordStrength();
        }
        var tokenForm = $("#tokenForm");
        if (tokenForm.length) {
            tokenForm.validate({
                rules: {
                    Token: {
                        required: true,
                        maxlength: 60
                    }
                },
                messages: {
                    Token: {
                        required: "Please input a token",
                        maxlength: "The token must be at most 60 characters long"
                    }
                }
            });
        }
        drawMap("#locationMap");
    }
    Page.InitConnectPage = InitConnectPage;
    function InitResetPasswordPage() {
        var passwordForm = $("#passwordForm");
        if (passwordForm.length) {
            passwordForm.validate({
                rules: {
                    Password: {
                        required: true,
                        minlength: 6,
                        regex: /^\S*$/
                    },
                    PasswordConfirmation: {
                        required: true,
                        equalTo: "#Password"
                    }
                },
                messages: {
                    Password: {
                        required: "Please enter your new password",
                        minlength: "Your new password must be at least six characters long",
                        regex: "Your new password cannot contain any spaces"
                    },
                    PasswordConfirmation: {
                        required: "Please confirm your new password",
                        equalTo: "Your new passwords must match"
                    }
                }
            });
            initPasswordStrength();
        }
        var tokenForm = $("#tokenForm");
        if (tokenForm.length) {
            tokenForm.validate({
                rules: {
                    Token: {
                        required: true,
                        maxlength: 60
                    }
                },
                messages: {
                    Token: {
                        required: "Please input a token",
                        maxlength: "The token must be at most 60 characters long"
                    }
                }
            });
        }
        passwordForm.on("submit", function () {
            if (!passwordForm.valid()) {
                $("input", $("label.has-error:visible:first").parent()).focus();
            }
        });
    }
    Page.InitResetPasswordPage = InitResetPasswordPage;
    function InitChangePasswordPage() {
        var passwordForm = $("#passwordForm");
        if (passwordForm.length) {
            passwordForm.validate({
                rules: {
                    CurrentPassword: {
                        required: true,
                        minlength: 6,
                        regex: /^\S*$/
                    },
                    Password: {
                        required: true,
                        minlength: 6,
                        regex: /^\S*$/
                    },
                    PasswordConfirmation: {
                        required: true,
                        equalTo: "#Password"
                    }
                },
                messages: {
                    CurrentPassword: {
                        required: "Please enter your current password",
                        minlength: "",
                        regex: ""
                    },
                    Password: {
                        required: "Please enter your new password",
                        minlength: "Your new password must be at least six characters long",
                        regex: "Your new password cannot contain any spaces"
                    },
                    PasswordConfirmation: {
                        required: "Please confirm your new password",
                        equalTo: "Your new passwords must match"
                    }
                }
            });
            initPasswordStrength();
        }
    }
    Page.InitChangePasswordPage = InitChangePasswordPage;
    function InitHHSPage() {
        var mapName = arguments[0] || ".map";
        drawMap(mapName);
        $(".connect").on("click", function (e) {
            e.preventDefault();
            var regionId = $(this).data("regionid");
            var categoryId = $(this).data("categoryid");
            $(this).append("<img src='/_static/images/processing_small.gif' class='waiting_on_map' />");
            $.getJSON("/api/search/regional/" + regionId + "/" + categoryId, function (d) {
                loadMap(mapName, d.Results);
                $('.waiting_on_map').remove();
            });
        });
    }
    Page.InitHHSPage = InitHHSPage;
    function InitAffiliateGroupMapPage() {
        var mapName = arguments[0] || ".map";
        drawMap(mapName);
        $(".connect").on("click", function (e) {
            e.preventDefault();
            var regionId = $(this).data("regionid");
            var group = $(this).data("group");
            $(this).append("<img src='/_static/images/processing_small.gif' class='waiting_on_map' />");
            $.getJSON("/api/search/group/" + regionId + "/" + group, function (d) {
                loadMap(mapName, d.Results);
                $('.waiting_on_map').remove();
            });
        });
    }
    Page.InitAffiliateGroupMapPage = InitAffiliateGroupMapPage;
    function InitCommunityActivityPage() {
        Common.SetupShareModal($('#ShareModal-ShareQRCode'));
        $('.activity-form').submit(function (e) {
            e.preventDefault(); // Prevent default form submission
            var formData = $(this).serialize(); // Serialize form data
            $.ajax({
                type: "POST",
                url: $(this).attr('action'),
                data: formData,
                success: function (response) {
                    if (response.Success) {
                        $.notify({
                            title: '<strong>Success!</strong>',
                            message: 'Activity saved.'
                        }, {
                            type: 'success',
                            placement: {
                                from: "top",
                                align: "right"
                            },
                            delay: 2000,
                            timer: 500,
                        });
                    }
                    else {
                        $.notify({
                            title: '<strong>Error!</strong>',
                            message: 'Failed to save activity ' + response.Message
                        }, {
                            type: 'danger',
                            placement: {
                                from: "top",
                                align: "right"
                            },
                            delay: 2000,
                            timer: 500,
                        });
                    }
                },
                error: function () {
                    $.notify({
                        title: '<strong>Error!</strong>',
                        message: 'Failed to save activity. An error occurred.'
                    }, {
                        type: 'danger',
                        placement: {
                            from: "top",
                            align: "right"
                        },
                        delay: 2000,
                        timer: 500,
                    });
                },
                complete: function () {
                }
            });
        });
        $('#copyButton').click(function () {
            var urlToCopy = $(this).data('url');
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(urlToCopy).select();
            document.execCommand("copy");
            $temp.remove();
            $.notify({
                title: '<strong>QR Code Link Coppied!</strong>',
                message: ''
            }, {
                type: 'success',
                placement: {
                    from: "top",
                    align: "right"
                },
                timer: 500,
            });
        });
        toggleSendEmailButton();
        // Event listener for checkbox state change
        $('.email-checkbox').change(function () {
            toggleSendEmailButton();
        });
        // Function to enable/disable Send Email button
        function toggleSendEmailButton() {
            var anyChecked = $('.email-checkbox:checked').length > 0; // Check if any checkboxes are checked
            $('#sendEmailButton').prop('disabled', !anyChecked); // Enable/disable button based on anyChecked
        }
        $('#shareQRCode').click(function () {
            console.log("show modal");
            $('#ShareModal-ShareQRCode').modal('show');
        });
        if ($('.message-type').length && $('.message-text').length) {
            var messageType = $('.message-type').text();
            var messageText = $('.message-text').text();
            if (messageType === "Success") {
                $.notify({
                    title: '<strong>Success!</strong>',
                    message: messageText
                }, {
                    type: 'success',
                    placement: {
                        from: "top",
                        align: "right"
                    },
                    delay: 2000,
                    timer: 500,
                });
            }
            else if (messageType === "Error") {
                $.notify({
                    title: '<strong>Error!</strong>',
                    message: messageText
                }, {
                    type: 'danger',
                    placement: {
                        from: "top",
                        align: "right"
                    },
                    delay: 2000,
                    timer: 500,
                });
            }
        }
    }
    Page.InitCommunityActivityPage = InitCommunityActivityPage;
    function InitMyNetworkListPage() {
        $('#addUserButton').click(function () {
            var activityContainer = $(this).closest('.activity-container');
            var profileId = activityContainer.data('profile-id'); // Assume data-profile-id is set on the container
            var activityId = activityContainer.data('activity-id'); // Assume data-activity-id is set on the container
            $('#addUserModal').find('#profileId').val(profileId);
            $('#addUserModal').find('#activityId').val(activityId);
            $('#addUserModal').modal('show');
        });
        var timeout;
        $('#user-email').on('input', function () {
            clearTimeout(timeout);
            var email = $(this).val();
            if (email.includes('@')) {
                timeout = setTimeout(function () {
                    $.ajax({
                        url: '/Manage/MyNetworkList/FoundOrgByEmailDomain',
                        method: 'POST',
                        data: { email: email },
                        success: function (response) {
                            var _a, _b;
                            if (response.IsFoundOrg) {
                                if ((response === null || response === void 0 ? void 0 : response.Org) != null) {
                                    var orgName = (_b = (_a = response.Org.DisplayName) !== null && _a !== void 0 ? _a : response.Org.PreferredName) !== null && _b !== void 0 ? _b : "";
                                    $('#organisationName').val(orgName);
                                }
                            }
                        },
                        error: function () {
                            console.error('An error occurred while finding the org.');
                        }
                    });
                }, 1000);
            }
            else {
            }
        });
        var typingTimer; //timer identifier
        var doneTypingInterval = 1000; //time in ms (5 seconds)
        //on keyup, start the countdown
        $('#user-email').keyup(function () {
            clearTimeout(typingTimer);
            if ($('#user-email').val()) {
                typingTimer = setTimeout(checkIfExist, doneTypingInterval);
            }
        });
        //user is "finished typing," do something
        function checkIfExist() {
            jQuery.ajax({
                async: true,
                url: '/api/Users/IsEmailExist?email=' + $('#user-email').val(),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (resp) {
                    if (resp) {
                        $('.found_you_text').show();
                        $('.can-be-hide').hide();
                        $('.can-be-hide').find('input').val('');
                    }
                    else {
                        $('.can-be-hide').show();
                        $('.found_you_text').hide();
                    }
                },
                error: function (err) {
                    alert(err.responseText);
                }
            });
        }
        $('#addUserForm').submit(function (event) {
            event.preventDefault();
            var formData = $(this).serialize();
            $.ajax({
                type: 'POST',
                url: '/Manage/MyNetworkList/AddUserToList',
                data: formData,
                success: function (response) {
                    // Handle success response (e.g., close modal, show success message, update list)
                    $('#addUserModal').modal('hide');
                    if (response.Success) {
                        $.notify({
                            title: '<strong>Successfully added user!</strong>',
                            message: ''
                        }, {
                            type: 'success',
                            placement: {
                                from: "top",
                                align: "right"
                            },
                            timer: 500,
                        });
                        window.location.reload();
                    }
                    else {
                        $.notify({
                            title: '<strong>There was an error adding a user!</strong>',
                            message: response.Message
                        }, {
                            type: 'danger',
                            placement: {
                                from: "top",
                                align: "right"
                            },
                            delay: 2000,
                            timer: 500,
                        });
                    }
                },
                error: function (response) {
                    // Handle error response
                    $.notify({
                        title: '<strong>There was an error adding a user!</strong>',
                    }, {
                        type: 'danger',
                        placement: {
                            from: "top",
                            align: "right"
                        },
                        delay: 2000,
                        timer: 500,
                    });
                },
                complete: function () {
                }
            });
        });
        $('#addUserModal').on('hidden.bs.modal', function () {
            $('#addUserForm').find('input').val('');
            $('.can-be-hide').hide();
            $('.found_you_text').hide();
        });
    }
    Page.InitMyNetworkListPage = InitMyNetworkListPage;
    function InitEmailFoundOrg() {
        var timeout;
        $('#Email').on('input', function () {
            clearTimeout(timeout);
            var email = $(this).val();
            if (email.includes('@')) {
                timeout = setTimeout(function () {
                    $.ajax({
                        url: '/UserInfoCollection/FoundOrgByEmailDomain',
                        method: 'POST',
                        data: { email: email },
                        success: function (response) {
                            var _a, _b;
                            if (response.IsFoundOrg) {
                                if ((response === null || response === void 0 ? void 0 : response.Org) != null) {
                                    var orgName = (_b = (_a = response.Org.DisplayName) !== null && _a !== void 0 ? _a : response.Org.PreferredName) !== null && _b !== void 0 ? _b : "";
                                    $('#OrganisationName').val(orgName);
                                }
                            }
                        },
                        error: function () {
                            console.error('An error occurred while finding the org.');
                        }
                    });
                }, 1000);
            }
            else {
            }
        });
    }
    Page.InitEmailFoundOrg = InitEmailFoundOrg;
})(Page || (Page = {}));
